var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xD1\\xEB\\xEE\\xE9_20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1707 1538.5",
    style: {
      enableBackground: "new 0 0 1707 1538.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4;}\n\t.st1{opacity:0.8;fill:url(#triangle36_00000132806930323003293850000007400948005309067452_);enable-background:new    ;}\n\t.st2{opacity:0.9;fill:url(#triangle36_00000101105000510524343730000010398610551334019494_);enable-background:new    ;}\n\t.st3{opacity:0.7;fill:url(#triangle36_00000082330594704470218400000003799259243162175653_);enable-background:new    ;}\n\t.st4{opacity:0.5;fill:url(#triangle36_00000101064611012782675390000007443207390693344407_);enable-background:new    ;}\n\t.st5{opacity:0.7;fill:url(#triangle36_00000065771835489716474950000000843006250929444536_);enable-background:new    ;}\n\t.st6{opacity:0.8;fill:url(#triangle36_00000060719390907301096440000016418167346597847480_);enable-background:new    ;}\n\t.st7{opacity:0.5;fill:url(#triangle36_00000096744991666516069500000013181504126382814125_);enable-background:new    ;}\n\t.st8{opacity:0.5;fill:url(#triangle36_00000123427353416043716970000011610801447650402735_);enable-background:new    ;}\n\t.st9{opacity:0.8;fill:url(#triangle36_00000085964676525436989230000005518749190910301849_);enable-background:new    ;}\n\t.st10{opacity:0.5;fill:url(#triangle36_00000046335731419057838550000011172333872416086414_);enable-background:new    ;}\n\t.st11{opacity:0.5;fill:url(#triangle36_00000034780442255348640120000008863732575144139169_);enable-background:new    ;}\n\t.st12{opacity:0.5;fill:url(#triangle36_00000156587141627232562110000012712890978340062390_);enable-background:new    ;}\n\t.st13{opacity:0.5;fill:url(#triangle36_00000031913817779458057990000004673755586558113981_);enable-background:new    ;}\n\t.st14{opacity:0.5;fill:url(#triangle36_00000010997006948280326870000002881562692810185375_);enable-background:new    ;}\n\t.st15{opacity:0.5;fill:url(#triangle36_00000147182233490969627550000004898415850877988994_);enable-background:new    ;}\n\t.st16{opacity:0.5;fill:url(#triangle36_00000120531634742290542710000009995306405787759785_);enable-background:new    ;}\n\t.st17{opacity:0.5;fill:url(#triangle36_00000106846876227059869800000008838547167365646516_);enable-background:new    ;}\n\t.st18{opacity:0.5;fill:url(#triangle36_00000173851961178136367760000012336421665899112599_);enable-background:new    ;}\n\t.st19{opacity:0.8;fill:url(#triangle36_00000171687315439650683550000013109011316899805600_);enable-background:new    ;}\n\t.st20{opacity:0.8;fill:url(#triangle36_00000109715325097913916380000001776486935146422657_);enable-background:new    ;}\n\t.st21{opacity:0.8;fill:url(#triangle36_00000117671341134801762970000010314857726724477858_);enable-background:new    ;}\n\t.st22{opacity:0.9;fill:url(#triangle36_00000100358894715309780070000000759908220948379821_);enable-background:new    ;}\n\t.st23{opacity:0.9;fill:url(#triangle36_00000098195678075634701970000008513972790993483160_);enable-background:new    ;}\n\t.st24{opacity:0.5;fill:url(#triangle36_00000155830423438299401340000014667613042718431154_);enable-background:new    ;}\n\t.st25{opacity:0.5;fill:url(#triangle36_00000094612352427208261670000017178995796623854468_);enable-background:new    ;}\n\t.st26{opacity:0.5;fill:url(#triangle36_00000110430413222142637570000005178877335001704876_);enable-background:new    ;}\n\t.st27{opacity:0.5;fill:url(#triangle36_00000165222014148028183610000010304675649821089463_);enable-background:new    ;}\n\t.st28{opacity:0.5;fill:url(#triangle36_00000057853165272301828470000016680873540781929129_);enable-background:new    ;}\n\t.st29{opacity:0.5;fill:url(#triangle36_00000121248070745022834770000009322890967995056567_);enable-background:new    ;}\n\t.st30{opacity:0.8;fill:url(#triangle36_00000040556368714245687100000008253311731608854402_);enable-background:new    ;}\n\t.st31{opacity:0.5;fill:url(#triangle36_00000108282765021648959930000017207565349289894834_);enable-background:new    ;}\n\t.st32{opacity:0.5;fill:url(#triangle36_00000180326210023286716300000012441927774316825255_);enable-background:new    ;}\n\t.st33{opacity:0.5;fill:url(#triangle36_00000025411398736625105900000008409515509444352147_);enable-background:new    ;}\n\t.st34{opacity:0.7;fill:url(#triangle36_00000029741813987158002990000002627488945547631509_);enable-background:new    ;}\n\t.st35{opacity:0.5;fill:url(#triangle36_00000125564486915370674140000010984195493287676065_);enable-background:new    ;}\n\t.st36{opacity:0.5;fill:url(#triangle36_00000121997031776554494350000000100338846095456167_);enable-background:new    ;}\n\t.st37{opacity:0.5;fill:url(#triangle36_00000018209409981721443260000000472599433062005642_);enable-background:new    ;}\n\t.st38{opacity:0.5;fill:url(#triangle36_00000094579458464706242650000015719430142557084084_);enable-background:new    ;}\n\t.st39{opacity:0.5;fill:url(#triangle36_00000102503617903922892790000001109773858979836556_);enable-background:new    ;}\n\t.st40{opacity:0.5;fill:url(#triangle36_00000037652727680385661880000012767569117953820058_);enable-background:new    ;}\n\t.st41{opacity:0.5;fill:url(#triangle36_00000090978870527208777070000001320552191496902071_);enable-background:new    ;}\n\t.st42{opacity:0.5;fill:url(#triangle36_00000177483866700014093270000012016799875406440632_);enable-background:new    ;}\n\t.st43{opacity:0.5;fill:url(#triangle36_00000011022954487573051880000006418061269748198572_);enable-background:new    ;}\n\t.st44{opacity:0.5;fill:url(#triangle36_00000030472467860258347430000005919692673547252891_);enable-background:new    ;}\n\t.st45{opacity:0.8;fill:url(#triangle36_00000103236166594071914060000013676803032482217360_);enable-background:new    ;}\n\t.st46{opacity:0.8;fill:url(#triangle36_00000183954882434799974950000007904969386946176143_);enable-background:new    ;}\n\t.st47{opacity:0.8;fill:url(#triangle36_00000060714907129270737270000003776403700387769746_);enable-background:new    ;}\n\t.st48{opacity:0.5;fill:url(#triangle36_00000022521753385483531280000018407181373495401350_);enable-background:new    ;}\n\t.st49{opacity:0.7;fill:url(#triangle36_00000129925870809684149360000005564588537692021143_);enable-background:new    ;}\n\t.st50{opacity:0.7;fill:url(#triangle36_00000166670542314364013910000000603838652295863225_);enable-background:new    ;}\n\t.st51{opacity:0.5;fill:url(#triangle36_00000033355871144749710210000001678538695212469391_);enable-background:new    ;}\n\t.st52{opacity:0.5;fill:url(#triangle36_00000137100663022340050070000017576642751395616920_);enable-background:new    ;}\n\t.st53{opacity:0.5;fill:url(#triangle36_00000072985433864020687770000012391511549326332063_);enable-background:new    ;}\n\t.st54{opacity:0.5;fill:url(#triangle36_00000057133456875690192630000002314324136111122615_);enable-background:new    ;}\n\t.st55{opacity:0.5;fill:url(#triangle36_00000000943291247950370360000003510914605901157048_);enable-background:new    ;}\n\t.st56{opacity:0.5;fill:url(#triangle36_00000110463533230368448120000002746333166889959555_);enable-background:new    ;}\n\t.st57{opacity:0.5;fill:url(#triangle36_00000151545399917356481420000010736053776287675820_);enable-background:new    ;}\n\t.st58{opacity:0.9;fill:url(#triangle36_00000013915179408272406080000018423267738864236193_);enable-background:new    ;}\n\t.st59{opacity:0.5;fill:url(#triangle36_00000040549335110308613930000006496671685454526592_);enable-background:new    ;}\n\t.st60{opacity:0.5;fill:url(#triangle36_00000111881407017883578880000012359798791961724293_);enable-background:new    ;}\n\t.st61{opacity:0.9;fill:url(#triangle36_00000112621786756210099650000000472954147113459894_);enable-background:new    ;}\n\t.st62{opacity:0.5;fill:url(#triangle36_00000026872090842476957500000008706767860533268370_);enable-background:new    ;}\n\t.st63{opacity:0.5;fill:url(#triangle36_00000039834502756090590450000005182207682330555303_);enable-background:new    ;}\n\t.st64{opacity:0.9;fill:url(#triangle36_00000122694626289870200580000012686567193406274710_);enable-background:new    ;}\n\t.st65{opacity:0.5;fill:url(#triangle36_00000126312219613695077030000009914929059864781744_);enable-background:new    ;}\n\t.st66{opacity:0.8;fill:url(#triangle36_00000042711361341221446660000002147085027341959819_);enable-background:new    ;}\n\t.st67{opacity:0.5;fill:url(#triangle36_00000179638725866112615530000014474456764085768355_);enable-background:new    ;}\n\t.st68{opacity:0.5;fill:url(#triangle36_00000124122566908486664660000010864359350828855729_);enable-background:new    ;}\n\t.st69{opacity:0.5;fill:url(#triangle36_00000165945827218521764630000011218283624844500661_);enable-background:new    ;}\n\t.st70{opacity:0.9;fill:url(#triangle36_00000007400606547812384970000001507473360974246335_);enable-background:new    ;}\n\t.st71{opacity:0.5;fill:url(#triangle36_00000165944550074322880670000007302580970073066164_);enable-background:new    ;}\n\t.st72{opacity:0.5;fill:url(#triangle36_00000053528162732533459340000014372722509694301856_);enable-background:new    ;}\n\t.st73{opacity:0.5;fill:url(#triangle36_00000039837689437188732610000017770474025502578866_);enable-background:new    ;}\n\t.st74{opacity:0.5;fill:url(#triangle36_00000018950649270397491170000007390413878486265488_);enable-background:new    ;}\n\t.st75{opacity:0.5;fill:url(#triangle36_00000165200010023357683760000001242721459048079767_);enable-background:new    ;}\n\t.st76{opacity:0.5;fill:url(#triangle36_00000117647113591824042460000011089665256411796104_);enable-background:new    ;}\n\t.st77{opacity:0.9;fill:url(#triangle36_00000003788731073943879710000016556033142031571627_);enable-background:new    ;}\n\t.st78{opacity:0.9;fill:url(#triangle36_00000101790330554853212090000017883784846548000672_);enable-background:new    ;}\n\t.st79{opacity:0.5;fill:url(#triangle36_00000173842105683794555420000002132042425309869188_);enable-background:new    ;}\n\t.st80{opacity:0.5;fill:url(#triangle36_00000073682112112602986180000002808646484647432593_);enable-background:new    ;}\n\t.st81{opacity:0.5;fill:url(#triangle36_00000040546754394631204860000013510240918414123144_);enable-background:new    ;}\n\t.st82{opacity:0.5;fill:url(#triangle36_00000178913502848998170430000007701415582309992381_);enable-background:new    ;}\n\t.st83{opacity:0.5;fill:url(#triangle36_00000049211510898771354980000010282750857182490266_);enable-background:new    ;}\n\t.st84{opacity:0.5;fill:url(#triangle36_00000083053751526708725850000002226875291452645293_);enable-background:new    ;}\n\t.st85{opacity:0.5;fill:url(#triangle36_00000129204639847295702100000013404747507522717599_);enable-background:new    ;}\n\t.st86{opacity:0.5;fill:url(#triangle36_00000175292447470157736370000012621760415960458409_);enable-background:new    ;}\n\t.st87{opacity:0.5;fill:url(#triangle36_00000013914541968624519780000006352679416371712150_);enable-background:new    ;}\n\t.st88{opacity:0.5;fill:url(#triangle36_00000179622769026051708420000017041021672844992959_);enable-background:new    ;}\n\t.st89{opacity:0.5;fill:url(#triangle36_00000102502346767262469750000009353348127349187734_);enable-background:new    ;}\n\t.st90{opacity:0.5;fill:url(#triangle36_00000011712435279200992570000007269001778638407589_);enable-background:new    ;}\n\t.st91{opacity:0.7;fill:url(#triangle36_00000010311196447034461930000008918359698532291998_);enable-background:new    ;}\n\t.st92{opacity:0.5;fill:url(#triangle36_00000069357774343383313300000006582998738389927065_);enable-background:new    ;}\n\t.st93{opacity:0.5;fill:url(#triangle36_00000140734928478771630000000013119557644632197280_);enable-background:new    ;}\n\t.st94{opacity:0.8;fill:url(#triangle36_00000169542610610153103250000000993442852930086069_);enable-background:new    ;}\n\t.st95{opacity:0.5;fill:url(#triangle36_00000018926913420240486660000010951171858632326048_);enable-background:new    ;}\n\t.st96{opacity:0.5;fill:url(#triangle36_00000167361270621747803140000003352312327854475964_);enable-background:new    ;}\n\t.st97{opacity:0.5;fill:url(#triangle36_00000096046091484302331750000005041745076132281525_);enable-background:new    ;}\n\t.st98{opacity:0.5;fill:url(#triangle36_00000042721052077868794920000005443490643933820064_);enable-background:new    ;}\n\t.st99{opacity:0.5;fill:url(#triangle36_00000157301762374658904820000015009534629043318951_);enable-background:new    ;}\n\t.st100{opacity:0.7;fill:url(#triangle36_00000083793734494299196280000003327918073405852805_);enable-background:new    ;}\n\t.st101{opacity:0.7;fill:url(#triangle36_00000167388798752500209790000016298604126398965407_);enable-background:new    ;}\n\t.st102{opacity:0.5;fill:url(#triangle36_00000039114130569848570070000000617882439309746105_);enable-background:new    ;}\n\t.st103{opacity:0.5;fill:url(#triangle36_00000014635027184885428940000002617786417214830752_);enable-background:new    ;}\n\t.st104{opacity:0.5;fill:url(#triangle36_00000027605898717823271070000009921611549430696326_);enable-background:new    ;}\n\t.st105{opacity:0.5;fill:url(#triangle36_00000033336929762925183780000001698660813305017274_);enable-background:new    ;}\n\t.st106{opacity:0.5;fill:url(#triangle36_00000175305191207050911960000011935920621926768783_);enable-background:new    ;}\n\t.st107{opacity:0.5;fill:url(#triangle36_00000067233202435266291780000006975494467630506148_);enable-background:new    ;}\n\t.st108{opacity:0.5;fill:url(#triangle36_00000072249516614043999640000002296222157100987570_);enable-background:new    ;}\n\t.st109{opacity:0.5;fill:url(#triangle36_00000113337144843762379440000009086885411075008959_);enable-background:new    ;}\n\t.st110{opacity:0.5;fill:url(#triangle36_00000047755966912245363460000000615391708657972892_);enable-background:new    ;}\n\t.st111{opacity:0.5;fill:url(#triangle36_00000078764458462341054010000002189177640853797763_);enable-background:new    ;}\n\t.st112{opacity:0.5;fill:url(#triangle36_00000109028334756363064860000017880359719687203201_);enable-background:new    ;}\n\t.st113{opacity:0.8;fill:url(#triangle36_00000101788312810600963370000004069493112061759111_);enable-background:new    ;}\n\t.st114{opacity:0.5;fill:url(#triangle36_00000160899595999301520150000008484553500552098208_);enable-background:new    ;}\n\t.st115{opacity:0.7;fill:url(#triangle36_00000070800917078696889150000013001790606990550671_);enable-background:new    ;}\n\t.st116{opacity:0.8;fill:url(#triangle36_00000065068312549618299210000012117294212202348424_);enable-background:new    ;}\n\t.st117{opacity:0.8;fill:url(#triangle36_00000014625378280752507350000003736661996394039974_);enable-background:new    ;}\n\t.st118{opacity:0.5;fill:url(#triangle36_00000014616813190143973690000013205313551716825239_);enable-background:new    ;}\n\t.st119{opacity:0.5;fill:url(#triangle36_00000143594717170184880550000000495246518555358352_);enable-background:new    ;}\n\t.st120{opacity:0.9;fill:url(#triangle36_00000031904640748527115380000003062886319976421261_);enable-background:new    ;}\n\t.st121{opacity:0.5;fill:url(#triangle36_00000083057746239589972450000002455488167858040724_);enable-background:new    ;}\n\t.st122{opacity:0.8;fill:url(#triangle36_00000051380276025692007700000003741915756995726758_);enable-background:new    ;}\n\t.st123{opacity:0.5;fill:url(#triangle36_00000131332783650568087570000017280887067868743613_);enable-background:new    ;}\n\t.st124{opacity:0.8;fill:url(#triangle36_00000131328786439408363420000016249087132167356333_);enable-background:new    ;}\n\t.st125{opacity:0.8;fill:url(#triangle36_00000059279244197908556250000016381331804573800895_);enable-background:new    ;}\n\t.st126{opacity:0.8;fill:url(#triangle36_00000134960214911506711290000000306591084475544762_);enable-background:new    ;}\n\t.st127{opacity:0.5;fill:url(#triangle36_00000091709230159881404360000014966386627861482384_);enable-background:new    ;}\n\t.st128{opacity:0.5;fill:url(#triangle36_00000145039506559637033940000005507721402783842239_);enable-background:new    ;}\n\t.st129{opacity:0.8;fill:url(#triangle36_00000080193357356202785550000015263812463890766214_);enable-background:new    ;}\n\t.st130{opacity:0.5;fill:url(#triangle36_00000157285446481998927810000003624773305012225964_);enable-background:new    ;}\n\t.st131{opacity:0.8;fill:url(#triangle36_00000116934369947634190870000003779990062107860670_);enable-background:new    ;}\n\t.st132{opacity:0.5;fill:url(#triangle36_00000039815933559467711570000007421767072277395363_);enable-background:new    ;}\n\t.st133{opacity:0.5;fill:url(#triangle36_00000039119383969524127760000008977548642267827383_);enable-background:new    ;}\n\t.st134{opacity:0.5;fill:url(#triangle36_00000176014300282435576560000018443209838486634665_);enable-background:new    ;}\n\t.st135{opacity:0.5;fill:url(#triangle36_00000036232778103550159920000005267815329114547620_);enable-background:new    ;}\n\t.st136{opacity:0.5;fill:url(#triangle36_00000103956756956353112210000010699608613006883255_);enable-background:new    ;}\n\t.st137{opacity:0.5;fill:url(#triangle36_00000132065981851475595630000009253997698341376445_);enable-background:new    ;}\n\t.st138{opacity:0.5;fill:url(#triangle36_00000106835724912970166900000007830011825346227637_);enable-background:new    ;}\n\t.st139{opacity:0.5;fill:url(#triangle36_00000144328912980936968210000012119993426343602316_);enable-background:new    ;}\n\t.st140{opacity:0.5;fill:url(#triangle36_00000036971253683747006910000010271076067724015753_);enable-background:new    ;}\n\t.st141{opacity:0.8;fill:url(#triangle36_00000008855065934172304660000001026584548773815958_);enable-background:new    ;}\n\t.st142{opacity:0.8;fill:url(#triangle36_00000059993321207692106040000011498677191765600128_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1699.3,858.1l-54.6-476.4c1.2-0.4,2-1.5,2-2.8c0-1.6-1.3-3-3-3c-0.6,0-1.2,0.2-1.7,0.5l-177.8-170c0.3-0.5,0.4-1,0.4-1.5 c0-1.6-1.3-3-3-3c-0.2,0-0.3,0-0.4,0l-15.4-40.5c0.8-0.5,1.4-1.4,1.4-2.5c0-1.6-1.3-3-3-3c-1.1,0-2.1,0.6-2.6,1.6l-317-89.3 c0-0.1,0-0.1,0-0.2c0-1.6-1.3-3-3-3c-1.2,0-2.2,0.7-2.7,1.7l-147-31.8l0,0c0-1.6-1.3-3-3-3c-1.2,0-2.2,0.7-2.6,1.6L871.4,9.6V9.5 c0-1.6-1.3-3-3-3c-1.6,0-3,1.3-3,3v0.1L298.7,154.7c-0.5-1-1.5-1.6-2.6-1.6c-1.6,0-3,1.3-3,3c0,0.7,0.3,1.3,0.7,1.8L8,507.7 c-0.4-0.2-0.9-0.3-1.3-0.3c-1.6,0-3,1.3-3,3c0,1.4,1,2.6,2.3,2.9l-3.6,146C1,659.5,0,660.6,0,662.1c0,1.6,1.3,3,3,3 c0.4,0,0.7-0.1,1.1-0.2l52.6,79c-0.5,0.5-0.8,1.3-0.8,2.1c0,1.6,1.3,3,3,3c0.9,0,1.8-0.5,2.3-1.1l110,53.8 c-0.1,0.2-0.1,0.5-0.1,0.7c0,1.6,1.3,3,3,3c1.4,0,2.6-1,2.9-2.4l60.5-0.5c0.2,0.8,0.7,1.5,1.3,1.9L202.2,907c-0.1,0-0.2,0-0.4,0 c-1.6,0-3,1.3-3,3c0,1.6,1.3,3,3,3c0.1,0,0.3,0,0.4,0l15.5,43.4c-0.8,0.5-1.4,1.4-1.4,2.5c0,1.6,1.3,3,3,3c0.2,0,0.4,0,0.6-0.1 l18.7,43.6c-0.8,0.5-1.3,1.4-1.3,2.4c0,1.6,1.3,3,3,3c1,0,1.9-0.5,2.4-1.3l183.1,74.6c0,0.2-0.1,0.3-0.1,0.5c0,1.6,1.3,3,3,3 c1.6,0,3-1.3,3-3c0-0.1,0-0.3,0-0.4l190-67.9c0.5,0.8,1.4,1.4,2.5,1.4c0.8,0,1.5-0.3,2-0.8l65.6,47.1c-0.2,0.4-0.2,0.8-0.2,1.2 c0,1.4,1,2.6,2.3,2.9l-0.5,132.8c-1.3,0.3-2.4,1.5-2.4,2.9c0,1.6,1.3,3,3,3c0.8,0,1.6-0.3,2.1-0.9l26.6,17.1 c-0.1,0.3-0.2,0.7-0.2,1c0,1.6,1.3,3,3,3c1,0,1.8-0.5,2.3-1.2l162.2,77c-0.1,0.2-0.1,0.4-0.1,0.7c0,1.6,1.3,3,3,3c1.6,0,3-1.3,3-3 c0-0.3-0.1-0.6-0.1-0.8l19.5-10.4c0.5,0.6,1.3,1.1,2.2,1.1h0.1l16,60.7c-1,0.5-1.6,1.5-1.6,2.6c0,1.6,1.3,2.9,2.9,2.9l5.9,32.7 c-1.1,0.4-1.8,1.5-1.8,2.7c0,1.3,0.9,2.4,2.1,2.8l-11.7,134.8c-1.5,0.2-2.6,1.4-2.6,2.9c0,1.6,1.3,3,3,3c1.6,0,3-1.3,3-3 c0-0.4-0.1-0.8-0.2-1.1l126.1-85c0.5,0.5,1.3,0.8,2,0.8c1.6,0,3-1.3,3-3c0-0.9-0.4-1.6-1-2.2l18.5-30c0.3,0.1,0.6,0.2,1,0.2 c1.6,0,3-1.3,3-3c0-1.6-1.3-3-3-3c-0.1,0-0.2,0-0.3,0l-23.2-71.2c0.9-0.5,1.5-1.5,1.5-2.5c0-1.6-1.2-2.8-2.7-2.9l-6.2-46.6 c1-0.3,1.7-1.2,1.9-2.2h116.4c0.3,1.3,1.5,2.3,2.9,2.3c1.5,0,2.8-1.1,2.9-2.6l105.9-9.9c0.4,1.2,1.5,2.1,2.8,2.1c1.6,0,3-1.3,3-3 c0-0.3-0.1-0.7-0.2-1l85.3-52.3c0.5,0.6,1.3,0.9,2.1,0.9c1.6,0,3-1.3,3-3c0-1.1-0.7-2.1-1.6-2.6l35.7-134h0.1c1.6,0,3-1.3,3-3 s-1.3-3-3-3c-0.6,0-1.1,0.2-1.5,0.4l-29.2-31.2c0.2-0.3,0.3-0.6,0.4-0.9l88.5,6.6c0.2,1.4,1.4,2.6,2.9,2.6c1.4,0,2.6-1,2.9-2.3 h53.5c0.3,1.3,1.5,2.3,2.9,2.3c1.6,0,3-1.3,3-3c0-0.7-0.2-1.3-0.6-1.7L1698,863.4c0.4,0.2,0.9,0.4,1.5,0.4c1.6,0,3-1.3,3-3 C1702,859.5,1700.8,858.2,1699.3,858.1z M1057.5,1448.1c0,0.1,0.1,0.2,0.1,0.3l-102,68.7l-14.7,9.9l72.2-58.4l23.9-19.3 L1057.5,1448.1z M1079.2,1413.7l-42.7,34.5l-58.4,3.6l43-75c0.3,0.1,0.6,0.2,0.9,0.2c0.8,0,1.6-0.3,2.1-0.9l55,35.2 c-0.1,0.3-0.2,0.7-0.2,1C1078.9,1412.8,1079,1413.3,1079.2,1413.7z M627.1,1014l99.3-43c0.5,0.6,1.2,1.1,2,1.2l3,39.6 c-1,0.3-1.8,1.1-2.1,2.2H627.1z M241.6,1005l22.9-81.7c0.1,0,0.1,0,0.2,0c0.6,0,1.1-0.2,1.6-0.5l62.5,64.8l27.7,28.7 c-0.2,0.2-0.3,0.5-0.4,0.8l-112.9-10C243,1006.3,242.5,1005.4,241.6,1005z M310.7,153.7L505,113.5l-67.5,24.9l-34.6,4.2 L310.7,153.7z M1529.7,1047.1l-23.6-20.6c0.2-0.4,0.4-0.9,0.4-1.4c0-1.1-0.6-2-1.5-2.5l32.5-97.6l-3.7,68.2l-2.9,53.5 C1530.6,1046.6,1530.1,1046.8,1529.7,1047.1z M1472.2,1046.5c-0.8,0-1.5,0.3-2.1,0.8l-68-45.4l98.6,23c0,0,0,0,0,0.1 c0,0.5,0.1,0.9,0.3,1.3l-25.4,19.7l-1.5,1.2C1473.6,1046.8,1472.9,1046.5,1472.2,1046.5z M1230.8,1164c-0.2-0.8-0.7-1.5-1.4-1.9 l26.1-78.3c0.1,0,0.2,0,0.3,0c0.5,0,1.1-0.2,1.5-0.4l72.9,79.5c-0.2,0.3-0.4,0.7-0.5,1.1L1230.8,1164L1230.8,1164z M948.6,1457.3 C948.7,1457.3,948.7,1457.3,948.6,1457.3c1.5,0,2.8-1.1,3-2.5l3.8-0.2l-21.9,66.9l11.9-50.3L948.6,1457.3z M264.7,917.4l-23.3-113 c1-0.4,1.7-1.4,1.8-2.6l78.1-13c0.2,0.5,0.6,1,1,1.3l-6.1,13.6l-50.9,113.7C265.1,917.4,264.9,917.4,264.7,917.4z M4.4,659.5 l29.7-99.2c0.1,0,0.2,0,0.2,0c0.5,0,0.9-0.1,1.3-0.3l97.7,128c-0.2,0.2-0.3,0.5-0.5,0.7l-0.8-0.2L5.9,662.1 C5.9,661,5.3,660,4.4,659.5z M224.3,272.1l69.2-110.7l-38.9,106.9c-0.1,0-0.3,0-0.4,0c-1.5,0-2.7,1.1-2.9,2.6l-26.2,2.4 C224.9,272.8,224.7,272.4,224.3,272.1z M295.7,159c0.1,0,0.3,0,0.4,0s0.2,0,0.3,0l4.7,15l3.5,11c-0.9,0.5-1.5,1.5-1.5,2.6 c0,0.8,0.4,1.6,0.9,2.1l-47.1,76.2l2-5.6L295.7,159z M266.4,918l32.5-72.6l24.5-54.8c0.2,0,0.4,0.1,0.6,0.1c0.1,0,0.3,0,0.4,0 l33,92.3c-0.8,0.5-1.4,1.4-1.4,2.5c0,0.1,0,0.3,0,0.4l-88.8,32.9C267,918.5,266.7,918.2,266.4,918z M225.2,274.5l26.2-2.4 c0.2,0.7,0.7,1.3,1.3,1.6l-11.9,33.7l-16.6-31C224.7,276,225.1,275.3,225.2,274.5z M868.4,12.4c0.7,0,1.3-0.2,1.8-0.6l48,42.4 c-0.2,0.4-0.4,0.9-0.4,1.4c0,0.4,0.1,0.8,0.2,1.1L847.7,106l-8.7,6c-0.2-0.2-0.4-0.3-0.6-0.4l29.8-99.2 C868.3,12.4,868.3,12.4,868.4,12.4z M1396,999.9l-74.5-3.2c-0.1-0.6-0.3-1.1-0.7-1.5l83.8-114c0.1,0.1,0.3,0.1,0.4,0.1l-5.4,94.1 l-1.3,22.3C1397.3,997.9,1396.3,998.7,1396,999.9z M1193,1231.5c-0.8,0-1.5,0.3-2,0.8l-89.5-63c0.1-0.2,0.1-0.4,0.2-0.6l123.4-3.3 c0.2,0.6,0.5,1.2,1,1.6l-32.3,64.6C1193.5,1231.5,1193.2,1231.5,1193,1231.5z M1096,1169.1l-75.3,45.9c-0.5-0.6-1.3-0.9-2.1-0.9 c-0.2,0-0.4,0-0.6,0.1l-29.1-68c0.4-0.3,0.8-0.7,1-1.2l48.4,10.6l57.6,12.6l0,0C1095.8,1168.5,1095.9,1168.8,1096,1169.1z  M919.1,1287.9l67.3-141.4c0.2,0.1,0.4,0.1,0.7,0.1c0.2,0,0.4,0,0.6-0.1l29.1,68c-0.8,0.5-1.3,1.4-1.3,2.4c0,0.4,0.1,0.8,0.3,1.2 l-96.5,69.9C919.2,1288,919.1,1288,919.1,1287.9z M515,113.3l20.6,13.2l-21.6,2.6l-0.4-15C514.2,114,514.6,113.7,515,113.3z  M1661.7,803.5C1661.7,803.5,1661.6,803.6,1661.7,803.5l-77.8-29.1l-56.5-21.2c0-0.1,0-0.3,0-0.4c0-0.6-0.2-1.1-0.5-1.6l41.3-41.3 c0.5,0.3,1,0.5,1.6,0.5s1.1-0.2,1.6-0.5l49.9,51.8L1661.7,803.5z M1545.5,844.1C1545.5,844.1,1545.4,844.1,1545.5,844.1l-9.3-41.9 l-10.4-46.7c0.5-0.2,1-0.6,1.3-1.1l24.6,9.2l109.6,41.1c0,0.1,0,0.3,0,0.4c0,0.1,0,0.3,0,0.4l-113.2,40 C1547.5,844.7,1546.5,844.1,1545.5,844.1z M1401.1,998.6c-0.4-0.4-0.9-0.7-1.4-0.9l6.7-116.4c0.9-0.1,1.7-0.7,2.1-1.5l47,14.8 l80.1,25.3c0,0.1,0,0.2,0,0.3c0,0.3,0.1,0.6,0.2,0.9l-62.7,36.1L1401.1,998.6z M1316,995.8l-131.7-32.9l-16.3-4.1v-0.1 c0-0.2,0-0.3-0.1-0.5l116.8-46.7c0.5,0.8,1.4,1.3,2.5,1.3c0.1,0,0.3,0,0.4,0l29.5,81.8C1316.6,994.9,1316.2,995.3,1316,995.8z  M1098.8,1165.2c-1.2,0-2.2,0.7-2.7,1.7l-106-23.2l0,0c0-0.2,0-0.4-0.1-0.6l127.3-57c0.3,0.4,0.7,0.7,1.1,0.9l-19.5,78.2 C1098.8,1165.2,1098.8,1165.2,1098.8,1165.2z M546.9,980.3L502.1,867l-12.4-31.4c0.6-0.4,1.1-1.1,1.3-1.8h64 c0.2,1.1,1,1.9,2.1,2.2L546.9,980.3L546.9,980.3z M215.2,664.9L321.7,615c0,0.1,0.1,0.1,0.1,0.2L252,708.3 c-0.4-0.2-0.8-0.3-1.2-0.3c-0.5,0-1,0.1-1.4,0.4l-34.7-41c0.4-0.5,0.6-1.1,0.6-1.8C215.3,665.4,215.3,665.1,215.2,664.9z  M135.5,687.1c-0.5,0-0.9,0.1-1.3,0.3l-97.7-128c0.4-0.4,0.6-0.9,0.7-1.5l144.3-10.1c0.2,0.7,0.7,1.3,1.3,1.7l-5.6,16.3 l-41.4,121.3C135.8,687.1,135.7,687.1,135.5,687.1z M776.2,216.7l59.9-99.8c0.3,0.1,0.6,0.2,0.9,0.2l12.9,67.6 c-1.1,0.4-1.8,1.5-1.8,2.7c0,0.2,0,0.4,0.1,0.5l-71.4,29.2C776.5,217,776.4,216.9,776.2,216.7z M1184.5,134.1 c1.1,0,2.1-0.6,2.6-1.6l94.2,26.9c0,0.1,0,0.1,0,0.2c0,0.3,0.1,0.6,0.1,0.8l-222,121.8l123.7-148.5 C1183.6,133.9,1184,134.1,1184.5,134.1z M1283.8,162.5l13,189.7c-1.2,0.4-2.1,1.5-2.1,2.8c0,0.1,0,0.2,0,0.3l-80.6,25.4 l-46.6,14.7c-0.2-0.3-0.4-0.6-0.7-0.8l116.6-232.2C1283.6,162.4,1283.7,162.4,1283.8,162.5z M1596.6,591.5l-26.6,113 c0,0,0,0-0.1,0c-1,0-1.8,0.5-2.4,1.2l-116.9-53.4c0-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.5l144.7-60.6 C1595.7,590.9,1596.1,591.3,1596.6,591.5z M1294.8,1038.3L1168,1035c-0.2-1.2-1.1-2.1-2.3-2.3v-71c0.6-0.1,1.1-0.4,1.5-0.9 l127.7,77.3C1294.9,1038.1,1294.8,1038.2,1294.8,1038.3z M1295.2,1040.6l-37.8,37.8c-0.5-0.3-1-0.5-1.6-0.5 c-0.9,0-1.8,0.4-2.3,1.1l-85.6-42.8l0,0l126.8,3.3C1294.9,1039.9,1295,1040.3,1295.2,1040.6z M600.8,852.3l-40.1-18.5 c0-0.2,0.1-0.4,0.1-0.7c0-0.9-0.4-1.7-1-2.2l46.1-85.7h0.1l-3.3,105.9C601.9,851.3,601.3,851.7,600.8,852.3z M490.9,832.5 c-0.1-0.4-0.2-0.7-0.4-1l41.3-41.3c0.5,0.3,1,0.5,1.6,0.5c0.3,0,0.6-0.1,0.8-0.1l21.7,40.3c-0.5,0.4-0.8,1-1,1.6H490.9z  M326.6,789.1L436.2,819c0,0.1,0,0.1,0,0.2c0,0.5,0.1,0.9,0.3,1.4l-75.8,62.6c-0.5-0.4-1.1-0.6-1.8-0.6c-0.1,0-0.3,0-0.4,0 l-33-92.3C326,790,326.4,789.6,326.6,789.1z M212.3,662.6L212.3,662.6l-25-105.9l-1.7-7.1c0.4-0.2,0.8-0.5,1.1-0.9l134.4,63.8 c-0.1,0.2-0.1,0.4-0.1,0.7c0,0.2,0,0.5,0.1,0.7l-106.5,49.9C214.1,663.1,213.3,662.6,212.3,662.6z M173.7,504.4L356,532.6 c0.1,0.9,0.5,1.7,1.2,2.2l-32.6,75.5c-0.2,0-0.4-0.1-0.6-0.1c-0.8,0-1.5,0.3-2,0.8L173.7,504.5 C173.7,504.4,173.7,504.4,173.7,504.4z M405.9,200.8c1.3-0.2,2.3-1.3,2.4-2.6l104-9.9c0.2,0.5,0.5,1,0.9,1.3L399.9,391.1 c-0.1,0-0.1,0-0.2,0L405.9,200.8z M700.5,110.1l4.9,56.2c-1.2,0.4-2.1,1.5-2.1,2.8c0,0.5,0.2,1,0.4,1.5l-104,94.4l100-155 C700.1,110,700.3,110.1,700.5,110.1z M252.9,709l69.8-93.1c0.4,0.2,0.8,0.3,1.2,0.3c0.3,0,0.6-0.1,0.9-0.2l32,54.4 c-0.6,0.5-1,1.3-1,2.2c0,0.1,0,0.3,0,0.4L253,709.5C253.1,709.3,253,709.1,252.9,709z M265.4,406.3l160.7,87.4 c-0.1,0.3-0.1,0.5-0.1,0.8s0.1,0.6,0.1,0.8l-65,35.2c-0.5-0.6-1.3-1-2.2-1c-0.4,0-0.9,0.1-1.2,0.3L265.4,406.3L265.4,406.3z  M586.5,161.8c0.2,0.1,0.4,0.1,0.6,0.1l8.8,103.9c-1.2,0.4-2.1,1.5-2.1,2.8c0,0.2,0,0.4,0.1,0.6l-96.4,42.2 c-0.1-0.2-0.2-0.3-0.4-0.4l72.8-121.3L586.5,161.8z M976.6,117.1c0.2,0,0.3,0,0.5,0l28.6,71.9l21.5,54.1l-86-94.1 c0.3-0.5,0.6-1.1,0.6-1.7c0-0.5-0.1-1-0.4-1.4l33.5-29.3C975.3,116.9,975.9,117.1,976.6,117.1z M1573.4,508c0.2,0,0.4,0,0.6-0.1 l18.7,43.5c-0.3,0.2-0.5,0.5-0.7,0.7l-130-53.3l108.6,6.6C1570.7,506.9,1571.9,508,1573.4,508z M1567.4,709.1l-41.3,41.3 c-0.5-0.3-1-0.5-1.6-0.5c-0.8,0-1.6,0.4-2.1,0.9l-44.7-27.3l-13.2-8.1c0.1-0.2,0.1-0.4,0.1-0.5l102.4-6.6 C1567.1,708.6,1567.3,708.8,1567.4,709.1z M1164.4,961.6v71c-1.1,0.2-1.9,1-2.2,2.1l-105.9-6.6c0-0.2-0.1-0.4-0.1-0.6l106.8-66.7 C1163.3,961.2,1163.9,961.5,1164.4,961.6z M700.4,871.4c0-0.6-0.2-1.2-0.5-1.6l38-41.1c0.4,0.3,0.9,0.4,1.5,0.4 c0.3,0,0.6-0.1,0.9-0.2l32,54.4c-0.3,0.3-0.6,0.6-0.7,1l-7.6-1.4L700.4,871.4z M1591.6,555l-141.8,94.5c-0.3-0.3-0.8-0.6-1.2-0.7 l8.8-128.7l1.3-19.1c0.8-0.1,1.6-0.6,2-1.2l130.8,53.6c0,0.2-0.1,0.3-0.1,0.5C1591.4,554.3,1591.4,554.7,1591.6,555z  M935.3,1025.6v-36.1c1.1-0.2,2-1.1,2.2-2.2l102,3.3L937.2,1027C936.8,1026.3,936.2,1025.8,935.3,1025.6z M697.4,868.5 c-0.2,0-0.5,0-0.7,0.1l-25.5-54.1c0.4-0.3,0.7-0.7,0.9-1.2l64.1,12.8c0,0.6,0.2,1.2,0.5,1.7l-38,41.1 C698.5,868.7,698,868.5,697.4,868.5z M557.8,830.1c-0.3,0-0.6,0.1-0.8,0.1L535.3,790c0.6-0.5,1-1.3,1-2.2c0-0.3-0.1-0.7-0.2-1 l68.4-42.3c0.1,0.1,0.1,0.1,0.2,0.2l-46.1,85.7C558.4,830.2,558.1,830.1,557.8,830.1z M325.7,610.8l32.6-75.5 c0.2,0,0.4,0.1,0.6,0.1c1,0,2-0.5,2.5-1.4l42,15.9l92.2,34.9c0,0.1,0,0.2,0,0.3l-168.8,27C326.5,611.6,326.2,611.2,325.7,610.8z  M779.1,398l-103.2-32.3c0-0.1,0-0.2,0-0.3c0-0.9-0.4-1.6-0.9-2.2l33.3-55.7c0.3,0.1,0.6,0.2,1,0.2c0.5,0,0.9-0.1,1.3-0.3 l68.9,90.1C779.3,397.7,779.2,397.8,779.1,398z M1054.1,283.2l-93.5-14.8v-0.1l33-10.5l32.8-10.4c0.5,0.9,1.5,1.5,2.6,1.5 c0.4,0,0.8-0.1,1.2-0.3l24.5,33.7C1054.4,282.6,1054.3,282.9,1054.1,283.2z M1457.4,500.9l-5.2,75.7l-4.9,72.1 c-0.6,0.1-1.2,0.4-1.6,0.8l-171.2-115.9c0.1-0.3,0.2-0.7,0.2-1l129-23.8l51.8-9.5C1455.8,500,1456.5,500.7,1457.4,500.9z  M1465.2,825.6c0.4,0,0.7-0.1,1.1-0.2l24.7,37.1c-0.3,0.3-0.5,0.6-0.6,1l-57.1-9.5c0-0.5-0.2-0.9-0.4-1.3l29.9-26.9l0.7-0.6 C1464,825.4,1464.5,825.6,1465.2,825.6z M1161.3,960.3l-105.8,66.1c-0.5-0.6-1.3-0.9-2.1-0.9c-0.1,0-0.1,0-0.2,0l-9-32.8 c0.9-0.5,1.6-1.5,1.6-2.6V990l74.7-19.2L1161.3,960.3z M1165.1,399.8c0.5,0,0.9-0.1,1.3-0.3l22.7,28.8l80.4,102.2 c-0.3,0.3-0.5,0.8-0.6,1.2l-167.2-2.9c-0.1-0.7-0.5-1.3-1.1-1.7l63.7-127.5C1164.6,399.8,1164.8,399.8,1165.1,399.8z  M1462.2,822.6c0,0.5,0.2,1,0.4,1.5l-25.8,23.2l-4.8,4.3c-0.2-0.1-0.4-0.3-0.6-0.4l6-36.1l10.5-62.7l16.1,67.5 C1462.9,820.4,1462.2,821.5,1462.2,822.6z M670.4,809.4l3-32.7c0.6-0.1,1.1-0.3,1.5-0.7l61.8,48.8c0,0,0,0.1-0.1,0.1l-64.1-12.8 C672.4,810.8,671.6,809.7,670.4,809.4z M607,739.4l-6.4-64.1c0.1,0,0.2-0.1,0.3-0.1l69.9,96.5c-0.1,0.1-0.1,0.1-0.1,0.2L609.6,743 c0.1-0.2,0.1-0.4,0.1-0.7C609.6,740.8,608.5,739.6,607,739.4z M603.9,743.4l-68.4,42.3c-0.4-0.4-0.8-0.6-1.3-0.8l1.1-17.6 l5.6-91.8c0.4-0.1,0.8-0.2,1.1-0.4l29.8,31.4l32.5,34.3c-0.3,0.5-0.5,1.1-0.5,1.7C603.7,742.7,603.8,743,603.9,743.4z  M781.7,402.4L781.7,402.4l3.9,17.2l18.7,82.8c-0.6,0.3-1.2,0.8-1.4,1.5l-106-23.2l0,0c0-0.6-0.2-1.1-0.4-1.5L756,424l24-22.2 C780.5,402.2,781.1,402.4,781.7,402.4z M847,254.3c0-0.1,0-0.2,0-0.3l50.4-16.5c0.2,0.4,0.6,0.8,1,1l-9.4,27.4l-33.7,97.8l0,0 L845,257C846.1,256.7,847,255.6,847,254.3z M938.6,150.2l18,115.7c-0.4,0.2-0.8,0.5-1.2,0.8L902.6,237c0.1-0.3,0.1-0.6,0.1-0.9 c0-1-0.5-1.9-1.2-2.4l36.6-83.5C938.3,150.2,938.4,150.2,938.6,150.2z M1445,650.5C1445,650.5,1445,650.6,1445,650.5L1325,634 c-0.1-1.5-1.4-2.7-2.9-2.7c-0.3,0-0.5,0-0.7,0.1l-47.8-96.6c0.1-0.1,0.1-0.1,0.2-0.2l111.5,75.5L1445,650.5z M1423.3,687.1 l-36,13.1l-34.8,12.6c-0.1-0.1-0.2-0.3-0.3-0.4l17.5-23.3c0.4,0.2,0.8,0.3,1.2,0.3c1.4,0,2.6-1,2.9-2.3L1423.3,687.1L1423.3,687.1 z M1460.1,716.9l-11.8,29.5c-0.2,0-0.3,0-0.5,0c-0.1,0-0.2,0-0.3,0l-17-50.9l-2.1-6.4c0.1-0.1,0.3-0.2,0.4-0.3l30.4,24.3 c-0.2,0.4-0.3,0.8-0.3,1.3C1458.7,715.5,1459.3,716.4,1460.1,716.9z M1222.2,786.2l-38.5,54.6c-0.4-0.2-0.8-0.2-1.2-0.2 c-0.6,0-1.2,0.2-1.7,0.6l-34.1-31c0.3-0.4,0.4-0.9,0.4-1.5c0-0.1,0-0.2,0-0.2l74.8-22.8C1221.9,785.9,1222.1,786.1,1222.2,786.2z  M937.1,984.9l55.6-65.4c0.4,0.2,0.9,0.4,1.4,0.4c0.4,0,0.7-0.1,1.1-0.2l45.7,68.5c-0.4,0.4-0.6,0.8-0.7,1.4l-102.4-3.3 C937.6,985.7,937.4,985.2,937.1,984.9z M879.9,778.9L775.8,883c-0.2-0.1-0.5-0.3-0.7-0.3l10-116.4c1.1-0.1,2-0.9,2.4-1.9l24.7,3.5 l67.3,9.6C879.5,778,879.6,778.5,879.9,778.9z M533,784.8L533,784.8L496.6,689c0.8-0.5,1.4-1.4,1.4-2.5c0-0.1,0-0.2,0-0.3l3.1-1 l36.7-11.3c0.4,0.7,1,1.2,1.8,1.4l-5.7,93.8L533,784.8z M472.8,398.8l110.1,58.3c-0.1,0.3-0.1,0.5-0.1,0.8s0.1,0.6,0.2,0.9 l-25.6,14.9l-56.7,32.9c-0.5-0.6-1.3-1-2.2-1h-0.1l-26.5-106.1C472.2,399.3,472.6,399.1,472.8,398.8z M1444.9,652.3l-71.5,32.5 c-0.5-0.7-1.4-1.2-2.4-1.2c-0.6,0-1.1,0.2-1.5,0.4l-44.9-48.1c0.1-0.2,0.3-0.4,0.3-0.7l119.9,16.7 C1444.8,652,1444.8,652.1,1444.9,652.3z M1424.3,688.1c0.5,0.8,1.4,1.4,2.5,1.4c0.1,0,0.2,0,0.3,0l19.1,57.4c-0.4,0.2-0.8,0.6-1,1 l-92.3-33c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4l65.5-23.8L1424.3,688.1z M543.3,671.9c-0.2-1-0.9-1.8-1.8-2.1l2.1-12.5l4-23.7 c0.7,0,1.3-0.3,1.7-0.7l47.9,38.3c-0.1,0.2-0.2,0.5-0.3,0.7H543.3z M902,238l52.8,29.7c-0.1,0.3-0.1,0.6-0.1,0.9 c0,0.9,0.4,1.7,1,2.2l-37.6,67.4c-0.2-0.1-0.5-0.1-0.7-0.1l-16.5-99.3C901.4,238.6,901.7,238.4,902,238z M1015.6,445 c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.7,0.2,1.2,0.6,1.7l-86.8,96.8l40-120.1c0.1,0,0.2,0,0.3,0c0.9,0,1.8-0.4,2.3-1.1l19.3,9.6 L1015.6,445z M1020,448.2l76.3,79.6c-0.3,0.5-0.5,1-0.5,1.7c0,0.1,0,0.3,0,0.4l-61,22.9l-17.4,6.5c-0.4-0.6-1-1.1-1.8-1.3 l3.3-109.4C1019.4,448.6,1019.7,448.4,1020,448.2z M1119.7,865c-1.2,0-2.2,0.7-2.6,1.7l-64.2-16.1v-0.1c0-0.2,0-0.4-0.1-0.6 l89-39.5c0.2,0.3,0.4,0.5,0.7,0.7l-21.5,52.2l-0.7,1.8C1120.1,865.1,1119.9,865,1119.7,865z M1041.8,987.4l-20.9-31.4l-24.7-37.1 c0.5-0.5,0.8-1.3,0.8-2.1c0-0.3,0-0.5-0.1-0.7l50.7-25.3c0.4,0.5,0.9,0.8,1.5,1l-6.6,95.5C1042.3,987.3,1042,987.3,1041.8,987.4z  M986.4,884.7l53-27.9l8.2-4.3c0.4,0.5,1,0.9,1.6,1V886c-1.1,0.2-1.9,1.1-2.2,2.1l-60.6-3.2C986.5,884.9,986.5,884.8,986.4,884.7z  M782,762.1l-47.6-10.6l-9.6-2.1l0,0c0-1.3-0.8-2.4-2-2.8l9.8-78c0.2,0,0.4-0.1,0.6-0.1l49.6,92.6 C782.4,761.3,782.2,761.7,782,762.1z M501,586.8c0.2-0.3,0.3-0.6,0.4-1l154.6-6.7l-16.6,7.8l-89.7,42c-0.5-0.7-1.4-1.2-2.3-1.2 c-0.6,0-1.2,0.2-1.7,0.5l-38.3-35.5L501,586.8z M857.8,366.2l45.2-18.6l11.9-4.9c0.4,0.5,0.9,0.9,1.5,1.1l-6.3,53.6 c-0.7,0.1-1.4,0.4-1.9,0.9l-50.5-30.6c0.1-0.3,0.2-0.6,0.2-1C857.8,366.6,857.8,366.4,857.8,366.2z M918.3,343.8l49.2,75.4 c-0.2,0.2-0.3,0.3-0.4,0.5l-53.9-19c0-0.1,0-0.2,0-0.4c0-1.3-0.8-2.4-2-2.8l0.3-2.5l6-51.1C917.8,343.9,918.1,343.9,918.3,343.8z  M1017.8,448.6l-3.3,109.4c-1,0.2-1.9,0.9-2.2,1.8l-29.7-4.7l-51.9-8.3c0-0.6-0.2-1.1-0.6-1.6l85-94.9l1.8-2.1 C1017.3,448.4,1017.5,448.5,1017.8,448.6z M1368.7,688.5l-17.5,23.3c-0.4-0.2-0.8-0.3-1.2-0.3c-0.8,0-1.4,0.3-2,0.8l-33.7-24.5 c0.1-0.2,0.1-0.4,0.2-0.6h53.5C1368.2,687.6,1368.4,688.1,1368.7,688.5z M808.1,503.4l100.6-100.6c0.4,0.3,0.8,0.4,1.3,0.4 L923.6,517l3.2,27.2c-0.7,0.2-1.2,0.7-1.6,1.3l-22.8-7.8l-93.9-32.2c0-0.1,0-0.2,0-0.3C808.6,504.5,808.4,503.9,808.1,503.4z  M1060.9,738.3l181.9-57.3c0.2,0.4,0.6,0.8,1,1.1l-19,53.9c-0.1,0-0.2,0-0.4,0c-1.4,0-2.6,1-2.9,2.3H1060.9z M1262.8,701 c-0.4,0-0.8,0.1-1.2,0.2l-13.7-19.2l-0.4-0.5c0.3-0.3,0.5-0.7,0.6-1.1l38.4,4l22.2,2.3c0,0,0,0,0,0.1l-43.4,15.5 C1264.8,701.6,1263.8,701,1262.8,701z M894.6,621.3l32.5-71.5c0.2,0,0.4,0.1,0.6,0.1c0.2,0,0.3,0,0.5-0.1l4.2,10.4l7.7,19.1 c-0.8,0.5-1.3,1.4-1.3,2.5c0,0.5,0.1,1,0.4,1.4L894.6,621.3C894.6,621.4,894.6,621.3,894.6,621.3z M944.5,582.9L1032,598l7.9,1.4 c0,1,0.5,1.8,1.3,2.3l-64.1,158.7c-0.1,0-0.3,0-0.4,0l-33.8-175.8C943.6,584.2,944.2,583.7,944.5,582.9z M978.3,760.9l64.1-158.7 c0.1,0,0.1,0,0.2,0l13.4,133.9c-1.2,0.4-2.1,1.5-2.1,2.8c0,0.1,0,0.2,0,0.2l-74.8,22.8C979,761.5,978.7,761.1,978.3,760.9z  M1059.4,737.4c-0.5-0.8-1.3-1.4-2.2-1.5L1043.8,602c0.6-0.2,1.2-0.6,1.6-1.2l197,78.1c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.3 l-116.3,36.6L1059.4,737.4z M1040.7,597.3c-0.2,0.3-0.4,0.5-0.5,0.9l-95.5-16.5v-0.1l67.8-19.4c0.5,0.9,1.5,1.6,2.6,1.6 c0.4,0,0.8-0.1,1.2-0.3l5.8,8L1040.7,597.3z M928,544l-16.8-140.9c0.7-0.2,1.2-0.7,1.6-1.2l53.9,19c0,0.1,0,0.2,0,0.4 c0,1.1,0.6,2,1.5,2.5L928,544C928.1,544,928,544,928,544z M924.8,546.6c0,0.1,0,0.2,0,0.4c0,1,0.5,1.8,1.2,2.4l-32.5,71.5 c-0.2,0-0.4-0.1-0.6-0.1c-0.4,0-0.8,0.1-1.2,0.3l-32.9-44.7l-51-69.3c0.1-0.1,0.2-0.3,0.3-0.4l60.2,20.6L924.8,546.6z  M806.8,507.7l83.8,114c-0.3,0.3-0.5,0.8-0.7,1.2l-92-3.3c-0.2-1.1-1-2-2-2.3L806,508C806.3,507.9,806.6,507.9,806.8,507.7z  M602.3,671.2l54.9-45.2c0.5,0.4,1.1,0.6,1.8,0.6c0.9,0,1.7-0.4,2.2-1l68.3,39c0,0.1-0.1,0.3-0.1,0.4l-126.9,6.7 C602.5,671.6,602.4,671.4,602.3,671.2z M729.6,663.3l-67.8-38.7c0.1-0.3,0.2-0.6,0.2-0.9c0-1.4-1-2.6-2.3-2.9v-39.6 c0.3-0.1,0.5-0.2,0.8-0.3l0.4,0.5L729.6,663.3z M732.3,662.6c-0.5,0-1,0.1-1.4,0.4l-53.5-63.6l-16.1-19.2c0.1-0.1,0.2-0.2,0.2-0.4 L792.2,620c0,0.1,0,0.2,0,0.3c0,0.4,0.1,0.8,0.3,1.2l-58.1,42C733.8,662.9,733.1,662.6,732.3,662.6z M658.4,581.2v39.6 c-1.2,0.3-2.1,1.2-2.3,2.5l-90,5.6l-15.6,1l106.1-49.7C657.1,580.7,657.7,581.1,658.4,581.2z M550.3,631.1l105.9-6.6 c0.1,0.2,0.1,0.4,0.2,0.6l-54.9,45.2c-0.5-0.4-1.1-0.6-1.8-0.6s-1.4,0.3-1.9,0.7L550,632C550.1,631.7,550.2,631.4,550.3,631.1z  M785.5,760.5l6.6-89.8l3.5-47.5c1.2-0.2,2.2-1,2.5-2.2l92,3.3c0.1,0.5,0.3,1,0.7,1.4l-104.7,135 C785.8,760.6,785.6,760.5,785.5,760.5z M1141.5,807.4c-0.2,0.4-0.3,0.8-0.3,1.3c0,0.2,0,0.4,0.1,0.6l-88.9,39.5 c-0.4-0.5-0.9-0.9-1.6-1.1l6.6-105.9c0.5-0.1,1-0.3,1.4-0.6l27,21.6L1141.5,807.4z M1225.9,736.4l19-53.9c0.1,0,0.2,0,0.4,0 c0.4,0,0.8-0.1,1.2-0.2l14.1,19.7c-0.5,0.5-0.8,1.2-0.8,2c0,0.5,0.2,1,0.4,1.5l-34.1,31C1226.1,736.4,1226,736.4,1225.9,736.4z  M1319.9,636.2c0.3,0.3,0.6,0.5,1,0.7l-9.3,46.7c-1.3,0-2.4,0.9-2.8,2l-60.6-6.4c0-0.2-0.1-0.4-0.1-0.6l65.4-38.7L1319.9,636.2z  M1104.6,623.1l-58.8-23.3c0-0.2,0-0.3,0-0.5c0-0.7-0.3-1.4-0.7-1.9l3.2-4l49-61.3c0.4,0.2,0.8,0.3,1.3,0.3c0.6,0,1.1-0.2,1.6-0.5 l142.5,145.9L1104.6,623.1z M1012.1,561C1012.1,561.1,1012.1,561.1,1012.1,561l-67.7,19.4c-0.5-0.9-1.5-1.6-2.6-1.6 c-0.2,0-0.3,0-0.5,0.1l-11.8-29.5c0.5-0.3,0.9-0.8,1.1-1.4l71.6,11.4L1012.1,561z M804.7,507.9l-9.9,109.4c-1,0.1-1.8,0.7-2.2,1.5 l-117.3-36.1l-13.3-4.1c0-0.1,0-0.2,0-0.3c0-0.3,0-0.5-0.1-0.7l141.4-70.7C803.7,507.3,804.2,507.7,804.7,507.9z M602.6,673 l91.2-4.8l35.7-1.9c0.3,0.9,1,1.7,1.9,2l-9.8,78c-0.7,0.1-1.4,0.4-1.9,0.9l-117.3-73.7C602.5,673.4,602.6,673.2,602.6,673z  M735.3,665.6c0-0.4-0.1-0.8-0.3-1.2l53.6-38.7l4.6-3.3c0.3,0.3,0.7,0.5,1.1,0.6l-10,137.3c-0.1,0-0.3,0-0.4,0.1l-49.6-92.6 C734.9,667.3,735.3,666.5,735.3,665.6z M894.9,625.9c0.6-0.5,0.9-1.3,0.9-2.2c0-0.5-0.1-1-0.4-1.4l44.5-38.1 c0.5,0.4,1.1,0.6,1.7,0.6L975.3,760l-4.1-6.8L894.9,625.9z M1144.1,805.7c-0.7,0-1.4,0.3-1.9,0.7l-82.8-66.2 c0.1-0.2,0.2-0.5,0.3-0.7h161.7c0.1,0.3,0.2,0.6,0.3,0.8l-75.9,66C1145.4,805.9,1144.8,805.7,1144.1,805.7z M1368.1,685.9h-53.5 c-0.2-0.9-0.9-1.7-1.7-2.1l8.5-42.5l0.8-4.1c0.5,0,1-0.2,1.5-0.4l16.6,17.8l28.4,30.4C1368.3,685.2,1368.2,685.5,1368.1,685.9z  M1096.5,531.3l-52.2,65.3c-0.4-0.2-0.8-0.3-1.3-0.3c-0.4,0-0.8,0.1-1.2,0.3l-24.5-33.7c0.5-0.5,0.8-1.2,0.8-2c0-0.1,0-0.3,0-0.4 l78.4-29.4C1096.3,531.2,1096.4,531.3,1096.5,531.3z M501.4,508.7l181.2-25.9l8.5-1.2c0.2,0.6,0.7,1.1,1.2,1.5l-31.2,87.3l-1.8,5 c-0.1,0-0.3,0-0.4,0c-1,0-1.9,0.5-2.4,1.2l-151.3-65.8l-4-1.7C501.4,509,501.4,508.9,501.4,508.7z M497.4,684.8l48.4-51.6 c0.1,0.1,0.3,0.2,0.4,0.2l-6,36.2c-1.6,0.1-2.8,1.4-2.8,2.9c0,0.1,0,0.2,0,0.3l-39.9,12.3C497.5,685,497.5,684.9,497.4,684.8z  M978.9,765.1c0.4-0.5,0.6-1.1,0.6-1.8c0-0.1,0-0.2,0-0.2l74.8-22.8c0.4,0.7,1,1.2,1.8,1.4l-6.6,105.9c-0.3,0.1-0.7,0.2-0.9,0.3 l-17.5-20.9L978.9,765.1z M1225,781.4v-39.6c1.3-0.3,2.3-1.5,2.3-2.9c0-0.5-0.2-1-0.4-1.5l15.2-13.8l18.7-17L1225,781.4 C1225.1,781.4,1225,781.4,1225,781.4z M1265.7,703.7L1265.7,703.7l43.4-15.6c0.5,0.8,1.4,1.4,2.5,1.4c0.8,0,1.4-0.3,2-0.8 l33.7,24.5c0,0.1-0.1,0.2-0.1,0.2l-50.1-6L1265.7,703.7z M1319.2,633.5c0,0.2-0.1,0.4-0.1,0.7s0.1,0.6,0.2,0.9l-71.8,42.4 c-0.5-0.6-1.3-1-2.2-1c-0.6,0-1.1,0.2-1.6,0.5l-66.3-67.9l-75.9-77.7l193.3,90.6L1319.2,633.5z M802.7,505L802.7,505 c0,0.3,0,0.5,0.1,0.8l-141.4,70.7c-0.2-0.3-0.5-0.5-0.7-0.7l33-92.3c0.1,0,0.3,0,0.4,0c1.2,0,2.2-0.7,2.7-1.7l11.7,2.6L802.7,505z  M690.4,480.5l-188.8,27l82-47.6c0.5,0.6,1.3,1,2.2,1c1.2,0,2.2-0.7,2.7-1.8l14.7,3.1L690.4,480.5z M492.4,687.8l-26.9,20.9 c-0.5-0.4-1.2-0.7-1.9-0.7c-0.2,0-0.3,0-0.5,0l-15.4-40c0.3-0.2,0.6-0.5,0.8-0.8l43.5,18.7c0,0.2-0.1,0.4-0.1,0.6 C492,687,492.2,687.4,492.4,687.8z M719.1,748.3c-0.1,0.3-0.2,0.7-0.2,1s0,0.5,0.1,0.7l-43.7,21.9c-0.5-0.7-1.4-1.1-2.3-1.1 c-0.4,0-0.8,0.1-1.2,0.3l-69.7-96.3L719.1,748.3z M675.8,773l23.6-11.8l20.1-10c0.5,0.7,1.4,1.1,2.3,1.1l0,0l5.9,25.9l10.3,45.2 c-0.2,0.1-0.4,0.2-0.6,0.4L675.6,775c0.2-0.4,0.3-0.8,0.3-1.3C675.9,773.5,675.9,773.3,675.8,773z M787.6,763.1 c0-0.6-0.3-1.2-0.7-1.7l104.7-135c0.1,0.1,0.3,0.1,0.5,0.2L882,774.3c-1.1,0.2-2,0.9-2.3,1.9l-75.5-10.8L787.6,763.1z  M883.2,774.4l2.6-37.6l7.5-110.2c0.2,0,0.4-0.1,0.5-0.1l80.8,134.7c-0.5,0.5-0.9,1.2-0.9,2l-5.9,0.9l-82.7,12.2 C884.8,775.4,884.1,774.7,883.2,774.4z M977.4,766.1c0.2-0.1,0.4-0.1,0.6-0.2l21.8,26l47.8,56.9c-0.4,0.5-0.6,1.1-0.6,1.8 c0,0.3,0.1,0.5,0.1,0.8l-18.1,9.5l-43.1,22.7c-0.5-0.5-1.1-0.9-1.8-1l-6-104.8L977.4,766.1z M986.4,886.2l9.8,0.5l50.7,2.7 c0,0.1,0,0.2,0.1,0.3L996.4,915c-0.5-0.7-1.4-1.1-2.3-1.1c-0.1,0-0.2,0-0.3,0l-8.6-25.9C985.7,887.6,986.2,887,986.4,886.2z  M1050.5,886v-32.6c0.9-0.2,1.6-0.8,2-1.6l59.9,15l4.3,1.1v0.1c0,0.1,0,0.2,0,0.2l-64.3,19.3 C1052.1,886.8,1051.4,886.2,1050.5,886z M1121.4,865.6l5.2-12.7l17-41.3c0.2,0,0.3,0.1,0.5,0.1c0.6,0,1.2-0.2,1.7-0.6l31,28.2 l3.1,2.8c-0.3,0.4-0.4,0.9-0.4,1.5c0,0.2,0,0.3,0,0.5l-57.4,22.3C1122,866.1,1121.7,865.8,1121.4,865.6z M1222.6,741.2 c0.3,0.3,0.7,0.4,1.2,0.5v39.6c-1.3,0.3-2.3,1.5-2.3,2.9c0,0.1,0,0.2,0,0.2l-74.7,22.8L1222.6,741.2z M1226.2,781.9l35.9-75.1 c0.2,0.1,0.4,0.1,0.7,0.1c1.3,0,2.4-0.8,2.8-2l81.5,9.8c0,0.2,0.1,0.4,0.1,0.6l-120.6,67C1226.5,782.2,1226.3,782,1226.2,781.9z  M1271.8,535.4c0.3,0,0.5,0,0.7-0.1l47.8,96.6c-0.2,0.2-0.4,0.3-0.5,0.5l-79.6-37.3l-138.5-64.9l88.1,1.5l79.1,1.4 C1269.1,534.4,1270.3,535.4,1271.8,535.4z M1030.6,394.5L972,419.6c-0.5-0.8-1.4-1.3-2.4-1.3c-0.4,0-0.7,0.1-1.1,0.2l-23-35.2 l-26.2-40.2c0.1-0.1,0.2-0.2,0.3-0.3l110.9,50.5c0,0.2-0.1,0.4-0.1,0.6C1030.5,394.1,1030.5,394.3,1030.6,394.5z M899.5,239 c0.1,0,0.1,0,0.2,0l5.3,32.1l11.2,67.2c-1.1,0.4-1.9,1.5-1.9,2.7c0,0.2,0,0.4,0.1,0.5L857.3,365c-0.2-0.3-0.6-0.6-0.9-0.9l33-95.9 L899.5,239z M854.9,369.7c0.8,0,1.6-0.4,2.1-0.9l50.5,30.6c-0.1,0.3-0.2,0.6-0.2,1c0,0.6,0.2,1.1,0.5,1.6L807.2,502.6 c0,0,0,0-0.1,0l47.3-132.9C854.6,369.7,854.7,369.7,854.9,369.7z M691.2,479.4l-60.4-12.7l-42.1-8.8c0-0.6-0.2-1.2-0.5-1.7 l33.6-35.6l49.7-52.6c0.4,0.3,0.9,0.4,1.4,0.4l19.9,109.5C692.1,478.2,691.5,478.7,691.2,479.4z M500.9,510.3l155.2,67.5v0.1 l-154.8,6.7c-0.3-1.1-1.1-1.9-2.2-2.1v-71C499.8,511.3,500.5,510.8,500.9,510.3z M499,588.2c0.4-0.1,0.8-0.2,1.2-0.5l44.6,41.4 c-0.3,0.4-0.4,1-0.4,1.5c0,0.6,0.2,1.2,0.5,1.7L496.5,684c-0.2-0.1-0.5-0.3-0.8-0.3l1.3-37.2L499,588.2z M446.1,668.5 c0.2,0,0.3,0,0.5,0l15.4,40c-0.7,0.5-1.2,1.3-1.3,2.2l-50.1,6.3c-0.1-0.4-0.3-0.7-0.6-1l35-47.7 C445.3,668.4,445.7,668.5,446.1,668.5z M543.3,673.2h53.5c0.3,1.2,1.3,2.2,2.6,2.3l6.4,64.1c-0.2,0.1-0.4,0.2-0.6,0.3l-62.3-65.6 C543,673.9,543.2,673.6,543.3,673.2z M739.3,823.2L739.3,823.2L723.1,752c0.6-0.3,1.1-0.8,1.4-1.4l57.2,12.7l0,0 c0,0.8,0.3,1.4,0.8,2l-15.4,21.4l-26.6,36.8C740.1,823.3,739.7,823.2,739.3,823.2z M885.3,777.5l88.5-13.1c0.4,1,1.2,1.7,2.3,1.9 l0.8,13.5l5.9,102.9c-0.3,0.1-0.5,0.2-0.7,0.3l-97.3-104C885.1,778.5,885.3,778,885.3,777.5z M1018.5,442.8 c-0.9,0-1.8,0.4-2.3,1.1L972.5,422c0.1-0.2,0.1-0.5,0.1-0.7s0-0.4-0.1-0.6l0,0l58.5-25.1c0.3,0.4,0.6,0.7,1,0.9L1018.5,442.8 C1018.6,442.8,1018.6,442.8,1018.5,442.8z M649.4,287.3c0.1,0,0.1,0,0.2,0l22,75.6c-0.9,0.5-1.6,1.5-1.6,2.6 c0,0.6,0.2,1.2,0.5,1.7l-83.2,88.2L649,287.2C649.1,287.2,649.3,287.3,649.4,287.3z M497.4,588.1c0.1,0,0.2,0.1,0.3,0.1l-0.8,23.7 l-2.5,71.8c-0.8,0.1-1.5,0.6-1.9,1.2l-42.1-18l-1.4-0.6c0-0.2,0.1-0.4,0.1-0.6c0-0.8-0.3-1.5-0.9-2.1l38.6-59.2L497.4,588.1z  M466,712.7c0.3-0.5,0.6-1.1,0.6-1.7c0-0.5-0.1-0.9-0.3-1.3l26.9-20.9c0.5,0.4,1.2,0.7,1.9,0.7c0.2,0,0.3,0,0.4,0l33,87.1l3.2,8.4 l-40-44L466,712.7z M982.9,888.3c0.2,0.1,0.5,0.1,0.7,0.1c0.1,0,0.2,0,0.3,0l8.7,25.9c-0.9,0.5-1.5,1.5-1.5,2.5 c0,0.7,0.2,1.3,0.6,1.8l-54.3,63.9l6.3-13.1L982.9,888.3z M1043.7,987.3l6.6-95.5c0.7-0.1,1.3-0.4,1.7-0.9l110.2,66.8 c-0.1,0.3-0.2,0.6-0.2,1v0.1l-116.6,30C1045.2,988.1,1044.5,987.5,1043.7,987.3z M1162.9,956.7l-110.2-66.8c0.1-0.3,0.2-0.6,0.2-1 c0-0.1,0-0.2,0-0.2l43.7-13.1l20.6-6.2c0.5,0.9,1.5,1.5,2.6,1.5c0.3,0,0.5,0,0.7-0.1l42.8,85.6 C1163.1,956.5,1163,956.6,1162.9,956.7z M1426.8,683.6c-1.4,0-2.6,1-2.9,2.3h-50.1l0,0l71.5-32.5c0.1,0.1,0.2,0.3,0.4,0.4l-18,30 C1427.5,683.6,1427.1,683.6,1426.8,683.6z M1162.5,398.4c0.2,0.3,0.4,0.6,0.7,0.8l-63.7,127.5c-0.2-0.1-0.5-0.1-0.7-0.1 c-0.6,0-1.1,0.2-1.5,0.4l-76.3-79.6c0.3-0.5,0.5-1,0.5-1.7c0-0.1,0-0.2,0-0.3l13.9-4.6L1162.5,398.4z M1033.5,390.9 c-1,0-1.8,0.5-2.4,1.2L938.6,350l-18.4-8.4c0-0.2,0.1-0.4,0.1-0.6s0-0.3-0.1-0.5l134.2-54.5c0.3,0.4,0.7,0.8,1.2,1L1033.5,390.9 L1033.5,390.9z M1054,284.8l-120.7,49l-13.6,5.5c-0.1-0.2-0.3-0.4-0.5-0.6l37.6-67.4c0.3,0.1,0.6,0.1,0.9,0.1 c1.3,0,2.3-0.8,2.8-1.9l93.5,14.8C1053.9,284.6,1054,284.7,1054,284.8z M1026,246.2l-65.8,20.9c-0.5-0.8-1.4-1.4-2.4-1.5 l-3.7-23.5L939.8,150c0.2-0.1,0.3-0.1,0.4-0.2l86.3,94.4c-0.3,0.5-0.6,1.1-0.6,1.7C1026,246,1026,246.1,1026,246.2z M853.3,369.3 l-35.6,99.9l-11.7,33c-0.1,0-0.2,0-0.4,0l0,0l-22.6-100c1-0.5,1.7-1.5,1.7-2.7c0-0.2,0-0.4-0.1-0.6l67.9-30.3 C852.7,368.8,853,369.1,853.3,369.3z M779.2,401l-83.5,77.2c-0.5-0.3-1-0.5-1.6-0.5l-12.9-71.2l-7-38.3c0.6-0.3,1.1-0.7,1.4-1.3 l80.7,25.3l22.5,7c0,0.1,0,0.2,0,0.3C778.8,400,778.9,400.5,779.2,401z M707.3,307L674,362.7c-0.3-0.1-0.6-0.2-0.9-0.2 c-0.1,0-0.1,0-0.2,0l-9-31l-13-44.6c0.5-0.3,0.9-0.6,1.1-1.1l54.4,18.6c0,0.1,0,0.2,0,0.3C706.3,305.7,706.7,306.4,707.3,307z  M596,271.5l-4.6,78.6L585.3,455c-0.7,0.1-1.4,0.5-1.8,1l-39.8-21.1l-70.3-37.3c0.1-0.3,0.1-0.5,0.1-0.8c0-0.6-0.2-1.2-0.5-1.6 l122.1-124.1C595.4,271.3,595.7,271.4,596,271.5z M493.6,315.7l-22.8,78.2c-0.1,0-0.1,0-0.2,0c-1.4,0-2.5,0.9-2.9,2.2l-65.8-2.7 c-0.1-0.3-0.2-0.6-0.3-0.9l91.6-77.1C493.3,315.5,493.5,315.6,493.6,315.7z M470.6,399.8h0.1l26.5,106.1c-0.6,0.3-1.1,0.8-1.4,1.5 l-52.9-10.7l-10.9-2.2c0-1-0.5-1.9-1.3-2.4l39.4-92.4C470.2,399.8,470.4,399.8,470.6,399.8z M497.9,511.4v71 c-0.8,0.2-1.4,0.6-1.9,1.3l-134.2-50.8c0-0.1,0-0.2,0-0.3l133.9-22.9C496.1,510.5,496.9,511.2,497.9,511.4z M496.4,587.4 l-13.9,21.3l-35.3,54.2c-0.3-0.1-0.7-0.2-1.1-0.2c-1,0-1.9,0.5-2.4,1.3l-116.8-50.1c0-0.1,0-0.3,0-0.4l168.8-27 C495.9,586.8,496.1,587.1,496.4,587.4z M375.7,699.8l68.1-32.4c0,0.1,0.1,0.1,0.1,0.2L423.8,695L409,715.2 c-0.4-0.2-0.8-0.3-1.2-0.3c-0.9,0-1.8,0.4-2.3,1.1l-29.7-14.9c0.1-0.2,0.1-0.5,0.1-0.7C375.8,700.2,375.8,700,375.7,699.8z  M410.7,718.2l1.5-0.2l48.6-6.1c0.3,0.8,0.8,1.4,1.5,1.7l-23.2,102.6l0,0c-0.1,0-0.2,0-0.3,0l-29.7-95.7 C410,720,410.6,719.2,410.7,718.2z M440.4,816.5l23.2-102.6l0,0c0.5,0,1-0.2,1.5-0.4l51.7,56.8L531,786c-0.3,0.5-0.6,1.1-0.6,1.7 c0,0.1,0,0.2,0,0.3l-88.8,29.6C441.4,817.1,441,816.7,440.4,816.5z M742.3,826.1c0-0.8-0.3-1.4-0.8-2l42-58.1 c0.1,0,0.2,0.1,0.3,0.1l-10,116.4c-0.2,0-0.4,0.1-0.6,0.1l-32-54.4C741.9,827.8,742.3,827,742.3,826.1z M1040.4,991.7 c0.5,0.8,1.4,1.4,2.5,1.4c0.1,0,0.1,0,0.2,0l9,32.8c-0.8,0.4-1.4,1.1-1.5,2H938.3L1040.4,991.7z M1121.5,870.3 c0.7-0.5,1.1-1.4,1.1-2.3c0-0.2,0-0.3,0-0.5l57.4-22.3c0.3,0.5,0.8,0.9,1.4,1.1l-16.6,109.5c-0.2,0-0.4,0-0.6,0.1L1121.5,870.3z  M1227.4,784.2c0-0.3-0.1-0.6-0.1-0.9l120.6-67c0.2,0.2,0.5,0.5,0.7,0.6l-61.1,190c-0.1,0-0.2,0-0.3,0c-0.3,0-0.5,0-0.7,0.1 l-60.2-120.5C1226.9,786,1227.4,785.2,1227.4,784.2z M1352,716.6c0.2-0.2,0.4-0.4,0.5-0.6l92.3,33c0,0.1,0,0.3,0,0.4 c0,1.2,0.8,2.3,1.9,2.7l-11.6,69.8l-4.9,29.2c-0.3,0-0.5,0.1-0.8,0.1l-65-113L1352,716.6z M1412,823.4l16.3,28.4 c-0.6,0.5-1,1.3-1,2.2c0,0.6,0.2,1.1,0.5,1.6l-20.3,20.3c-0.5-0.3-1-0.5-1.6-0.5c-0.1,0-0.2,0-0.3,0l-52.9-155.3L1412,823.4z  M1393.2,453.7l-11,7.1l-108.3,69.6c-0.1-0.1-0.2-0.1-0.2-0.2l58.2-113c0.2,0.1,0.5,0.1,0.8,0.1c0.8,0,1.6-0.4,2.1-0.9l58.4,35.4 c-0.1,0.3-0.2,0.6-0.2,1C1393,453.1,1393,453.4,1393.2,453.7z M1021,444.2c-0.3-0.5-0.7-0.8-1.1-1.1l13.4-46.3c0.1,0,0.1,0,0.2,0 c1.4,0,2.6-1,2.9-2.3l125.2,2.8L1021,444.2z M936.4,149c0.2,0.2,0.4,0.5,0.6,0.6l-36.6,83.5c-0.2,0-0.4-0.1-0.6-0.1 c-0.6,0-1.1,0.2-1.6,0.5L853.4,189c0.3-0.5,0.5-1,0.5-1.6c0-0.2,0-0.4-0.1-0.6l18.2-8.3L936.4,149z M852.6,189.9l44.8,44.5 c-0.3,0.5-0.5,1-0.5,1.6c0,0.1,0,0.2,0,0.3l-3,1l-47.4,15.5c-0.4-0.6-0.9-1.1-1.6-1.3l6.4-61.1 C851.8,190.3,852.2,190.2,852.6,189.9z M647.8,286.8l-61.2,167l10.6-182.2c0.9-0.1,1.7-0.7,2.1-1.5l47.1,14c0,0.1,0,0.1,0,0.2 C646.5,285.4,647,286.3,647.8,286.8z M519.7,346l-47.6,48.4c-0.1,0-0.1-0.1-0.2-0.1l22.8-78.2c0.1,0,0.1,0,0.2,0c1.6,0,3-1.3,3-3 c0-0.2,0-0.4-0.1-0.6l96.2-42L519.7,346z M429,497.5c1.2,0,2.3-0.7,2.7-1.8l63.5,12.8l-132.6,22.7l18.1-9.8l46.1-24.9 C427.3,497.1,428.1,497.5,429,497.5z M326.4,614.9l110.3,47.3l6.5,2.8c0,0.1,0,0.1,0,0.2l-81.5,6.5c-0.4-1.2-1.5-2.1-2.8-2.1 c-0.3,0-0.6,0.1-0.9,0.2l-32-54.4C326.1,615.3,326.3,615.1,326.4,614.9z M361.8,673l81-6.5l-51.1,24.3l-16.6,7.9 c-0.5-0.7-1.4-1.2-2.3-1.2c-0.3,0-0.5,0-0.7,0.1l-11.4-22.8C361.3,674.4,361.7,673.7,361.8,673z M670.1,773.1 c-0.1,0.2-0.1,0.4-0.1,0.7c0,1.3,0.9,2.4,2.1,2.8l-3,32.7c-0.4,0-0.8,0.2-1.1,0.4l-58.8-65.4L670.1,773.1z M776.7,883.8 l104.1-104.1c0.5,0.3,1,0.5,1.6,0.5s1.1-0.2,1.5-0.4l97.3,104c-0.2,0.3-0.4,0.7-0.5,1.1H777.1C777,884.5,776.9,884.1,776.7,883.8z  M777.1,886.1h203.6c0.1,0.7,0.5,1.3,1.1,1.7l-46.4,96c-0.2-0.1-0.5-0.1-0.7-0.1c-0.8,0-1.6,0.3-2.1,0.9L777,886.5 C777,886.3,777.1,886.2,777.1,886.1z M937.6,1029.2h111.2l-107.9,29.4c-0.4-0.9-1.3-1.5-2.3-1.6l-2.9-25.7 C936.6,1031,937.4,1030.2,937.6,1029.2z M1184.7,841.6l38.5-54.6c0.4,0.2,0.7,0.2,1.2,0.2c0.3,0,0.5,0,0.7-0.1l60.2,120.5 c-0.1,0.1-0.2,0.1-0.3,0.2l-99.8-63.2c0.1-0.3,0.2-0.7,0.2-1C1185.5,842.8,1185.2,842.1,1184.7,841.6z M1408.3,876.9l20.3-20.3 c0.5,0.3,1,0.5,1.6,0.5c1.3,0,2.3-0.8,2.7-1.9l20.3,3.4l35.9,6l-80.7,12.9C1408.5,877.2,1408.5,877,1408.3,876.9z M1465.2,819.7 L1465.2,819.7L1449,752c0.8-0.4,1.4-1.1,1.6-1.9l38.6,1.8l32.4,1.5c0.1,0.5,0.3,0.9,0.6,1.3l-55.6,65.4 C1466.2,819.8,1465.7,819.7,1465.2,819.7z M1521.7,752.1l-53.8-2.4l-17.2-0.8c-0.1-0.8-0.6-1.5-1.3-2l11.8-29.5 c0.2,0,0.3,0.1,0.5,0.1c0.8,0,1.6-0.4,2.1-0.9l22.6,13.8l35.3,21.6C1521.7,751.9,1521.7,752,1521.7,752.1z M1460.5,711.8 c-0.2,0.1-0.4,0.2-0.6,0.4l-30.4-24.3c0.2-0.4,0.3-0.8,0.3-1.3c0-0.9-0.4-1.6-0.9-2.2l18-30c0.3,0.1,0.6,0.2,1,0.2l0,0l11.6,52 L1460.5,711.8z M1455.3,498l-122.7,22.6l-57.8,10.7l119.1-76.5c0.5,0.5,1.3,0.9,2.1,0.9c0.8,0,1.4-0.3,2-0.8l57.6,42 C1455.4,497.2,1455.3,497.6,1455.3,498z M1330.7,416.6l-15.5,30.1l-42.7,82.9c-0.2-0.1-0.5-0.1-0.8-0.1c-0.5,0-0.9,0.1-1.3,0.3 l-103.1-131c0.2-0.3,0.4-0.6,0.5-1l161.8,16.9C1329.7,415.4,1330.1,416.1,1330.7,416.6z M1034.7,391.2l12.9-60.5l9.3-43.4 c1.6,0,3-1.3,3-3c0-0.3-0.1-0.6-0.1-0.8l220.5-121l-245.1,229C1035,391.4,1034.8,391.3,1034.7,391.2z M843.4,257.2 c0.1,0,0.2,0,0.2,0L854,363.9c-1.2,0.4-2.1,1.5-2.1,2.8c0,0.2,0,0.4,0.1,0.6l-46,20.6l-21.9,9.8c-0.2-0.3-0.4-0.5-0.7-0.7l11-25.6 L843.4,257.2z M706.8,303.3l-54.4-18.6c0-0.1,0-0.2,0-0.4c0-0.9-0.4-1.8-1.1-2.3l54.4-110c0.1,0,0.1,0,0.2,0l2.8,129.9 C707.8,302.1,707.2,302.6,706.8,303.3z M400.4,396.5c0.7-0.4,1.2-1,1.4-1.8l65.8,2.7c0.1,0.8,0.6,1.5,1.2,1.9L447.2,450 l-17.7,41.6c-0.2,0-0.4-0.1-0.6-0.1c-0.1,0-0.2,0-0.2,0L405,411.9L400.4,396.5z M372.9,703.4c0.9,0,1.8-0.4,2.3-1.1l29.7,14.9 c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.5,0.1,1,0.4,1.4l-79,65.8l45.8-81.8C372.3,703.4,372.6,703.4,372.9,703.4z M941.2,1059.9 c0-0.1,0-0.1,0-0.2l109.6-29.9c0.2,0.3,0.4,0.6,0.6,0.8l-59.3,103l-4.1,7.1c-0.3-0.1-0.6-0.2-0.9-0.2c-0.3,0-0.6,0.1-0.9,0.2 l-46-78.8C940.8,1061.6,941.2,1060.8,941.2,1059.9z M1166.1,956l16.6-109.5c0.8,0,1.4-0.4,1.9-0.9l99.8,63.2 c-0.1,0.3-0.2,0.7-0.2,1c0,0.2,0,0.3,0,0.5L1167.4,957C1167.2,956.6,1166.7,956.2,1166.1,956z M1288.7,907.3l61.1-190 c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0L1385,819l19.4,57c-0.9,0.5-1.4,1.5-1.4,2.5v0.1l-113.1,29.9 C1289.6,908,1289.2,907.6,1288.7,907.3z M1567,707l-102.4,6.6c-0.4-1.2-1.5-2.2-2.8-2.2l0,0l-7.1-31.9l-5.6-25.3 c0.5-0.2,0.8-0.5,1.1-0.9l116.9,53.4C1567,706.9,1567,707,1567,707z M1395.9,449.7c-0.8,0-1.6,0.4-2.1,0.9l-6.6-4l-51.9-31.4 c0.1-0.3,0.2-0.6,0.2-1c0-0.2,0-0.4-0.1-0.6l134.3-60.5c0,0.1,0.1,0.1,0.1,0.2l-72.8,96.6C1396.8,449.9,1396.4,449.7,1395.9,449.7 z M1165.1,393.9c-1.4,0-2.6,1-2.9,2.3l-125.8-2.8c-0.1-0.3-0.2-0.7-0.4-1l246.2-230L1165.8,394 C1165.6,393.9,1165.3,393.9,1165.1,393.9z M1181.8,132.3l-150.9,111.4c-0.2-0.2-0.5-0.4-0.7-0.5l26.7-123.1l0,0 c1.3,0,2.4-0.9,2.8-2l121.9,13.3C1181.6,131.7,1181.7,132,1181.8,132.3z M947.7,71l-9.2,73.3c-1.5,0.1-2.7,1.4-2.7,2.9 c0,0.2,0,0.4,0.1,0.6l-82.5,37.8c0,0,0,0-0.1-0.1l94.1-114.8C947.5,70.9,947.6,70.9,947.7,71z M842.3,256.7l-25.8,60l-34.2,79.8 c0,0,0,0-0.1,0l-7.3-174.8c0.6-0.2,1.2-0.5,1.6-1l64.7,32.8c-0.1,0.2-0.1,0.5-0.1,0.8C841,255.3,841.5,256.2,842.3,256.7z  M704.3,171.8l-54.2,109.6c-0.2-0.1-0.5-0.1-0.7-0.1c-1.1,0-2.1,0.6-2.6,1.5l-47.1-14c0-0.1,0-0.2,0-0.2c0-0.5-0.2-1-0.4-1.5 l80.1-72.8L704.3,171.8z M494.9,310.2c-1.6,0.1-2.8,1.4-2.8,2.9c0,0.5,0.1,1,0.4,1.4l-91.2,76.8L514,190.8l-1,6.5L494.9,310.2z  M357.7,675.3c0.4,0.2,0.8,0.3,1.2,0.3c0.3,0,0.5,0,0.7-0.1l11.4,22.8c-0.7,0.5-1.1,1.4-1.1,2.3c0,0.4,0.1,0.8,0.2,1.2l-64.4,45.1 l17.8-24.5L357.7,675.3z M326.6,786.4l79.3-66.1c0.5,0.4,1.1,0.6,1.8,0.6c0.1,0,0.2,0,0.3,0l29.7,95.7c-0.5,0.3-0.9,0.7-1.2,1.2 l-109.6-29.9c0-0.1,0-0.1,0-0.2C327,787.2,326.8,786.8,326.6,786.4z M442.1,819.3c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3l88.8-29.6 c0,0,0,0.1,0.1,0.1l-41.3,41.3c-0.5-0.3-1-0.5-1.6-0.5c-1.1,0-2.1,0.6-2.6,1.6l-27.6-7.9L442.1,819.3z M603.9,851.2l3.3-105.9 c0.3-0.1,0.7-0.2,0.9-0.4l35.4,39.3l23.6,26.2c-0.4,0.5-0.6,1.1-0.6,1.7c0,0.4,0.1,0.7,0.2,1L605.3,852 C604.9,851.6,604.4,851.3,603.9,851.2z M812.6,976.7c-0.2,0-0.3,0-0.5,0.1l-36.2-88.9c0.2-0.1,0.3-0.2,0.5-0.4L932,985.6 c0,0.1-0.1,0.2-0.1,0.2l-116.4-6.7C815.3,977.8,814.1,976.7,812.6,976.7z M934.1,989.5v36.1c-1.1,0.2-1.9,1-2.2,2.1l-95.3-6.6 l95.6-33C932.6,988.9,933.3,989.4,934.1,989.5z M989.5,1142c-0.1-0.2-0.3-0.3-0.4-0.4l63.4-110.2c0.3,0.1,0.6,0.2,0.9,0.2 c0.7,0,1.3-0.2,1.8-0.6l47.4,39.9l14.5,12.2c-0.2,0.4-0.4,0.9-0.4,1.4c0,0.2,0,0.4,0.1,0.6l-109.4,49L989.5,1142z M1121.2,1081.8 c-0.4-0.3-1-0.4-1.5-0.4c-0.7,0-1.3,0.2-1.8,0.6l-43.4-36.6l-18.5-15.6c0.1-0.2,0.2-0.4,0.2-0.6l105.9,6.6 c0.1,0.5,0.2,0.9,0.5,1.3l-16.5,17.8L1121.2,1081.8z M1542.5,847.4l-46.9,15.6c-0.5-0.9-1.5-1.5-2.5-1.5c-0.4,0-0.7,0.1-1.1,0.2 l-24.7-37.1c0.2-0.2,0.3-0.4,0.5-0.6l74.8,22.8c0,0.1,0,0.2,0,0.2C1542.5,847.2,1542.5,847.3,1542.5,847.4z M1456.3,495.9 l-57.6-42c0.2-0.4,0.3-0.8,0.3-1.2c0-0.7-0.3-1.4-0.7-1.9l72.8-96.6c0.1,0.1,0.2,0.1,0.4,0.1l-13.4,140.8 C1457.3,495.2,1456.7,495.5,1456.3,495.9z M1469.3,352.1L1335,412.6c-0.4-0.5-0.9-0.9-1.6-1.1l6.7-119.9c0.8-0.1,1.4-0.5,1.9-1.1 l127.4,60.3c-0.1,0.2-0.1,0.4-0.1,0.7C1469.2,351.7,1469.2,351.9,1469.3,352.1z M1329.8,413.4L1197,399.6l-28.9-3l127-40.1 c0.5,0.9,1.5,1.5,2.6,1.5c0.3,0,0.6-0.1,0.9-0.2l32,54.4C1330.2,412.5,1329.9,412.9,1329.8,413.4z M1058.2,281.7 c-0.4-0.2-0.9-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.3l-24.5-33.7c0.5-0.5,0.8-1.2,0.8-2c0-0.4-0.1-0.8-0.3-1.2l99.9-73.7l49.2-36.3 L1058.2,281.7z M1059.8,116.8L1059.8,116.8l46.6-16.9c0.5,0.8,1.4,1.4,2.5,1.4c1,0,1.9-0.5,2.4-1.2l69.2,29.9L1059.8,116.8z  M1106,98.8l-46.6,16.8c-0.5-0.8-1.4-1.4-2.5-1.4c-0.3,0-0.5,0-0.7,0.1L1037.8,77c0.3-0.2,0.5-0.5,0.7-0.8l67.5,21.9 c0,0.1,0,0.2,0,0.3C1105.9,98.5,1106,98.7,1106,98.8z M1055.7,119.8l-17.9,82.7L1029,243l0,0c-0.2,0-0.3,0-0.5,0l-31-78.1 l-19.2-48.3c0.6-0.4,1-1,1.2-1.7l74.5,2.7C1054.1,118.6,1054.8,119.4,1055.7,119.8z M973.7,114.2c0,0.5,0.1,1,0.4,1.4l-33.5,29.3 c-0.2-0.2-0.5-0.3-0.8-0.4l9.2-73.3c0.2,0,0.5-0.1,0.7-0.1l24.9,41.1C974,112.6,973.7,113.3,973.7,114.2z M848.5,189.1 c0.4,0.5,0.9,0.9,1.5,1.1l-6.4,61.1c-0.8,0.1-1.5,0.5-2,1.1L777,219.6c0.1-0.2,0.1-0.5,0.1-0.8c0-0.2,0-0.3-0.1-0.5l70.8-29 L848.5,189.1z M780,396.2l-68.5-89.5c0.4-0.5,0.7-1.2,0.7-1.9c0-1.4-1-2.6-2.4-2.9l-1.2-53.6l-1.6-75l65.4,199.9L780,396.2z  M399,396.9c0.1,0,0.2,0,0.2,0l27.2,91.5l-91.4-178l61.8,81.6c-0.4,0.5-0.7,1.2-0.7,1.9C396.1,395.5,397.4,396.9,399,396.9z  M306,749.3c0-0.4-0.1-0.8-0.2-1.2l25.1-17.6l39.9-27.9c0,0,0,0,0.1,0.1l-42.3,75.5l-3.8,6.7c-0.3-0.1-0.6-0.1-0.9-0.1 s-0.6,0.1-0.8,0.1L305,751.6C305.6,751,306,750.2,306,749.3z M361.5,884.1l75.8-62.6c0.3,0.2,0.6,0.4,0.9,0.5l-6.6,63.4l-3.3,32.1 c-0.8,0.1-1.5,0.5-2,1.1l-64.6-32.3c0.1-0.2,0.1-0.5,0.1-0.7C361.9,885,361.7,884.5,361.5,884.1z M429.6,917.5l9.9-95.5 c1-0.1,1.8-0.7,2.3-1.5l4.2,1.2l39.1,11.2c0,0.1,0,0.1,0,0.2c0,0.8,0.3,1.5,0.8,2l-56.1,82.5C429.7,917.6,429.7,917.6,429.6,917.5 z M606,853l61.4-38.8c0.5,0.5,1.3,0.9,2.1,0.9c0.2,0,0.5,0,0.7-0.1l25.5,54.1c-0.4,0.3-0.7,0.7-0.9,1.2L606.1,854 C606.1,853.6,606.1,853.3,606,853z M700.2,872.6l71.1,12.9c0,0.9,0.4,1.6,1,2.1l-1.9,3.5l-40.8,75.2c-0.3-0.1-0.5-0.1-0.8-0.1 c-0.1,0-0.2,0-0.3,0L698.9,874C699.5,873.7,699.9,873.2,700.2,872.6z M815.4,980.5l96,5.5l20.1,1.2l-37.9,13.1L836,1020 c-0.5-0.9-1.4-1.4-2.5-1.4c-0.3,0-0.5,0-0.7,0.1L814.4,982C814.9,981.6,815.3,981.1,815.4,980.5z M933.1,1031 c0.4,0.3,0.9,0.4,1.4,0.5l2.9,25.7c-1.2,0.4-2,1.5-2,2.8c0,0.2,0,0.4,0.1,0.6l-60.5,25.5l28.9-27.3L933.1,1031z M874.8,1087.3 l42-17.7l19-8c0.5,0.8,1.4,1.3,2.4,1.3c0.3,0,0.6-0.1,0.9-0.2l4.6,7.8l41.4,71c-0.1,0.1-0.2,0.2-0.3,0.4l-110-53.3 c0.1-0.2,0.1-0.5,0.1-0.7C874.9,1087.7,874.9,1087.5,874.8,1087.3z M1122.1,1082.7l21-22.6l20.4-22c0.4,0.3,1,0.4,1.5,0.4 c0.9,0,1.8-0.4,2.3-1.1l85.6,42.8c0,0.1,0,0.1,0,0.2l-130.3,3.3C1122.5,1083.3,1122.3,1083,1122.1,1082.7z M1290.2,909.9 L1290.2,909.9l81.4-21.6l31.7-8.4c0.1,0.2,0.3,0.4,0.4,0.6l-83.8,114c-0.4-0.2-0.8-0.3-1.2-0.3c-0.1,0-0.3,0-0.4,0l-29.5-81.8 C1289.6,911.9,1290.2,910.9,1290.2,909.9z M1408.8,878.7L1408.8,878.7l81.6-13.2c0.4,1.1,1.5,1.9,2.8,1.9c0.5,0,0.9-0.1,1.3-0.3 l41.7,51.4c-0.1,0.1-0.2,0.3-0.3,0.4l-90.3-28.5L1408.8,878.7z M1537.1,917.7l-41.7-51.4c0.4-0.5,0.7-1.1,0.7-1.8 c0-0.1,0-0.2,0-0.3l46.9-15.6c0.4,0.6,0.9,1.1,1.6,1.3l-6.4,67.6C1537.8,917.5,1537.5,917.6,1537.1,917.7z M1542.9,845.6 l-74.8-22.8c0-0.1,0-0.2,0-0.2c0-0.7-0.2-1.3-0.6-1.8l55.6-65.4c0.4,0.2,0.9,0.4,1.4,0.4l0,0l6.9,30.9l12.8,57.7 C1543.7,844.6,1543.2,845.1,1542.9,845.6z M1594.9,588.8c0,0.2,0,0.4,0.1,0.5l-141.5,59.2l138.8-92.6c0.5,0.4,1.1,0.7,1.7,0.8 l2.9,29.2C1595.7,586.4,1594.9,587.5,1594.9,588.8z M1569.5,462.6l3,39.6c-1,0.3-1.7,1.1-2,2l-107.4-6.5l-1.7-0.1l87.2-30 l18.8-6.5C1567.8,462,1568.6,462.5,1569.5,462.6z M1338.8,291.5l-6.7,119.9c-0.2,0-0.3,0.1-0.5,0.1l-32-54.4c0.6-0.5,1-1.3,1-2.2 c0-0.8-0.3-1.6-0.9-2.1l38.8-61.4C1338.6,291.5,1338.7,291.5,1338.8,291.5z M771.5,217.7c-0.2,0.4-0.3,0.8-0.3,1.2 c0,1.5,1.1,2.7,2.5,2.9l7.2,173.2l-54.1-165.2l-19-58.1c0.2-0.1,0.3-0.2,0.5-0.3l15.7,11.5L771.5,217.7z M585,160.7 c0.1,0.2,0.3,0.4,0.4,0.5L496.1,310l19.1-119.6c1.6-0.1,2.8-1.4,2.8-2.9c0-0.2,0-0.3,0-0.5l23.9-9.4L585,160.7z M404.6,200.8 L398.5,391c-0.3,0-0.5,0.1-0.8,0.3l-64.3-84.9c0.4-0.5,0.7-1.2,0.7-1.9c0-0.8-0.3-1.5-0.8-2l70.8-101.7 C404.3,200.7,404.5,200.8,404.6,200.8z M403.2,200l-70.8,101.7c-0.4-0.1-0.7-0.2-1.1-0.2l0,0l-9.1-42l-14.9-69.2 c0.8-0.3,1.3-1,1.6-1.8l93.6,9.9C402.5,198.9,402.8,199.5,403.2,200z M173,505.5l145.1,104.2l-130.8-62.1c0.1-0.2,0.1-0.4,0.1-0.7 c0-1.6-1.3-3-3-3c-0.1,0-0.2,0-0.3,0l-11.7-38.1C172.6,505.8,172.8,505.6,173,505.5z M137.1,687.5l2.5-7.2l44.5-130.4 c0.1,0,0.2,0,0.3,0c0,0,0,0,0.1,0l21.4,91l5.2,22c-1,0.5-1.7,1.5-1.7,2.7c0,0.1,0,0.2,0,0.3l-71.3,22.7 C137.9,688.1,137.5,687.7,137.1,687.5z M253.4,712.2c0.2-0.4,0.3-0.8,0.3-1.2c0-0.1,0-0.3,0-0.4l99.8-35.4l3-1.1 c0.1,0.1,0.2,0.3,0.3,0.4l-52.4,72.1c-0.4-0.2-0.8-0.3-1.2-0.3c-0.8,0-1.4,0.3-2,0.8L262.7,719L253.4,712.2z M303.1,752.3 c0.3,0,0.6-0.1,0.8-0.1l18.2,33.3c-0.6,0.5-1,1.3-1,2.1l-78.1,13c0-0.1-0.1-0.2-0.1-0.3l58.4-48.7 C301.7,752.1,302.4,752.3,303.1,752.3z M731.8,969c-0.1-0.8-0.4-1.5-1-2l42.6-78.7c0.3,0.1,0.5,0.1,0.8,0.1c0.2,0,0.3,0,0.5-0.1 l36.2,88.9c-0.5,0.4-0.9,0.9-1.1,1.5l-24.3-3L731.8,969z M1100.1,1165.5l2.3-9.1l17.3-69h0.1c0.7,0,1.4-0.3,1.9-0.7l103.6,76.8 c-0.1,0.2-0.2,0.4-0.2,0.7l-123.4,3.3C1101.4,1166.6,1100.8,1165.9,1100.1,1165.5z M1227.9,1161.7c-0.7,0-1.4,0.3-1.9,0.7 l-73.8-54.7l-29.8-22.1c0.1-0.2,0.2-0.4,0.2-0.7l82.5-2.1l47.9-1.2c0.2,0.8,0.7,1.4,1.4,1.8l-26.1,78.3 C1228.1,1161.7,1228,1161.7,1227.9,1161.7z M1594.3,551c-0.2,0-0.4,0-0.6,0.1l-18.7-43.6c0.8-0.5,1.3-1.4,1.3-2.4 c0-0.9-0.4-1.7-1-2.2l66.4-119.1L1594.5,551C1594.4,551,1594.4,551,1594.3,551z M1469.9,349.6l-0.1,0.1l-127.4-60.3 c0.1-0.2,0.1-0.4,0.1-0.7c0-0.7-0.3-1.3-0.7-1.9l40.7-50.5L1469.9,349.6z M1179.2,128.1L1111.8,99c0-0.2,0.1-0.4,0.1-0.6 c0-1-0.5-1.9-1.3-2.4l2.3-5.3l45.3,14.9l23.6,23.7L1179.2,128.1z M1035.9,77.7c0.3,0,0.5,0,0.7-0.1l18.4,37.2 c-0.5,0.4-0.9,0.9-1,1.6l-5.9-0.2l-68.6-2.5c0-0.2-0.1-0.4-0.2-0.6l54.5-36.2C1034.4,77.4,1035.1,77.7,1035.9,77.7z M975.7,111.4 L975.7,111.4l-25-41c0.6-0.5,0.9-1.3,0.9-2.1c0-0.8-0.4-1.6-0.9-2.1l14.8-23.9l3.7,1.2L975.7,111.4z M946.4,70l-92,112.3L920,58.6 c0.3,0.1,0.5,0.1,0.8,0.1c1,0,1.8-0.5,2.4-1.2l22.6,10.1c0,0.2-0.1,0.4-0.1,0.6C945.7,68.9,946,69.5,946.4,70z M918.9,58 l-11.7,22.1l-55.4,104.5c-0.2-0.1-0.5-0.1-0.7-0.1l-1.3-6.9l-11.6-60.8c1.1-0.4,1.8-1.5,1.8-2.7c0-0.4-0.1-0.8-0.2-1.1l79-55.1 C918.8,57.9,918.8,58,918.9,58z M732.8,187.8L709,170.4c0.2-0.4,0.3-0.8,0.3-1.2c0-1.5-1.1-2.7-2.6-2.9l-4.9-56.2 c0.1,0,0.1,0,0.2-0.1l69.8,106.4L732.8,187.8z M698.8,109.3L648.7,187l-50.9,78.8c-0.2-0.1-0.4-0.1-0.7-0.2l-8.8-103.9 c1.2-0.4,2.1-1.5,2.1-2.8c0-0.2,0-0.4-0.1-0.6L698.5,109C698.6,109.1,698.7,109.2,698.8,109.3z M584.7,158c-0.1,0.3-0.2,0.7-0.2,1 c0,0.2,0,0.3,0,0.5l-38.6,15.2l-28.4,11.2c-0.4-0.7-1.1-1.1-1.9-1.3l-1.5-54.2l23.2-2.8l37,23.7L584.7,158z M513.2,144.6l1.1,40 c-1.2,0.3-2.1,1.3-2.2,2.5l-104,9.9c0-0.2-0.1-0.3-0.2-0.4l78-62.8l26.9-3.2L513.2,144.6z M256.2,269.1l48.8-78.9 c0.3,0.1,0.6,0.2,1,0.2l0,0l24,111.3c-0.5,0.2-0.9,0.6-1.2,1l-71.7-30.9c0-0.2,0.1-0.4,0.1-0.6 C257.2,270.4,256.8,269.6,256.2,269.1z M330.1,307.1c0.3,0.1,0.7,0.2,1.1,0.2c0.3,0,0.5,0,0.8-0.1l95.1,185 c-0.1,0.1-0.3,0.2-0.4,0.4L266,405.2c0.1-0.3,0.1-0.5,0.1-0.8c0-0.8-0.3-1.5-0.8-2L330.1,307.1z M261.7,406.9 c0.4,0.3,1,0.4,1.5,0.4c0.4,0,0.9-0.1,1.2-0.3l92.3,123.4c-0.2,0.3-0.4,0.6-0.5,0.9l-173.7-26.9l-8.5-1.3c0-0.4-0.1-0.7-0.2-1 l0.8-1.6L261.7,406.9z M168.5,504.9c0.5,0.8,1.4,1.3,2.3,1.3l0.4,0.2l11.7,37.9c-0.8,0.4-1.3,1.2-1.5,2.2l-143.2,10l120.6-47.8 L168.5,504.9z M239.3,768.8c-0.3-0.5-0.7-0.9-1.3-1.2l12.6-53.7c0,0,0,0,0.1,0c0.8,0,1.4-0.3,2-0.8l40.2,29.4l7.5,5.5 c-0.2,0.4-0.3,0.8-0.3,1.2c0,0.1,0,0.2,0,0.3l-57.3,18.1L239.3,768.8z M361.2,887.3l54.4,27.2l10.2,5.1c-0.1,0.2-0.1,0.5-0.1,0.7 c0,0.8,0.3,1.5,0.8,2l-66.4,93c-0.2-0.1-0.4-0.1-0.6-0.2V888.3C360.2,888.2,360.8,887.8,361.2,887.3z M431.5,921.1 c0.1-0.3,0.1-0.5,0.1-0.8c0-0.8-0.3-1.5-0.8-2l48.3-71l7.8-11.5c0.3,0.1,0.7,0.2,1.1,0.2c0.2,0,0.3,0,0.5,0l57.2,144.7 c-0.2,0.2-0.4,0.4-0.6,0.6l-5.3-2.8L431.5,921.1z M558.2,836c0.8-0.1,1.5-0.5,1.9-1.1l40.1,18.5c0,0.2-0.1,0.4-0.1,0.6 c0,1,0.5,1.9,1.2,2.4L548,979.6L558.2,836z M604.2,856.8c0.8-0.3,1.4-0.9,1.7-1.6l8.6,1.6l80,14.8c0,0.9,0.4,1.7,1.1,2.2 l-70.7,138c-0.2,0-0.3-0.1-0.5-0.1L604.2,856.8z M835.5,1023.7c0.4-0.4,0.7-0.8,0.8-1.4l95.5,6.6c0.1,0.4,0.2,0.8,0.4,1.1 l-58.6,55.4c-0.5-0.3-1.1-0.5-1.7-0.5c-0.3,0-0.6,0.1-0.9,0.2l-1.6-2.8L835.5,1023.7z M839.3,1218.6c-0.3-0.3-0.6-0.6-0.9-0.8 l4.9-18.5l28.6-108.6h0.1c0.9,0,1.8-0.5,2.3-1.1l107.4,52.1l2.6,1.3c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.3,0,0.5,0.1,0.8l-41.4,21.2 L839.3,1218.6z M1295.5,1037l-117.6-71.2l-9-5.5l3.3,0.8l143.5,35.9v0.1c0,0.9,0.4,1.8,1.1,2.3l-18.4,36.7 c-0.2-0.1-0.5-0.1-0.7-0.1C1296.8,1036,1296.1,1036.4,1295.5,1037z M1503.6,1022.1c-1.2,0-2.2,0.7-2.7,1.7l-99.1-23.1 c0,0,0,0,0-0.1c0-0.3-0.1-0.6-0.2-0.9l109.4-62.9l25.2-14.5c0.2,0.2,0.4,0.4,0.7,0.6l-33.1,99.2 C1503.8,1022.1,1503.7,1022.1,1503.6,1022.1z M1595.7,551.3l16.7-59.1l26.3-93.3l-40.7,186l-2.8-28.2c1.2-0.4,2.1-1.5,2.1-2.8 C1597.3,552.8,1596.6,551.8,1595.7,551.3z M1640.6,383.2l-66.3,119c-0.2,0-0.3-0.1-0.5-0.1l-3-39.6c1.2-0.4,2.1-1.5,2.1-2.8 c0-0.6-0.2-1.2-0.6-1.7l20.9-22.8L1640.6,383.2z M1567.7,457.7c-0.5,0.5-0.8,1.2-0.8,2c0,0.1,0,0.2,0,0.4l-106.2,36.5 c-0.1-0.1-0.2-0.2-0.2-0.3l67.4-83.5l2.3-2.8c0.4,0.2,0.8,0.3,1.3,0.3c0.4,0,0.8-0.1,1.2-0.3l14.1,19.2L1567.7,457.7z  M1529.2,409.2l-69.7,86.3c-0.1-0.1-0.3-0.1-0.4-0.2l13.4-140.8c0.5-0.1,1-0.2,1.3-0.5l55.1,51.9c-0.3,0.4-0.4,1-0.4,1.5 C1528.5,408,1528.8,408.7,1529.2,409.2z M1380.9,229.1l7.8-2.3l-6.1,7.5l-2.4-3.1c0.4-0.5,0.7-1.2,0.7-1.9 C1380.9,229.3,1380.9,229.2,1380.9,229.1z M1377.9,232.3c0.5,0,0.9-0.1,1.3-0.3l2.6,3.4l-35.3,43.8l30.4-47 C1377.2,232.2,1377.6,232.3,1377.9,232.3z M1156.2,103.6l-42.9-14.1l1.5-3.5l36.3,12.5L1156.2,103.6z M1109.5,95.5 c-0.2,0-0.4-0.1-0.6-0.1c-1.1,0-2,0.6-2.5,1.5l-67.2-21.8l21.6-1.6l51,16.8L1109.5,95.5z M968.8,38.1l0.4,3.9l-2.9-1l1.9-3.1 C968.3,38,968.5,38.1,968.8,38.1z M512.4,114.1l0.4,15.2l-25.1,3l23.3-18.8C511.4,113.8,511.9,114,512.4,114.1z M253.6,274.8v56.3 c-0.1,0-0.1,0-0.2,0.1l-11.9-22.3L253.6,274.8z M252.3,331.8c-0.6,0.5-1.1,1.3-1.1,2.2c0,0.5,0.2,1,0.4,1.5 c-0.3,0.4-0.4,0.9-0.4,1.5c0,0.4,0.1,0.8,0.3,1.2l-76.2,157.7l65.6-185.4L252.3,331.8z M252.4,339.3c0.5,0.4,1.1,0.7,1.9,0.7 c1.6,0,3-1.3,3-3c0-0.5-0.2-1-0.4-1.5c0.3-0.4,0.4-0.9,0.4-1.5c0-1.4-1-2.6-2.3-2.9v-57c0.7-0.2,1.4-0.6,1.8-1.2l71.7,30.9 c0,0.2-0.1,0.4-0.1,0.6c0,0.8,0.3,1.5,0.8,2l-64.8,95.2c-0.3-0.1-0.7-0.2-1.1-0.2c-1.6,0-3,1.3-3,3c0,0.6,0.2,1.2,0.5,1.7 l-84.5,90.6L252.4,339.3z M170.8,500.4c-1.6,0.1-2.8,1.4-2.8,2.9c0,0.2,0,0.3,0,0.5l-48.1,19l-83.2,32.9l0,0l149.6-159.8 c0.1,0.1,0.3,0.2,0.5,0.2L170.8,500.4z M137.1,692.5c0.9-0.5,1.4-1.4,1.4-2.5c0-0.1,0-0.2,0-0.3l58.2-18.5l13.1-4.2 c0.3,0.5,0.7,0.9,1.2,1.1l-20.8,74.1l-16,57c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0l-31.8-93.1L137.1,692.5z M239.7,770.3 c0-0.1,0-0.2,0-0.3l44.2-13.9l16.4-5.2l-14.9,12.4l-43.3,36.1c-0.4-0.3-0.9-0.6-1.5-0.6l-2.9-25.7 C238.9,772.7,239.7,771.6,239.7,770.3z M361.8,1018.2c0-0.1,0-0.1,0-0.2c0-0.8-0.3-1.5-0.8-2l66.4-93c0.1,0.1,0.3,0.1,0.4,0.1 l-0.5,8.7l-6.1,100.7c-0.9,0.1-1.7,0.7-2.2,1.5l-51.4-14.3L361.8,1018.2z M422.5,1032.7l5.9-98.1l0.7-11.3c0.7-0.1,1.4-0.5,1.8-1 l102.5,54.3l11.1,5.9c-0.1,0.3-0.1,0.5-0.1,0.8c0,0.2,0,0.4,0.1,0.5l-120.3,50.1C423.8,1033.3,423.2,1032.9,422.5,1032.7z  M626,1012.3l70.7-138c0.2,0.1,0.5,0.1,0.8,0.1c0.1,0,0.2,0,0.3,0l29.6,92.2c-0.9,0.5-1.5,1.5-1.5,2.6c0,0.2,0,0.4,0.1,0.6 l-99.4,43.1C626.4,1012.6,626.2,1012.5,626,1012.3z M729.7,972c0.9-0.3,1.6-1,1.9-1.9l78,9.8c0,0.1,0,0.2,0,0.3l-75,32.6 c-0.5-0.6-1.2-1.1-2-1.2l-2.5-32.3L729.7,972z M735.2,1014.2c0-0.1,0-0.1,0-0.2l75-32.6c0.5,0.7,1.4,1.2,2.4,1.2 c0.3,0,0.5,0,0.7-0.1l18.4,36.7c-0.5,0.4-0.8,0.9-1,1.5l-79-5.4L735.2,1014.2z M832.7,1024.4c0.3,0.1,0.6,0.1,0.8,0.1 c0.3,0,0.6-0.1,0.9-0.2l28.2,48.7l7.3,12.6c-0.6,0.5-1,1.3-1,2.2c0,0.1,0,0.3,0,0.4l-11.5,4.3l-77.3,28.6 c-0.2-0.2-0.3-0.5-0.6-0.6l37.6-68.1L832.7,1024.4z M780.6,1122.8c0-0.1,0-0.3,0-0.4l88.8-32.9c0.3,0.4,0.7,0.8,1.2,1l-33.4,127 h-0.1c-0.3,0-0.7,0.1-1,0.2l-56.3-92.8C780.3,1124.4,780.6,1123.6,780.6,1122.8z M986.4,1289.4c-0.2-0.6-0.5-1.1-1-1.4l32.4-68.1 c0.2,0.1,0.4,0.1,0.7,0.1c0.2,0,0.5,0,0.7-0.1l28.9,61.1c-0.6,0.5-1,1.2-1.1,2l-16.5,1.7L986.4,1289.4z M1331.1,1162.1l-72.9-79.5 c0.3-0.5,0.6-1.1,0.6-1.7s-0.2-1.1-0.5-1.6l37.8-37.8c0.5,0.3,1,0.5,1.6,0.5c0.1,0,0.1,0,0.2,0l33.4,120.1 C1331.2,1162.1,1331.1,1162.1,1331.1,1162.1z M1541.3,919.6c-0.3-1-1-1.8-2-2.1l6.4-67.6c0.5-0.1,0.9-0.2,1.3-0.4l65.7,65.7 c-0.2,0.3-0.4,0.7-0.4,1.1L1541.3,919.6z M1662.6,802.7l-90.2-93.6c0.3-0.5,0.5-1,0.5-1.6c0-1.2-0.7-2.2-1.7-2.7l26.6-113 c0,0,0,0,0.1,0s0.2,0,0.3,0l64.6,210.9C1662.6,802.6,1662.6,802.7,1662.6,802.7z M1461.3,207.8l10.1,140.8c-0.2,0-0.3,0.1-0.5,0.2 l-87.5-113.5l7.4-9.1l68.4-19.9C1459.6,207.1,1460.3,207.7,1461.3,207.8z M1337.9,286.3c-0.8,0.5-1.3,1.4-1.3,2.4 c0,0.8,0.3,1.6,0.9,2.1l-38.8,61.4c-0.2-0.1-0.4-0.1-0.6-0.1l-13-188.9L1324,254L1337.9,286.3z M1279.4,157.5l-91.9-26.2 c0-0.1,0-0.1,0-0.2c0-1.6-1.3-3-3-3c-0.6,0-1.1,0.2-1.6,0.5l-22.2-22.2l67,22.1L1279.4,157.5z M1149.2,96.6l-33.9-11.7l4.2-9.9 l1.6-3.9c0.2,0,0.4,0.1,0.6,0.1c0.6,0,1.1-0.2,1.6-0.5l7.6,7.6L1149.2,96.6z M1112.2,89.1l-48.3-15.9l11.3-0.9l38.5,13.3 L1112.2,89.1z M1047.8,73.2l-9,0.7c-0.4-1.2-1.5-2.1-2.8-2.1c-0.9,0-1.6,0.4-2.2,1l-31-18.3l54.8,18.1L1047.8,73.2z M1033.1,73.8 c-0.1,0.3-0.2,0.6-0.2,0.9c0,0.4,0.1,0.7,0.2,1.1l-5.7,3.8L978.6,112c-0.5-0.4-1.1-0.7-1.7-0.8l-6.4-67.5l26.8,8.8L1033.1,73.8z  M970.4,42.4L970,38c0.5-0.2,0.9-0.4,1.3-0.8l21.1,12.5L970.4,42.4z M967.1,37.3l-2.1,3.4l-4.1-1.3l5.8-2.4 C966.8,37,966.9,37.2,967.1,37.3z M959.2,40l5.1,1.7l-14.6,23.7c-0.3-0.1-0.6-0.2-1-0.2c-1,0-1.8,0.5-2.4,1.2l-13.9-6.2l-8.8-3.9 c0-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.6l22.7-9.7L959.2,40z M834.1,114.7c0.1,0.7,0.4,1.2,0.9,1.7l-59.9,99.8 c-0.3-0.1-0.6-0.2-1-0.2s-0.7,0.1-1.1,0.2l-26-39.6l-44-67.3c0.4-0.4,0.6-0.8,0.7-1.3l53.3,2.7L834.1,114.7z M589.9,157.3 c-0.5-0.7-1.4-1.2-2.4-1.2c-0.8,0-1.6,0.3-2.1,0.9l-46.2-29.6l157.8-19L589.9,157.3z M485.4,132.6l-42.7,5.1l66.8-24.6 L485.4,132.6z M437.7,139.6l45.9-5.5l-76.4,61.6c-0.5-0.4-1.1-0.7-1.9-0.7c-1.3,0-2.4,0.9-2.8,2l-93.6-9.9V187l111.9-41.2 L437.7,139.6z M222.3,277.1c0.3,0,0.6-0.1,0.8-0.1l17.1,32l-67.9,191.6c-0.1,0-0.2-0.1-0.3-0.1l16-104.2c1.6-0.1,2.8-1.4,2.8-2.9 c0-1.1-0.6-2.1-1.6-2.6L222,277.1C222.1,277.1,222.2,277.1,222.3,277.1z M9.6,510.3c0-0.4-0.1-0.7-0.2-1L184,396.6L35.9,554.9 c-0.4-0.3-1-0.4-1.5-0.4c-0.3,0-0.6,0.1-0.9,0.2L8.7,512.5C9.3,511.9,9.6,511.1,9.6,510.3z M132.6,690.1l-55.8,14.7l-4.9,1.3 c-0.5-1-1.5-1.6-2.6-1.6c-0.8,0-1.5,0.3-2,0.8l-11.1-7.6L5.9,663.3L132.6,690.1C132.6,690.1,132.6,690.1,132.6,690.1z  M175.3,799.6L175.3,799.6l36.8-131.1c0.1,0,0.1,0,0.2,0c0.5,0,1-0.1,1.4-0.4l34.7,41c-0.4,0.5-0.6,1.1-0.6,1.8s0.2,1.3,0.6,1.8 l-1.4,1.7L175.3,799.6z M205,766.3l44.4-52.7c0,0,0.1,0,0.1,0.1l-12.6,53.7c0,0,0,0-0.1,0c-1.6,0-3,1.3-3,3c0,0.3,0,0.5,0.1,0.8 l-57.5,29.3L205,766.3z M267.1,922c0.3-0.5,0.5-1,0.5-1.7c0-0.1,0-0.3,0-0.4l88.8-32.9c0.4,0.7,1.1,1.1,1.9,1.3v126.8 c-0.3,0.1-0.7,0.2-0.9,0.4l-74-76.8L267.1,922z M549.1,980.8L602.6,857c0.1,0,0.2,0,0.3,0l20.2,154.8c-0.6,0.2-1.1,0.6-1.5,1.1 l-71.4-29.2c0-0.2,0.1-0.3,0.1-0.5C550.3,982.2,549.8,981.3,549.1,980.8z M839.9,1219.7l144.9-74.2c0.1,0.2,0.3,0.3,0.5,0.5 L918,1287.4c-0.2-0.1-0.4-0.1-0.7-0.1c-0.7,0-1.3,0.2-1.8,0.6l-75.9-66c0.2-0.4,0.4-0.9,0.4-1.4 C840,1220.2,839.9,1220,839.9,1219.7z M920,1289.1l96.5-69.9c0.1,0.1,0.1,0.1,0.2,0.1l-32.4,68.1c-0.2-0.1-0.4-0.1-0.7-0.1 c-1.4,0-2.6,1-2.9,2.3h-60.5C920.1,1289.5,920.1,1289.3,920,1289.1z M920.2,1290.9h60.5c0.3,1.3,1.4,2.3,2.8,2.3l5.9,32.7 c-0.4,0.2-0.8,0.5-1.1,0.9l-68.2-35.7C920.1,1291,920.2,1291,920.2,1290.9z M980.1,1384c1.6,0,2.9-1.3,2.9-2.8l36.2-6 c0.2,0.4,0.4,0.8,0.8,1.1l-43.4,75.7l-19.5,1.2l22.7-69.2C979.9,1383.9,980,1384,980.1,1384z M975.9,1453.2l-44,76.8l24.7-75.6 L975.9,1453.2z M1019,1373.9l-36.2,6c-0.3-0.7-0.9-1.3-1.6-1.6l9.3-46.7c0.4,0,0.8-0.1,1.1-0.2l28.1,40.6 C1019.4,1372.5,1019.1,1373.2,1019,1373.9z M989.4,1331.4l-9.3,46.7c-0.9,0-1.7,0.4-2.2,1l-40.3-21.7c0.1-0.3,0.1-0.5,0.1-0.8 s0-0.5-0.1-0.7l50.7-25.3C988.6,1330.9,989,1331.2,989.4,1331.4z M977.4,1453.1l57.5-3.6L931.7,1533L977.4,1453.1z M1047.2,1284.6 l-54.8,41.9c-0.5-0.4-1.1-0.7-1.8-0.7l-5.9-32.7c1-0.4,1.7-1.3,1.8-2.4l60.6-6.4C1047.1,1284.3,1047.2,1284.4,1047.2,1284.6z  M1049.9,1280.3c-0.2,0-0.5,0-0.7,0.1l-11.4-24l-17.6-37.1c0.7-0.5,1.2-1.4,1.2-2.3c0-0.3-0.1-0.7-0.2-1l60.4-36.7l15-9.1 c0.1,0.1,0.3,0.3,0.4,0.4l-46.6,109.8C1050.3,1280.4,1050.1,1280.3,1049.9,1280.3z M1377.9,1039.5c-0.7,0-1.4,0.3-1.9,0.7 l-54.8-41.9c0.1-0.2,0.1-0.3,0.2-0.5l31.3,1.4l43.2,1.9c0.1,0.7,0.5,1.4,1.1,1.8l-18.4,36.7 C1378.5,1039.6,1378.2,1039.5,1377.9,1039.5z M1532.3,1046.6l5-93l1.6-30.4c1.3-0.2,2.2-1.2,2.4-2.4l40.7-1.9l30.3-1.4 c0.1,0.5,0.4,1,0.8,1.4l-80.7,127.7C1532.4,1046.7,1532.4,1046.7,1532.3,1046.6z M1615.9,914c-0.2,0-0.4-0.1-0.6-0.1 c-0.6,0-1.1,0.2-1.6,0.5l-65.7-65.7c0.3-0.5,0.5-1,0.5-1.6c0-0.1,0-0.3,0-0.4l113.2-40c0.2,0.3,0.5,0.6,0.8,0.9l-17.1,39.1 L1615.9,914z M1599.2,591.4c0.9-0.5,1.5-1.5,1.5-2.6c0-1.2-0.7-2.2-1.7-2.7l44.3-202.5l19.9,416.7L1599.2,591.4z M1641.1,380.2 c0.1,0.1,0.1,0.3,0.2,0.4l-69.9,76.5c-0.4-0.3-0.9-0.4-1.5-0.4c-0.4,0-0.8,0.1-1.2,0.3l-35-47.7c0.5-0.5,0.8-1.2,0.8-2v-0.1 l49.3-12.5L1641.1,380.2z M1530,404.8c-0.1,0-0.1,0.1-0.2,0.1l-37.1-34.9l-18-16.9c0.3-0.4,0.4-1,0.4-1.5c0-1.5-1.1-2.7-2.5-2.9 l-9.9-139l33.6,97.6L1530,404.8z M1380.5,228c-0.1-0.1-0.1-0.2-0.2-0.3l35.2-37.3l2.1,0.7l-27.6,34.1L1380.5,228z M1379.5,226.8 c-0.4-0.3-1-0.4-1.5-0.4c-1.6,0-3,1.3-3,3c0,0.8,0.3,1.6,0.9,2.1l-35.3,54.5c-0.3-0.1-0.7-0.2-1-0.2c-0.2,0-0.4,0-0.6,0.1 l-19.8-46.1L1286,162c0.6-0.4,1-1.1,1.2-1.8l36.3-0.1l90.8,29.9L1379.5,226.8z M1327.4,160h2.1l46.5,16L1327.4,160z M1287.1,158.9 c-0.3-1.3-1.5-2.3-2.9-2.3c-0.9,0-1.7,0.4-2.2,1l-48.2-27.1l85.9,28.3L1287.1,158.9z M1222.2,125.4l-63.3-20.9l-5-5l57.6,19.8 L1222.2,125.4z M1151.8,97.5L1125.3,71l80.1,45L1151.8,97.5z M1120,70.6l-5.9,13.9l-35.9-12.4l40.6-3.1 C1119.1,69.7,1119.5,70.2,1120,70.6z M1060.8,72.2l-63-20.8l-23.2-13.8l97.6,33.6L1060.8,72.2z M688.4,108.1l-150.9,18.2l-21.9-14 c0.1-0.2,0.1-0.3,0.1-0.5l44.2-0.9L688.4,108.1z M395.9,153.7l-87.4,32.2c-0.5-0.8-1.4-1.4-2.5-1.4c-0.1,0-0.2,0-0.3,0l-7.5-23.7 l-0.7-2.2c0.8-0.5,1.4-1.3,1.5-2.3l133.4-16.1L395.9,153.7z M220.8,276.7C220.8,276.7,220.8,276.8,220.8,276.7l-32.7,113.7 c-0.1,0-0.1,0-0.2,0c-1.6,0-3,1.3-3,3c0,0.4,0.1,0.7,0.2,1L10.4,507.2l44.4-48.6L220.8,276.7z M72.2,707.3l60.7-16 c0.5,1,1.5,1.6,2.6,1.6c0.1,0,0.2,0,0.3,0l36.5,106.8c-0.1,0-0.1,0.1-0.2,0.1L71.8,708.9c0.3-0.4,0.4-0.9,0.4-1.5 C72.2,707.4,72.2,707.4,72.2,707.3z M361.5,1019.4l57.3,15.9c0,0.1,0,0.1,0,0.2c0,1.6,1.2,2.8,2.8,2.9l6.2,43.2 c-0.2,0.1-0.5,0.2-0.6,0.3l-65.6-62.3C361.4,1019.5,361.5,1019.5,361.5,1019.4z M731.1,1017.3c0.4,0.2,0.8,0.3,1.2,0.3 c1.3,0,2.5-0.9,2.8-2.1l95.1,6.6L697,1063.6c-0.1-0.2-0.2-0.3-0.3-0.5l18.8-25.1L731.1,1017.3z M697.2,1066.2 c0.1-0.4,0.2-0.7,0.2-1.1c0-0.1,0-0.2,0-0.3l56.8-17.8l76.8-24c0.2,0.3,0.4,0.6,0.6,0.8l-53.1,96.2c-0.3-0.1-0.6-0.1-0.8-0.1 c-0.8,0-1.5,0.3-2,0.8l-62-42.9L697.2,1066.2z M728.2,1223.3c-0.2-0.6-0.5-1.2-1-1.6l49.7-96.1c0.2,0.1,0.5,0.1,0.8,0.1 s0.7-0.1,1-0.2l56.3,92.8c-0.5,0.4-0.8,1-0.9,1.6l-41.1,1.3L728.2,1223.3z M944.7,1395c0-0.1,0-0.3,0-0.4l33-12 c0.3,0.4,0.6,0.7,1,1l-6.8,20.9l-16,48.8l-4.3,0.3c-0.3-1.2-1.3-2-2.6-2.1l-6.3-53.6C943.8,1397.4,944.7,1396.3,944.7,1395z  M1172.6,1280.4c-0.2,0-0.4-0.1-0.6-0.1c-0.4,0-0.7,0.1-1,0.2l-70.1-110.1l89.3,62.8c-0.2,0.4-0.2,0.7-0.2,1.2 c0,1,0.5,1.9,1.3,2.4l-8.2,19.1L1172.6,1280.4z M1195.9,1235c0-0.2,0.1-0.4,0.1-0.6c0-0.9-0.4-1.8-1.1-2.3l32.3-64.6 c0.2,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5,0,0.8-0.1l53.2,103.1c-0.2,0.2-0.4,0.4-0.5,0.6l-61.7-26.1L1195.9,1235z M1283.7,1269.9 c-0.3,0-0.5,0-0.8,0.1l-53.2-103.1c0.5-0.4,0.9-1,1-1.7h98.9c0.2,0.7,0.6,1.3,1.1,1.8l-46.5,102.9 C1284.1,1269.9,1283.9,1269.9,1283.7,1269.9z M1408.2,1077.6c0,0.1,0,0.2,0,0.3c0,0.6,0.2,1.2,0.6,1.7l-74.7,82.4 c-0.4-0.3-0.9-0.4-1.5-0.4c-0.1,0-0.1,0-0.2,0l-33.4-120.1c0.5-0.3,0.9-0.6,1.2-1.1l32.8,11.3L1408.2,1077.6z M1300.6,1038.5 c-0.1-0.7-0.5-1.4-1.1-1.8l18.4-36.7c0.2,0.1,0.5,0.1,0.7,0.1c0.7,0,1.4-0.3,1.9-0.7l54.8,41.9c-0.1,0.2-0.1,0.3-0.2,0.5l-34-1.5 L1300.6,1038.5z M1617,914.5l0.5-1.2l46-105.2c0.2,0,0.4,0.1,0.6,0.1c0.4,0,0.7-0.1,1-0.2l31.8,50.9c-0.6,0.5-0.9,1.3-0.9,2.1 c0,0.4,0.1,0.7,0.2,1.1l-79,52.6C1617.2,914.6,1617.1,914.5,1617,914.5z M1698,858.2l-31.8-50.9c0.6-0.5,0.9-1.3,0.9-2.1 c0-1.5-1.1-2.7-2.5-2.9l-19.4-404.8L1698,858.2C1698.1,858.2,1698,858.2,1698,858.2z M1640.8,379l-1.9,0.5L1534.1,406 c-0.5-1-1.5-1.7-2.6-1.7c-0.1,0-0.2,0-0.4,0l-49.3-142.8l-18.7-54.1c0,0,0.1,0,0.1-0.1l177.8,170c-0.3,0.5-0.4,1-0.4,1.5 C1640.8,378.9,1640.8,379,1640.8,379z M1458.8,205.1l-46.1,13.4l-20.6,6l26.7-33.1l39.9,13.2c0,0.1,0,0.2,0,0.3 C1458.7,205,1458.8,205.1,1458.8,205.1z M1418.9,189.5l-1.9-0.6l16.7-17.7L1418.9,189.5z M1441.4,159.6c0.1,0.4,0.2,0.7,0.5,1.1 l-26.1,27.7l-82.4-28.4l68.8-0.2L1441.4,159.6z M1323.7,158.8l-95.4-31.4l-10.3-5.8l108,37.2H1323.7z M1075.3,71.1L979.1,38 l138.3,29.9L1075.3,71.1z M966.2,35.7l-7,3l-73.4-24.2L966.2,35v0.1C966.1,35.4,966.2,35.5,966.2,35.7z M957.4,39.5L923.2,54 c-0.5-0.8-1.4-1.3-2.4-1.3c-0.7,0-1.3,0.2-1.7,0.6l-48-42.3L957.4,39.5z M866.2,11.5c0.2,0.2,0.5,0.4,0.8,0.6l-29.8,99.2 c-0.1,0-0.2,0-0.2,0c-1.4,0-2.5,0.9-2.8,2.2l-130.4-6.7c0-0.2-0.1-0.3-0.1-0.4l160.4-93.6L866.2,11.5z M7.6,513.1l24.7,42.1 c-0.6,0.5-1,1.3-1,2.2c0,1.1,0.6,2.1,1.5,2.6L3.7,657.5l3.5-144.3C7.4,513.2,7.5,513.1,7.6,513.1z M66.5,706.3 c-0.1,0.3-0.2,0.7-0.2,1.1c0,1.1,0.7,2.1,1.6,2.6l-9,32.8c-0.1,0-0.1,0-0.2,0c-0.4,0-0.7,0.1-1.1,0.2L5.2,664.4L66.5,706.3z  M176.8,801.5l57.7-29.3c0.5,0.6,1.2,1,2,1.1l2.9,25.7c-1,0.3-1.8,1.2-2,2.2l-60.5,0.5C176.8,801.5,176.8,801.5,176.8,801.5z  M356,1018.4c0.2,1.5,1.4,2.6,2.9,2.6c0.6,0,1.2-0.2,1.7-0.5l33.7,32l31.7,30.1l-181.6-74L356,1018.4z M430.5,1082 c-0.4-0.3-1-0.6-1.6-0.6l-6.2-43.2c1.1-0.4,1.9-1.5,1.9-2.8c0-0.2,0-0.4-0.1-0.5L544,985.2l-109.8,93.7L430.5,1082z M627,1015.2 h102.4c0.1,0.5,0.3,0.9,0.7,1.3l-25.9,34.6l-8.5,11.3c-0.4-0.2-0.8-0.3-1.2-0.3c-0.8,0-1.5,0.3-2,0.8l-65.6-47.1 C626.9,1015.6,627,1015.4,627,1015.2z M696.5,1067.2l47,32.6l31.4,21.8c-0.1,0.4-0.2,0.7-0.2,1.1c0,0.6,0.2,1.1,0.5,1.6 l-79.6,76.9c-0.3-0.2-0.7-0.4-1-0.4l0.5-132.8C695.6,1067.9,696.1,1067.6,696.5,1067.2z M937,1358.5l40.3,21.7 c-0.1,0.3-0.1,0.5-0.1,0.8c0,0.1,0,0.3,0,0.4l-33,12c-0.5-0.8-1.4-1.4-2.4-1.4l-5.9-32.7C936.3,1359.1,936.7,1358.8,937,1358.5z  M941.8,1401l5.9,50.5c-1.2,0.4-2,1.5-2,2.8c0,1.2,0.7,2.2,1.7,2.7l-16.6,70.2l5.2-60.2L941.8,1401z M1023.5,1371.5 c-0.4-0.3-0.9-0.4-1.5-0.4c-0.4,0-0.8,0.1-1.1,0.2l-28.1-40.6c0.3-0.3,0.5-0.7,0.6-1.1l6,0.6l54.5,5.7c0.1,0.5,0.2,1,0.5,1.4 l-0.9,1L1023.5,1371.5z M1054.1,1334.7l-60.6-6.4c0-0.3-0.1-0.7-0.3-0.9l54.8-41.9c0.5,0.4,1,0.6,1.7,0.7l6.2,46.6 C1055,1333.2,1054.4,1333.9,1054.1,1334.7z M1051.6,1280.9l35.8-84.3l10.8-25.5c0.2,0,0.4,0.1,0.6,0.1c0.4,0,0.7-0.1,1-0.2 l70.2,110.3c-0.4,0.4-0.7,0.9-0.8,1.5h-116.4C1052.6,1281.9,1052.2,1281.3,1051.6,1280.9z M1173.7,1280.9l3.2-7.6l15.4-36 c0.2,0,0.4,0.1,0.6,0.1c1,0,1.9-0.5,2.4-1.3l79,33.4l6.4,2.7c0,0.1,0,0.1,0,0.2l-105.9,9.9 C1174.7,1281.8,1174.3,1281.3,1173.7,1280.9z M1408.6,1076.4l-53-18.2l-53.6-18.4l52.1,2.3l21,0.9c0.2,1.4,1.4,2.5,2.9,2.5 c0.6,0,1.1-0.2,1.5-0.4L1408.6,1076.4C1408.6,1076.3,1408.6,1076.3,1408.6,1076.4z M1379.8,1040.2l18.4-36.7 c0.2,0.1,0.5,0.1,0.7,0.1c0.8,0,1.5-0.3,2.1-0.8l68.5,45.7c0,0.1-0.1,0.2-0.1,0.3l-88.5-6.6 C1380.8,1041.3,1380.4,1040.7,1379.8,1040.2z M1474.8,1048.2l26.9-20.9c0.5,0.4,1.2,0.7,1.9,0.7c0.7,0,1.3-0.2,1.8-0.6l23.6,20.6 c-0.1,0.3-0.3,0.5-0.3,0.8h-53.5C1475,1048.6,1474.9,1048.4,1474.8,1048.2z M1460.1,202.4c-0.4,0.2-0.7,0.6-0.9,1l-39.1-13.5 l22.8-28.3c0.4,0.2,0.8,0.3,1.3,0.3c0.2,0,0.3,0,0.4,0L1460.1,202.4z M1371.5,158.6l-41.8,0.1l-117.8-40.6l-85.4-48l313.3,88.2 L1371.5,158.6z M703.1,105.2c-0.5-0.6-1.3-1-2.2-1c-1.4,0-2.6,1-2.9,2.4l-182.2,3.9c-0.3-1.3-1.5-2.3-2.9-2.3 c-1.6,0-2.9,1.3-3,2.9L321.6,150L864.2,11L703.1,105.2z M290.4,164l-67.1,107.4c-0.3-0.1-0.6-0.2-1-0.2c-1.6,0-3,1.3-3,3 c0,0.6,0.2,1.2,0.6,1.7L21.4,493.3L290.4,164z M60.1,743.2l9-32.8c0.1,0,0.1,0,0.2,0c0.6,0,1.2-0.2,1.7-0.6l99.3,89.9L61.6,746.6 c0.1-0.2,0.1-0.5,0.1-0.7C61.7,744.7,61.1,743.7,60.1,743.2z M239.9,804.6c0.1,0,0.2,0,0.4,0l23.3,113c-0.7,0.3-1.3,0.9-1.6,1.6 l-57.1-9.5c0-1-0.6-1.9-1.4-2.4L239.9,804.6z M203.4,912.4c0.5-0.3,1-0.8,1.2-1.4l57.1,9.5c0,0.5,0.1,0.9,0.3,1.3l-41,34.7 c-0.5-0.4-1.1-0.6-1.8-0.6c-0.1,0-0.3,0-0.4,0L203.4,912.4z M221,961.1c0.8-0.5,1.3-1.4,1.3-2.4c0-0.5-0.1-1-0.4-1.4l41-34.7 c0.1,0.1,0.3,0.2,0.4,0.3l-13.2,47.3l-9.6,34.4c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.6,0.1L221,961.1z M431.7,1082.7l113.9-97.2 c0.5,0.4,1.1,0.6,1.8,0.6c1,0,1.9-0.5,2.4-1.3l71.4,29.2c0,0.2-0.1,0.3-0.1,0.5c0,0.1,0,0.3,0,0.4L431.7,1082.7z M696.7,1204.8 c0.1-0.3,0.2-0.7,0.2-1c0-0.6-0.2-1.1-0.5-1.6l79-76.3l-49.3,95.3c-0.2-0.1-0.5-0.1-0.8-0.1c-0.8,0-1.6,0.3-2.1,0.9L696.7,1204.8z  M728.2,1224.6c0-0.1,0-0.1,0-0.2l105.9-3.3c0.3,1.3,1.5,2.2,2.9,2.2c0.4,0,0.8-0.1,1.1-0.2l52.5,78.1c-0.1,0.1-0.1,0.2-0.2,0.3 L728.2,1224.6z M895,1301.5c-0.5-0.6-1.3-1.1-2.2-1.1c-0.4,0-0.8,0.1-1.1,0.2l-51.5-76.7l74.6,64.8c-0.2,0.4-0.4,0.9-0.4,1.4 c0,0.3,0.1,0.6,0.1,0.8L895,1301.5z M918.6,1292.9c0.4-0.2,0.7-0.4,0.9-0.7l68.2,35.7c-0.1,0.3-0.1,0.5-0.1,0.8s0,0.5,0.1,0.7 l-50.7,25.3c-0.5-0.7-1.4-1.1-2.3-1.1h-0.1L918.6,1292.9z M1060.4,1444.4c-1.5,0-2.7,1.1-2.9,2.5l-18.8,1.2l40.8-33l-18.1,29.5 C1061,1444.4,1060.7,1444.4,1060.4,1444.4z M1080.4,1409.8c-0.2,0.1-0.4,0.3-0.6,0.5l-50.6-32.4l-4.4-2.8c0.1-0.3,0.2-0.7,0.2-1 c0-0.6-0.2-1.2-0.6-1.7l3.6-3.9l27.4-30.2c0.4,0.3,0.9,0.4,1.5,0.4c0.1,0,0.2,0,0.3,0L1080.4,1409.8z M1285.9,1270.8 c-0.1-0.1-0.2-0.2-0.4-0.3l33.3-73.7l13.2-29.2c0.2,0,0.4,0.1,0.6,0.1c0.5,0,0.9-0.1,1.3-0.3l37.8,48.3c-0.4,0.5-0.7,1.2-0.7,1.9 c0,0.3,0.1,0.7,0.2,1L1285.9,1270.8z M1374.1,1214.6L1374.1,1214.6c-0.6,0-1,0.1-1.4,0.3l-37.8-48.3c0.4-0.5,0.7-1.2,0.7-1.9 c0-0.6-0.2-1.2-0.6-1.7l74.7-82.4c0,0,0.1,0,0.1,0.1L1374.1,1214.6z M1614.2,919.6c0.3,0.1,0.7,0.2,1,0.2c1.6,0,3-1.3,3-3 c0-0.4-0.1-0.8-0.2-1.1l77.4-51.6L1536,1043.4L1614.2,919.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000057831708591192646640000010297340485273264810_",
    gradientUnits: "userSpaceOnUse",
    x1: -52.3058,
    y1: -212.2755,
    x2: -48.8159,
    y2: -208.7856,
    gradientTransform: "matrix(26 0 0 9 1529 2674)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11990_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000057831708591192646640000010297340485273264810_)",
      enableBackground: "new"
    },
    points: " 149.8,773.7 240.5,801.6 237,770.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000152948986842467616720000001425211288818262202_",
    gradientUnits: "userSpaceOnUse",
    x1: -46.8544,
    y1: -222.0894,
    x2: -43.3645,
    y2: -218.5995,
    gradientTransform: "matrix(25 0 0 10 1534 2885)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11989_",
    style: {
      opacity: 0.9,
      fill: "url(#triangle36_00000152948986842467616720000001425211288818262202_)",
      enableBackground: "new"
    },
    points: " 359.2,672.5 373.1,700.4 446.4,665.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000058586653658298577330000015463377801508001425_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.5442,
    y1: -232.4491,
    x2: -41.0543,
    y2: -228.9592,
    gradientTransform: "matrix(32 0 0 15 1973 4065)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11988_",
    style: {
      opacity: 0.7,
      fill: "url(#triangle36_00000058586653658298577330000015463377801508001425_)",
      enableBackground: "new"
    },
    points: " 547.6,630.6 659.3,623.6 659.3,578.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000178905104696439278350000016854135287024312761_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.9061,
    y1: -235.8776,
    x2: -39.4162,
    y2: -232.3877,
    gradientTransform: "matrix(42 0 0 21 2594 5502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#838383"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11987_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000178905104696439278350000016854135287024312761_)",
      enableBackground: "new"
    },
    points: " 795.4,620.1 942,581.7 928,546.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000048486480840272750460000013537193986040220845_",
    gradientUnits: "userSpaceOnUse",
    x1: -57.8517,
    y1: -234.7835,
    x2: -54.3618,
    y2: -231.2936,
    gradientTransform: "matrix(13 0 0 28 778 7218)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11986_",
    style: {
      opacity: 0.7,
      fill: "url(#triangle36_00000048486480840272750460000013537193986040220845_)",
      enableBackground: "new"
    },
    points: " 24.1,648 59,745.8 69.5,707.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000116940912123519009950000008647023973566813340_",
    gradientUnits: "userSpaceOnUse",
    x1: -55.9428,
    y1: -228.9957,
    x2: -52.4529,
    y2: -225.5058,
    gradientTransform: "matrix(26 0 0 19 1503 5066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11985_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000116940912123519009950000008647023973566813340_)",
      enableBackground: "new"
    },
    points: " 59,745.8 149.8,773.7 69.5,707.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000071553245633903317200000000410968529815969169_",
    gradientUnits: "userSpaceOnUse",
    x1: -60.9844,
    y1: -237.9814,
    x2: -57.4945,
    y2: -234.4916,
    gradientTransform: "matrix(8 0 0 30 498 7670)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11984_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000071553245633903317200000000410968529815969169_)",
      enableBackground: "new"
    },
    points: " 6.7,543.4 24.1,648 34.6,557.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000047052610260523782220000003720942599543291805_",
    gradientUnits: "userSpaceOnUse",
    x1: -54.6689,
    y1: -235.3445,
    x2: -51.179,
    y2: -231.8546,
    gradientTransform: "matrix(41 0 0 31 2331 7946)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0B0B0B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11983_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000047052610260523782220000003720942599543291805_)",
      enableBackground: "new"
    },
    points: " 69.5,707.4 149.8,773.7 212.6,665.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000127724695025402502110000013798670946145102776_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.2132,
    y1: -234.6109,
    x2: -49.7233,
    y2: -231.121,
    gradientTransform: "matrix(25 0 0 31 1474 7946)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D9D9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#898989"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11982_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000127724695025402502110000013798670946145102776_)",
      enableBackground: "new"
    },
    points: " 149.8,773.7 237,770.2 212.6,665.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000127046510651284938440000013116129153968731550_",
    gradientUnits: "userSpaceOnUse",
    x1: -55.8442,
    y1: -237.3511,
    x2: -52.3543,
    y2: -233.8612,
    gradientTransform: "matrix(46 0 0 29 2593 7430)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11981_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000127046510651284938440000013116129153968731550_)",
      enableBackground: "new"
    },
    points: " 24.1,648 34.6,557.3 184.7,546.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000021830814352301102620000010456091016164752517_",
    gradientUnits: "userSpaceOnUse",
    x1: -55.5981,
    y1: -238.9459,
    x2: -52.1082,
    y2: -235.456,
    gradientTransform: "matrix(46 0 0 46 2593 11527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#393939"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686868"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11980_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000021830814352301102620000010456091016164752517_)",
      enableBackground: "new"
    },
    points: " 24.1,648 69.5,707.4 184.7,546.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000091711487204464335650000014446693348187789200_",
    gradientUnits: "userSpaceOnUse",
    x1: -55.3285,
    y1: -238.5292,
    x2: -51.8386,
    y2: -235.0392,
    gradientTransform: "matrix(41 0 0 46 2331 11527)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#979797"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11979_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000091711487204464335650000014446693348187789200_)",
      enableBackground: "new"
    },
    points: " 69.5,707.4 212.6,665.5 184.7,546.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000085253077389285987870000004757067123144845979_",
    gradientUnits: "userSpaceOnUse",
    x1: -54.1708,
    y1: -237.3763,
    x2: -50.68,
    y2: -233.8855,
    gradientTransform: "matrix(50 0 0 36 2859 9117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#898989"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#545454"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11978_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000085253077389285987870000004757067123144845979_)",
      enableBackground: "new"
    },
    points: " 212.6,665.5 359.2,672.5 184.7,546.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000162327475270586468920000012581800740320043703_",
    gradientUnits: "userSpaceOnUse",
    x1: -45.0048,
    y1: -242.069,
    x2: -41.6426,
    y2: -238.7069,
    gradientTransform: "matrix(58 0 0 71 3480 17481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11977_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000162327475270586468920000012581800740320043703_)",
      enableBackground: "new"
    },
    points: " 941.2,206.6 928,546.8 1099,393.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000086674742843719821170000003280582377384660132_",
    gradientUnits: "userSpaceOnUse",
    x1: -43.483,
    y1: -245.1799,
    x2: -39.8988,
    y2: -241.5958,
    gradientTransform: "matrix(58 0 0 42 3480 10492)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4F4F4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11976_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000086674742843719821170000003280582377384660132_)",
      enableBackground: "new"
    },
    points: " 941.2,206.6 1087.8,191.6 1099,393.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000072260371933806869490000001215349032671349166_",
    gradientUnits: "userSpaceOnUse",
    x1: -55.7503,
    y1: -241.0492,
    x2: -52.2604,
    y2: -237.5592,
    gradientTransform: "matrix(62 0 0 45 3468 11244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11975_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000072260371933806869490000001215349032671349166_)",
      enableBackground: "new"
    },
    points: " 6.7,543.4 34.6,557.3 223.1,400.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000142868909248029890370000002306987147008636085_",
    gradientUnits: "userSpaceOnUse",
    x1: -55.6185,
    y1: -242.5585,
    x2: -52.1286,
    y2: -239.0687,
    gradientTransform: "matrix(83 0 0 111 4623 27080)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11974_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000142868909248029890370000002306987147008636085_)",
      enableBackground: "new"
    },
    points: " 6.7,543.4 296.3,156 223.1,400.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000085211213080564878090000018106131329865903508_",
    gradientUnits: "userSpaceOnUse",
    x1: -55.5814,
    y1: -240.9719,
    x2: -52.0915,
    y2: -237.482,
    gradientTransform: "matrix(54 0 0 45 3036 11244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11973_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000085211213080564878090000018106131329865903508_)",
      enableBackground: "new"
    },
    points: " 34.6,557.3 184.7,546.8 223.1,400.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000180331911307254800400000016764844764837626289_",
    gradientUnits: "userSpaceOnUse",
    x1: -51.7872,
    y1: -234.1859,
    x2: -48.2972,
    y2: -230.696,
    gradientTransform: "matrix(26 0 0 30 1547 7705)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#898989"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11972_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000180331911307254800400000016764844764837626289_)",
      enableBackground: "new"
    },
    points: " 212.6,665.5 237,770.2 303.3,749.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000080165341884765813030000000863335209167379897_",
    gradientUnits: "userSpaceOnUse",
    x1: -52.2571,
    y1: -233.5292,
    x2: -48.7673,
    y2: -230.0393,
    gradientTransform: "matrix(42 0 0 24 2427 6259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#898989"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#545454"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11971_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000080165341884765813030000000863335209167379897_)",
      enableBackground: "new"
    },
    points: " 212.6,665.5 359.2,672.5 303.3,749.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000180352681466562938930000001129559532995711152_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.007,
    y1: -224.3611,
    x2: -45.5171,
    y2: -220.8713,
    gradientTransform: "matrix(19 0 0 15 1169 4114)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#111111"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11970_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000180352681466562938930000001129559532995711152_)",
      enableBackground: "new"
    },
    points: " 237,770.2 240.5,801.6 303.3,749.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000152979661226516112600000014550499228746736273_",
    gradientUnits: "userSpaceOnUse",
    x1: -47.1589,
    y1: -231.9396,
    x2: -43.669,
    y2: -228.4496,
    gradientTransform: "matrix(20 0 0 22 1243 5779)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11969_",
    style: {
      opacity: 0.9,
      fill: "url(#triangle36_00000152979661226516112600000014550499228746736273_)",
      enableBackground: "new"
    },
    points: " 359.2,672.5 373.1,700.4 303.3,749.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000062178959413727443450000011017379860187715972_",
    gradientUnits: "userSpaceOnUse",
    x1: -52.3567,
    y1: -235.4594,
    x2: -48.8668,
    y2: -231.9695,
    gradientTransform: "matrix(35 0 0 49 2039 12319)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11968_",
    style: {
      opacity: 0.9,
      fill: "url(#triangle36_00000062178959413727443450000011017379860187715972_)",
      enableBackground: "new"
    },
    points: " 202.1,909.8 219.6,958.6 324.3,787.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000087395061799966074430000015479827509612376498_",
    gradientUnits: "userSpaceOnUse",
    x1: -52.4819,
    y1: -233.0676,
    x2: -48.9921,
    y2: -229.5778,
    gradientTransform: "matrix(35 0 0 35 2039 8945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDEDED"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11967_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000087395061799966074430000015479827509612376498_)",
      enableBackground: "new"
    },
    points: " 202.1,909.8 240.5,801.6 324.3,787.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000087397419692697413950000001493204055527694750_",
    gradientUnits: "userSpaceOnUse",
    x1: -50.4064,
    y1: -224.0972,
    x2: -46.9165,
    y2: -220.6073,
    gradientTransform: "matrix(24 0 0 15 1445 4114)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#979797"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#898989"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11966_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000087397419692697413950000001493204055527694750_)",
      enableBackground: "new"
    },
    points: " 240.5,801.6 303.3,749.3 324.3,787.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000041288353739203738950000008694472539795158955_",
    gradientUnits: "userSpaceOnUse",
    x1: -46.7215,
    y1: -232.6465,
    x2: -43.2316,
    y2: -229.1566,
    gradientTransform: "matrix(20 0 0 25 1243 6510)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#181818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686868"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11965_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000041288353739203738950000008694472539795158955_)",
      enableBackground: "new"
    },
    points: " 303.3,749.3 373.1,700.4 324.3,787.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000048501925538695077150000007448022955732345762_",
    gradientUnits: "userSpaceOnUse",
    x1: -51.4222,
    y1: -233.917,
    x2: -47.9322,
    y2: -230.4271,
    gradientTransform: "matrix(49 0 0 29 2844 7470)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4A4A4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11964_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000048501925538695077150000007448022955732345762_)",
      enableBackground: "new"
    },
    points: " 324.3,787.6 373.1,700.4 495.3,686.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000013872131922361624580000002090027125134857632_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.3459,
    y1: -221.6009,
    x2: -45.856,
    y2: -218.1109,
    gradientTransform: "matrix(35 0 0 10 2088 2885)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0B0B0B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#757575"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11963_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000013872131922361624580000002090027125134857632_)",
      enableBackground: "new"
    },
    points: " 373.1,700.4 446.4,665.5 495.3,686.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000126287825103980106800000003036564128064107662_",
    gradientUnits: "userSpaceOnUse",
    x1: -45.6245,
    y1: -230.977,
    x2: -42.1346,
    y2: -227.487,
    gradientTransform: "matrix(29 0 0 16 1779 4321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#838383"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11962_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000126287825103980106800000003036564128064107662_)",
      enableBackground: "new"
    },
    points: " 446.4,665.5 547.6,630.6 495.3,686.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000138568141638182004960000001001232308881837974_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.7238,
    y1: -235.4157,
    x2: -32.2346,
    y2: -231.9264,
    gradientTransform: "matrix(21 0 0 25 1400 6475)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11961_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000138568141638182004960000001001232308881837974_)",
      enableBackground: "new"
    },
    points: " 659.3,623.6 659.3,578.3 732.6,665.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000163766500616116825500000006308855840139078060_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.3246,
    y1: -235.9203,
    x2: -40.8347,
    y2: -232.4304,
    gradientTransform: "matrix(39 0 0 25 2390 6475)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11960_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000163766500616116825500000006308855840139078060_)",
      enableBackground: "new"
    },
    points: " 659.3,578.3 795.4,620.1 732.6,665.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000109000356716368335250000016637893232362107009_",
    gradientUnits: "userSpaceOnUse",
    x1: -30.9695,
    y1: -230.2105,
    x2: -27.4796,
    y2: -226.7205,
    gradientTransform: "matrix(25 0 0 10 1697 2851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9D9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11959_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000109000356716368335250000016637893232362107009_)",
      enableBackground: "new"
    },
    points: " 928,546.8 942,581.7 1015.3,560.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000137112186831844074450000007941786503880458670_",
    gradientUnits: "userSpaceOnUse",
    x1: -30.4185,
    y1: -241.254,
    x2: -26.9286,
    y2: -237.7641,
    gradientTransform: "matrix(26 0 0 33 1752 8365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D3D3D3"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11958_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000137112186831844074450000007941786503880458670_)",
      enableBackground: "new"
    },
    points: " 928,546.8 1099,393.4 1015.3,560.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000110441865191308003850000015764472322054835597_",
    gradientUnits: "userSpaceOnUse",
    x1: -23.1597,
    y1: -242.2855,
    x2: -18.0034,
    y2: -237.1291,
    gradientTransform: "matrix(24 0 0 33 1667 8365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D3D3D3"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11957_",
    style: {
      opacity: 0.7,
      fill: "url(#triangle36_00000110441865191308003850000015764472322054835597_)",
      enableBackground: "new"
    },
    points: " 1099,393.4 1335.5,355 1015.3,560.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000078021423786421052680000009675621440828745620_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.6021,
    y1: -230.63,
    x2: -30.1122,
    y2: -227.1401,
    gradientTransform: "matrix(29 0 0 11 1921 3096)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B1B1B1"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11956_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000078021423786421052680000009675621440828745620_)",
      enableBackground: "new"
    },
    points: " 942,581.7 1015.3,560.8 1043.2,599.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000151540954221645868410000001075215149219021227_",
    gradientUnits: "userSpaceOnUse",
    x1: -22.2217,
    y1: -241.2645,
    x2: -18.7318,
    y2: -237.7747,
    gradientTransform: "matrix(24 0 0 20 1667 5256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#909090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11955_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000151540954221645868410000001075215149219021227_)",
      enableBackground: "new"
    },
    points: " 1015.3,560.8 1335.5,355 1043.2,599.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000165199299796308816170000014584388827441497001_",
    gradientUnits: "userSpaceOnUse",
    x1: -52.3379,
    y1: -221.7732,
    x2: -48.8471,
    y2: -218.2823,
    gradientTransform: "matrix(54 0 0 22 3095 5875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11954_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000165199299796308816170000014584388827441497001_)",
      enableBackground: "new"
    },
    points: " 240.5,1007.5 429,1084.3 422,1035.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000039130984290010701040000009762686238021128321_",
    gradientUnits: "userSpaceOnUse",
    x1: -50.7463,
    y1: -219.0556,
    x2: -47.2564,
    y2: -215.5657,
    gradientTransform: "matrix(58 0 0 20 3367 5395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#898989"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#545454"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11953_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000039130984290010701040000009762686238021128321_)",
      enableBackground: "new"
    },
    points: " 429,1084.3 624.4,1014.5 422,1035.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000093138409502930317840000007931231982564669842_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.8891,
    y1: -234.9227,
    x2: -41.3992,
    y2: -231.4328,
    gradientTransform: "matrix(92 0 0 54 5511 13545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#757575"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11952_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000093138409502930317840000007931231982564669842_)",
      enableBackground: "new"
    },
    points: " 1531.8,1049.4 1699.3,860.9 1378.2,1042.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000171705321872044082110000012548412973938637197_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.2104,
    y1: -209.6936,
    x2: -38.8295,
    y2: -206.3128,
    gradientTransform: "matrix(31 0 0 13 1940 3695)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#545454"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11951_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000171705321872044082110000012548412973938637197_)",
      enableBackground: "new"
    },
    points: " 624.4,1014.5 765.5,976.7 732.6,1014.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000090268233932931990140000003985975425327764636_",
    gradientUnits: "userSpaceOnUse",
    x1: -47.2122,
    y1: -215.9106,
    x2: -44.2552,
    y2: -212.9536,
    gradientTransform: "matrix(59 0 0 17 3510 4659)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11950_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000090268233932931990140000003985975425327764636_)",
      enableBackground: "new"
    },
    points: " 765.5,976.7 732.6,1014.5 935,1028.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000133518233664156046920000011636144344100606371_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.6512,
    y1: -205.1626,
    x2: -38.1613,
    y2: -201.6727,
    gradientTransform: "matrix(31 0 0 12 1940 3467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E0E0E0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11949_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000133518233664156046920000011636144344100606371_)",
      enableBackground: "new"
    },
    points: " 624.4,1014.5 732.6,1014.5 722.1,1056.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000127741402164162133250000012569611413540013221_",
    gradientUnits: "userSpaceOnUse",
    x1: -40.7562,
    y1: -228.0185,
    x2: -37.2663,
    y2: -224.5285,
    gradientTransform: "matrix(28 0 0 33 1775 8528)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11948_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000127741402164162133250000012569611413540013221_)",
      enableBackground: "new"
    },
    points: " 624.4,1014.5 722.1,1056.4 697.7,1129.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000069379872697080278940000006539969802807277488_",
    gradientUnits: "userSpaceOnUse",
    x1: -48.359,
    y1: -206.4293,
    x2: -44.8691,
    y2: -202.9394,
    gradientTransform: "matrix(62 0 0 13 3673 3708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#616161"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11947_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000069379872697080278940000006539969802807277488_)",
      enableBackground: "new"
    },
    points: " 722.1,1056.4 732.6,1014.5 938.5,1059.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000012430364512511430040000009302382731882938511_",
    gradientUnits: "userSpaceOnUse",
    x1: -46.5018,
    y1: -207.782,
    x2: -43.0108,
    y2: -204.2909,
    gradientTransform: "matrix(59 0 0 13 3511 3708)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11946_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000012430364512511430040000009302382731882938511_)",
      enableBackground: "new"
    },
    points: " 732.6,1014.5 935,1028.4 938.5,1059.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000021837520929337664730000017813461914991291310_",
    gradientUnits: "userSpaceOnUse",
    x1: -45.9237,
    y1: -190.8803,
    x2: -42.4338,
    y2: -187.3904,
    gradientTransform: "matrix(66 0 0 9 3954 2748)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11945_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000021837520929337664730000017813461914991291310_)",
      enableBackground: "new"
    },
    points: " 935,1028.4 1165.3,1035.4 938.5,1059.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000163773285187887757140000012271822014271219073_",
    gradientUnits: "userSpaceOnUse",
    x1: -10.8591,
    y1: -212.3084,
    x2: -7.3692,
    y2: -208.8185,
    gradientTransform: "matrix(20 0 0 16 1533 4439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11944_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000163773285187887757140000012271822014271219073_)",
      enableBackground: "new"
    },
    points: " 1378.2,1042.4 1385.2,1098.2 1315.4,1091.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000176731303752314951290000005321342787103314085_",
    gradientUnits: "userSpaceOnUse",
    x1: -17.6077,
    y1: -212.5491,
    x2: -14.1178,
    y2: -209.0592,
    gradientTransform: "matrix(24 0 0 17 1753 4694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#757575"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B0B0B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11943_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000176731303752314951290000005321342787103314085_)",
      enableBackground: "new"
    },
    points: " 1385.2,1098.2 1399.2,1150.6 1315.4,1091.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000160869639752409785360000008433641182205467796_",
    gradientUnits: "userSpaceOnUse",
    x1: -28.9392,
    y1: -225.6696,
    x2: -25.4493,
    y2: -222.1796,
    gradientTransform: "matrix(33 0 0 35 2239 9049)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11942_",
    style: {
      opacity: 0.7,
      fill: "url(#triangle36_00000160869639752409785360000008433641182205467796_)",
      enableBackground: "new"
    },
    points: " 1284,1272.7 1399.2,1150.6 1311.9,1199.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000004527032131907707280000013702798382357421707_",
    gradientUnits: "userSpaceOnUse",
    x1: -20.2823,
    y1: -224.5775,
    x2: -16.7924,
    y2: -221.0876,
    gradientTransform: "matrix(25 0 0 31 1807 8068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11941_",
    style: {
      opacity: 0.7,
      fill: "url(#triangle36_00000004527032131907707280000013702798382357421707_)",
      enableBackground: "new"
    },
    points: " 1315.4,1091.3 1399.2,1150.6 1311.9,1199.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000001656734710045312670000009727069766091965578_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.1945,
    y1: -173.3556,
    x2: -31.7056,
    y2: -169.8668,
    gradientTransform: "matrix(35 0 0 9 2282 2812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11940_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000001656734710045312670000009727069766091965578_)",
      enableBackground: "new"
    },
    points: " 1050.2,1283.2 1172.3,1283.2 1172.3,1251.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000026873564704546081970000000710725419894963370_",
    gradientUnits: "userSpaceOnUse",
    x1: -31.1957,
    y1: -172.7755,
    x2: -27.7059,
    y2: -169.2856,
    gradientTransform: "matrix(32 0 0 9 2152 2812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11939_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000026873564704546081970000000710725419894963370_)",
      enableBackground: "new"
    },
    points: " 1172.3,1283.2 1284,1272.7 1172.3,1251.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000178903230709888401980000003563272187454159772_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.2437,
    y1: -214.0367,
    x2: -31.7538,
    y2: -210.5468,
    gradientTransform: "matrix(40 0 0 21 2592 5689)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11938_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000178903230709888401980000003563272187454159772_)",
      enableBackground: "new"
    },
    points: " 1284,1272.7 1311.9,1199.5 1172.3,1251.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000029746156732967744680000006683511692546876591_",
    gradientUnits: "userSpaceOnUse",
    x1: -31.0586,
    y1: -190.4738,
    x2: -27.5687,
    y2: -186.9839,
    gradientTransform: "matrix(25 0 0 12 1694 3534)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ABABAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#979797"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11937_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000029746156732967744680000006683511692546876591_)",
      enableBackground: "new"
    },
    points: " 917.5,1290.2 983.9,1290.2 1004.8,1248.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000000182502106724444220000011756525477455956399_",
    gradientUnits: "userSpaceOnUse",
    x1: -21.604,
    y1: -189.8779,
    x2: -18.1141,
    y2: -186.388,
    gradientTransform: "matrix(19 0 0 12 1383 3534)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11936_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000000182502106724444220000011756525477455956399_)",
      enableBackground: "new"
    },
    points: " 983.9,1290.2 1050.2,1283.2 1004.8,1248.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000076578497690722565770000008829149976463261099_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.0578,
    y1: -229.4101,
    x2: -29.5679,
    y2: -225.9203,
    gradientTransform: "matrix(20 0 0 41 1356 10468)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11935_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000076578497690722565770000008829149976463261099_)",
      enableBackground: "new"
    },
    points: " 697.7,1129.7 722.1,1056.4 767.5,1199.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000062910826137692128730000003079439580505154217_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.2123,
    y1: -221.3805,
    x2: -29.7224,
    y2: -217.8906,
    gradientTransform: "matrix(20 0 0 27 1356 7115)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11934_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000062910826137692128730000003079439580505154217_)",
      enableBackground: "new"
    },
    points: " 697.7,1129.7 725.6,1223.9 767.5,1199.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000114074334088237941410000017514518624138581381_",
    gradientUnits: "userSpaceOnUse",
    x1: -47.4334,
    y1: -229.713,
    x2: -43.9435,
    y2: -226.2231,
    gradientTransform: "matrix(62 0 0 41 3673 10468)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11933_",
    style: {
      opacity: 0.9,
      fill: "url(#triangle36_00000114074334088237941410000017514518624138581381_)",
      enableBackground: "new"
    },
    points: " 722.1,1056.4 938.5,1059.9 767.5,1199.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000123400218381892536510000001966327441581065909_",
    gradientUnits: "userSpaceOnUse",
    x1: -43.4249,
    y1: -219.8701,
    x2: -39.935,
    y2: -216.3803,
    gradientTransform: "matrix(40 0 0 27 2464 7135)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11932_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000123400218381892536510000001966327441581065909_)",
      enableBackground: "new"
    },
    points: " 725.6,1223.9 865.2,1293.7 767.5,1199.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000022548785765985776330000009745959235152745119_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.4713,
    y1: -228.4108,
    x2: -40.9814,
    y2: -224.921,
    gradientTransform: "matrix(49 0 0 41 2971 10495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11931_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000022548785765985776330000009745959235152745119_)",
      enableBackground: "new"
    },
    points: " 767.5,1199.5 865.2,1293.7 938.5,1150.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000060734372159540374590000012254397262109404335_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.9702,
    y1: -229.2032,
    x2: -41.4803,
    y2: -225.7134,
    gradientTransform: "matrix(49 0 0 40 2971 10228)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11930_",
    style: {
      opacity: 0.9,
      fill: "url(#triangle36_00000060734372159540374590000012254397262109404335_)",
      enableBackground: "new"
    },
    points: " 767.5,1199.5 938.5,1059.9 938.5,1150.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000008129454897090307800000000774534115317707935_",
    gradientUnits: "userSpaceOnUse",
    x1: -28.2763,
    y1: -227.9124,
    x2: -24.7864,
    y2: -224.4226,
    gradientTransform: "matrix(21 0 0 41 1459 10495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D3D3D3"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11929_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000008129454897090307800000000774534115317707935_)",
      enableBackground: "new"
    },
    points: " 865.2,1293.7 917.5,1290.2 938.5,1150.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000137094123595773571360000005763825606281295288_",
    gradientUnits: "userSpaceOnUse",
    x1: -31.6693,
    y1: -226.9741,
    x2: -28.1794,
    y2: -223.4841,
    gradientTransform: "matrix(25 0 0 40 1694 10254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ABABAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11928_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000137094123595773571360000005763825606281295288_)",
      enableBackground: "new"
    },
    points: " 917.5,1290.2 1004.8,1248.3 938.5,1150.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000017504378983195781800000007666866555000431265_",
    gradientUnits: "userSpaceOnUse",
    x1: -43.4671,
    y1: -222.1129,
    x2: -39.9772,
    y2: -218.623,
    gradientTransform: "matrix(50 0 0 26 3075 6854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11927_",
    style: {
      opacity: 0.9,
      fill: "url(#triangle36_00000017504378983195781800000007666866555000431265_)",
      enableBackground: "new"
    },
    points: " 938.5,1059.9 938.5,1150.6 1113,1136.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000160177876544633513060000009476564112082510227_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.9001,
    y1: -225.9918,
    x2: -41.4102,
    y2: -222.502,
    gradientTransform: "matrix(65 0 0 29 3900 7570)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#181818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11926_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000160177876544633513060000009476564112082510227_)",
      enableBackground: "new"
    },
    points: " 938.5,1059.9 1165.3,1035.4 1113,1136.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000022539318865212116330000009924970303274803108_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.3983,
    y1: -224.8747,
    x2: -38.9084,
    y2: -221.3849,
    gradientTransform: "matrix(50 0 0 32 3075 8322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11925_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000022539318865212116330000009924970303274803108_)",
      enableBackground: "new"
    },
    points: " 938.5,1150.6 1004.8,1248.3 1113,1136.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000101792574856845449670000016344986451207020982_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.4759,
    y1: -228.6693,
    x2: -29.986,
    y2: -225.1794,
    gradientTransform: "matrix(31 0 0 42 2049 10732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11924_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000101792574856845449670000016344986451207020982_)",
      enableBackground: "new"
    },
    points: " 1004.8,1248.3 1050.2,1283.2 1113,1136.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000017495042815760770630000012851670482276257939_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.6185,
    y1: -228.038,
    x2: -32.1287,
    y2: -224.5481,
    gradientTransform: "matrix(35 0 0 42 2282 10732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11923_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000017495042815760770630000012851670482276257939_)",
      enableBackground: "new"
    },
    points: " 1050.2,1283.2 1172.3,1251.8 1113,1136.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000025420191723324269570000003228164990055075209_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.7575,
    y1: -224.8489,
    x2: -39.2676,
    y2: -221.3589,
    gradientTransform: "matrix(58 0 0 29 3565 7570)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#111111"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11922_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000025420191723324269570000003228164990055075209_)",
      enableBackground: "new"
    },
    points: " 1165.3,1035.4 1315.4,1091.3 1113,1136.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000051374727285063501370000001429035609923014077_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.2694,
    y1: -224.8256,
    x2: -38.7795,
    y2: -221.3358,
    gradientTransform: "matrix(57 0 0 33 3510 8563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11921_",
    style: {
      opacity: 0.9,
      fill: "url(#triangle36_00000051374727285063501370000001429035609923014077_)",
      enableBackground: "new"
    },
    points: " 1172.3,1251.8 1311.9,1199.5 1113,1136.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000056388014937496814660000014535787525527174817_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.7695,
    y1: -225.5627,
    x2: -38.2796,
    y2: -222.0727,
    gradientTransform: "matrix(58 0 0 31 3565 8068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F6F6F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11920_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000056388014937496814660000014535787525527174817_)",
      enableBackground: "new"
    },
    points: " 1311.9,1199.5 1315.4,1091.3 1113,1136.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000018202283713875445260000002633996586224350388_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.8439,
    y1: -225.5896,
    x2: -50.354,
    y2: -222.0997,
    gradientTransform: "matrix(60 0 0 25 3419 6573)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11919_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000018202283713875445260000002633996586224350388_)",
      enableBackground: "new"
    },
    points: " 219.6,958.6 240.5,1007.5 358.9,951.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000041261815654431770960000002900344591507564726_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.6565,
    y1: -234.7954,
    x2: -50.5781,
    y2: -231.7171,
    gradientTransform: "matrix(60 0 0 49 3419 12319)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9D9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4F4F4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11918_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000041261815654431770960000002900344591507564726_)",
      enableBackground: "new"
    },
    points: " 219.6,958.6 324.3,787.6 358.9,951.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000044136982866303991690000004091869486323030148_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.2128,
    y1: -229.3676,
    x2: -49.7229,
    y2: -225.8778,
    gradientTransform: "matrix(54 0 0 33 3095 8501)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BFBFBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9D9D9D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11917_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000044136982866303991690000004091869486323030148_)",
      enableBackground: "new"
    },
    points: " 240.5,1007.5 422,1035.4 358.9,951.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000060007778202869801780000015065397628516926351_",
    gradientUnits: "userSpaceOnUse",
    x1: -51.1878,
    y1: -237.817,
    x2: -48.5116,
    y2: -235.1408,
    gradientTransform: "matrix(49 0 0 67 2844 16628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7E7E7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11916_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000060007778202869801780000015065397628516926351_)",
      enableBackground: "new"
    },
    points: " 324.3,787.6 495.3,686.4 358.9,951.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000139999289564846893960000018382852647668080772_",
    gradientUnits: "userSpaceOnUse",
    x1: -51.619,
    y1: -229.1349,
    x2: -47.987,
    y2: -225.503,
    gradientTransform: "matrix(58 0 0 33 3367 8501)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#909090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7E7E7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11915_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000139999289564846893960000018382852647668080772_)",
      enableBackground: "new"
    },
    points: " 422,1035.4 624.4,1014.5 358.9,951.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000168828887976067326660000001057334198027328145_",
    gradientUnits: "userSpaceOnUse",
    x1: -51.6989,
    y1: -237.4578,
    x2: -48.7696,
    y2: -234.5286,
    gradientTransform: "matrix(69 0 0 67 3974 16628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11914_",
    style: {
      opacity: 0.9,
      fill: "url(#triangle36_00000168828887976067326660000001057334198027328145_)",
      enableBackground: "new"
    },
    points: " 358.9,951.8 495.3,686.4 706.3,729.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000022518394448802632430000013133519910941040034_",
    gradientUnits: "userSpaceOnUse",
    x1: -51.2064,
    y1: -236.7534,
    x2: -47.3466,
    y2: -232.8938,
    gradientTransform: "matrix(69 0 0 58 3974 14495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBFBFB"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11913_",
    style: {
      opacity: 0.9,
      fill: "url(#triangle36_00000022518394448802632430000013133519910941040034_)",
      enableBackground: "new"
    },
    points: " 358.9,951.8 624.4,1014.5 706.3,729.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000067914465118751349530000017746956913728902049_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.2091,
    y1: -236.436,
    x2: -37.5614,
    y2: -231.7883,
    gradientTransform: "matrix(30 0 0 58 1885 14495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5C5C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11912_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000067914465118751349530000017746956913728902049_)",
      enableBackground: "new"
    },
    points: " 624.4,1014.5 765.5,976.7 706.3,729.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000076585310420644734550000002991817915371292800_",
    gradientUnits: "userSpaceOnUse",
    x1: -45.5266,
    y1: -230.2145,
    x2: -42.0367,
    y2: -226.7247,
    gradientTransform: "matrix(30 0 0 16 1848 4321)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#909090"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11911_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000076585310420644734550000002991817915371292800_)",
      enableBackground: "new"
    },
    points: " 495.3,686.4 547.6,630.6 600,672.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000067926794169687587090000011632793662662193560_",
    gradientUnits: "userSpaceOnUse",
    x1: -48.4056,
    y1: -236.6915,
    x2: -45.6216,
    y2: -233.9076,
    gradientTransform: "matrix(50 0 0 40 2948 10117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11910_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000067926794169687587090000011632793662662193560_)",
      enableBackground: "new"
    },
    points: " 495.3,686.4 706.3,729.2 600,672.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000094582247427308772090000009168701119071534468_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.134,
    y1: -229.9365,
    x2: -40.6441,
    y2: -226.4465,
    gradientTransform: "matrix(32 0 0 14 1973 3837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F1F1F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11909_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000094582247427308772090000009168701119071534468_)",
      enableBackground: "new"
    },
    points: " 547.6,630.6 659.3,623.6 600,672.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000031166276392797538630000012867202069022804402_",
    gradientUnits: "userSpaceOnUse",
    x1: -45.6934,
    y1: -229.0453,
    x2: -42.2035,
    y2: -225.5554,
    gradientTransform: "matrix(38 0 0 14 2318 3837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11908_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000031166276392797538630000012867202069022804402_)",
      enableBackground: "new"
    },
    points: " 659.3,623.6 732.6,665.5 600,672.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000012444733919072948730000012261293301648926896_",
    gradientUnits: "userSpaceOnUse",
    x1: -44.364,
    y1: -237.2791,
    x2: -41.5583,
    y2: -234.4735,
    gradientTransform: "matrix(38 0 0 42 2318 10597)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11907_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000012444733919072948730000012261293301648926896_)",
      enableBackground: "new"
    },
    points: " 706.3,729.2 732.6,665.5 600,672.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000006703726187112703350000016826322295559320738_",
    gradientUnits: "userSpaceOnUse",
    x1: -51.5316,
    y1: -238.4387,
    x2: -46.4015,
    y2: -233.3086,
    gradientTransform: "matrix(111 0 0 66 6353 16402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDEDED"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11906_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000006703726187112703350000016826322295559320738_)",
      enableBackground: "new"
    },
    points: " 706.3,729.2 765.5,976.7 1060.7,686.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000147204438912634653430000015878946717820872635_",
    gradientUnits: "userSpaceOnUse",
    x1: -50.6683,
    y1: -236.8495,
    x2: -48.0843,
    y2: -234.2655,
    gradientTransform: "matrix(111 0 0 42 6353 10597)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11905_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000147204438912634653430000015878946717820872635_)",
      enableBackground: "new"
    },
    points: " 706.3,729.2 732.6,665.5 1060.7,686.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000092426532691023315240000001814872281368267174_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.5225,
    y1: -238.3739,
    x2: -46.1809,
    y2: -235.0322,
    gradientTransform: "matrix(94 0 0 83 5435 20499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C2C2C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11904_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000092426532691023315240000001814872281368267174_)",
      enableBackground: "new"
    },
    points: " 765.5,976.7 935,1028.4 1060.7,686.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000120529927491935510300000008156859358253354122_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.8423,
    y1: -236.3294,
    x2: -47.1818,
    y2: -233.6689,
    gradientTransform: "matrix(93 0 0 34 5381 8656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#909090"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11903_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000120529927491935510300000008156859358253354122_)",
      enableBackground: "new"
    },
    points: " 732.6,665.5 795.4,620.1 1060.7,686.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000136397702236482030210000004999444501459682702_",
    gradientUnits: "userSpaceOnUse",
    x1: -47.8281,
    y1: -238.293,
    x2: -44.9724,
    y2: -235.4373,
    gradientTransform: "matrix(75 0 0 45 4409 11296)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFBFBF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11902_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000136397702236482030210000004999444501459682702_)",
      enableBackground: "new"
    },
    points: " 795.4,620.1 942,581.7 1060.7,686.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000013894678510674308840000011472711584507320216_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.6639,
    y1: -238.765,
    x2: -32.7009,
    y2: -235.8021,
    gradientTransform: "matrix(33 0 0 45 2141 11296)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#909090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11901_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000013894678510674308840000011472711584507320216_)",
      enableBackground: "new"
    },
    points: " 942,581.7 1043.2,599.2 1060.7,686.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000020394370347414116700000010023708029037656507_",
    gradientUnits: "userSpaceOnUse",
    x1: -9.076,
    y1: -246.3572,
    x2: 6.4173,
    y2: -230.8639,
    gradientTransform: "matrix(16 0 0 60 1235 14896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11900_",
    style: {
      opacity: 0.7,
      fill: "url(#triangle36_00000020394370347414116700000010023708029037656507_)",
      enableBackground: "new"
    },
    points: " 1043.2,599.2 1335.5,355 1060.7,686.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000057845870850597655170000001121203795365916089_",
    gradientUnits: "userSpaceOnUse",
    x1: -46.3929,
    y1: -238.2479,
    x2: -42.4349,
    y2: -234.2899,
    gradientTransform: "matrix(66 0 0 83 3954 20499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C2C2C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11899_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000057845870850597655170000001121203795365916089_)",
      enableBackground: "new"
    },
    points: " 935,1028.4 1060.7,686.5 1165.3,958.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000028315342831393853180000018410776726394851741_",
    gradientUnits: "userSpaceOnUse",
    x1: -45.6622,
    y1: -222.9145,
    x2: -42.1723,
    y2: -219.4246,
    gradientTransform: "matrix(66 0 0 22 3954 5861)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11898_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000028315342831393853180000018410776726394851741_)",
      enableBackground: "new"
    },
    points: " 935,1028.4 1165.3,1035.4 1165.3,958.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000119820536262687231650000000702778861132311472_",
    gradientUnits: "userSpaceOnUse",
    x1: -50.7039,
    y1: -240.705,
    x2: -46.0689,
    y2: -236.07,
    gradientTransform: "matrix(155 0 0 60 8884 14896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDEDED"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11897_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000119820536262687231650000000702778861132311472_)",
      enableBackground: "new"
    },
    points: " 1060.7,686.5 1335.5,355 1598.1,588.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000180345533661301389360000000202167518974018951_",
    gradientUnits: "userSpaceOnUse",
    x1: -50.6761,
    y1: -240.2491,
    x2: -46.5948,
    y2: -236.1678,
    gradientTransform: "matrix(155 0 0 106 8884 25999)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4A4A4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11896_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000180345533661301389360000000202167518974018951_)",
      enableBackground: "new"
    },
    points: " 1060.7,686.5 1165.3,958.6 1598.1,588.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000018957949092830264550000007742116929520791734_",
    gradientUnits: "userSpaceOnUse",
    x1: -48.5862,
    y1: -240.1172,
    x2: -45.0963,
    y2: -236.6272,
    gradientTransform: "matrix(124 0 0 130 7210 31783)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C2C2C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11895_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000018957949092830264550000007742116929520791734_)",
      enableBackground: "new"
    },
    points: " 1165.3,958.6 1378.2,1042.4 1598.1,588.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000129896171462281809750000017730668090660968576_",
    gradientUnits: "userSpaceOnUse",
    x1: -45.1965,
    y1: -239.6811,
    x2: -41.7066,
    y2: -236.1912,
    gradientTransform: "matrix(92 0 0 130 5511 31783)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11894_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000129896171462281809750000017730668090660968576_)",
      enableBackground: "new"
    },
    points: " 1378.2,1042.4 1699.3,860.9 1598.1,588.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000167390915078781862780000004405464182947301565_",
    gradientUnits: "userSpaceOnUse",
    x1: -17.5023,
    y1: -240.8564,
    x2: -14.0124,
    y2: -237.3665,
    gradientTransform: "matrix(29 0 0 120 2109 29331)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11893_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000167390915078781862780000004405464182947301565_)",
      enableBackground: "new"
    },
    points: " 1646.9,442.1 1699.3,860.9 1598.1,588.7  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000104696667771384546350000002868922804610426529_",
    gradientUnits: "userSpaceOnUse",
    x1: -51.7104,
    y1: -245.3801,
    x2: -48.2205,
    y2: -241.8902,
    gradientTransform: "matrix(170 0 0 63 9655 15470)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11892_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000104696667771384546350000002868922804610426529_)",
      enableBackground: "new"
    },
    points: " 868.7,9.4 1462,204.8 1378.2,229.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000080180050332432789040000011737307413267458957_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.543,
    y1: -244.1986,
    x2: -44.7048,
    y2: -239.3603,
    gradientTransform: "matrix(112 0 0 62 6499 15292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4F4F4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11891_",
    style: {
      opacity: 0.7,
      fill: "url(#triangle36_00000080180050332432789040000011737307413267458957_)",
      enableBackground: "new"
    },
    points: " 1087.8,191.6 1099,393.4 1378.2,229.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000175291976952362444810000011688056697558564014_",
    gradientUnits: "userSpaceOnUse",
    x1: -47.8814,
    y1: -242.9775,
    x2: -44.1991,
    y2: -239.2951,
    gradientTransform: "matrix(103 0 0 86 6013 21076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11890_",
    style: {
      opacity: 0.7,
      fill: "url(#triangle36_00000175291976952362444810000011688056697558564014_)",
      enableBackground: "new"
    },
    points: " 1099,393.4 1335.5,355 1378.2,229.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000018235727566225384060000010395281766986596533_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.4209,
    y1: -242.6603,
    x2: -45.931,
    y2: -239.1704,
    gradientTransform: "matrix(143 0 0 103 8236 25173)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C2C2C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11889_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000018235727566225384060000010395281766986596533_)",
      enableBackground: "new"
    },
    points: " 1335.5,355 1598.1,588.7 1378.2,229.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000082356123166854889940000003152370530177542558_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.7761,
    y1: -243.214,
    x2: -39.2862,
    y2: -239.7242,
    gradientTransform: "matrix(77 0 0 68 4686 16731)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11888_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000082356123166854889940000003152370530177542558_)",
      enableBackground: "new"
    },
    points: " 1462,204.8 1646.9,442.1 1378.2,229.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000066511492227154186100000003410864035012929687_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.7609,
    y1: -242.3694,
    x2: -39.271,
    y2: -238.8795,
    gradientTransform: "matrix(77 0 0 103 4686 25173)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11887_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000066511492227154186100000003410864035012929687_)",
      enableBackground: "new"
    },
    points: " 1598.1,588.7 1646.9,442.1 1378.2,229.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000158738652681049392870000007746813789455506068_",
    gradientUnits: "userSpaceOnUse",
    x1: -54.1443,
    y1: -248.8257,
    x2: -43.8502,
    y2: -238.5316,
    gradientTransform: "matrix(63 0 0 78 3706 19101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9D9D9D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11886_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000158738652681049392870000007746813789455506068_)",
      enableBackground: "new"
    },
    points: " 484.5,260.8 941.2,206.6 865.2,65.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000137101214865851263530000012658349868133874359_",
    gradientUnits: "userSpaceOnUse",
    x1: -43.2074,
    y1: -245.4565,
    x2: -39.5192,
    y2: -241.7683,
    gradientTransform: "matrix(49 0 0 71 2985 17414)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5C5C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11885_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000137101214865851263530000012658349868133874359_)",
      enableBackground: "new"
    },
    points: " 941.2,206.6 1087.8,191.6 865.2,65.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000117664056495744577980000016397603297925867167_",
    gradientUnits: "userSpaceOnUse",
    x1: -51.3978,
    y1: -245.1909,
    x2: -47.9079,
    y2: -241.701,
    gradientTransform: "matrix(147 0 0 63 8389 15470)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#979797"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11884_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000117664056495744577980000016397603297925867167_)",
      enableBackground: "new"
    },
    points: " 868.7,9.4 1378.2,229.3 865.2,65.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000063631283561722129450000014297850735257062557_",
    gradientUnits: "userSpaceOnUse",
    x1: -50.9542,
    y1: -244.5774,
    x2: -47.4643,
    y2: -241.0876,
    gradientTransform: "matrix(147 0 0 71 8389 17414)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6F6F6F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11883_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000063631283561722129450000014297850735257062557_)",
      enableBackground: "new"
    },
    points: " 1087.8,191.6 1378.2,229.3 865.2,65.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000096755567802048676700000001195612668100575884_",
    gradientUnits: "userSpaceOnUse",
    x1: -52.3266,
    y1: -243.3599,
    x2: -48.8367,
    y2: -239.8699,
    gradientTransform: "matrix(37 0 0 70 2155 17199)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#909090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#616161"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11882_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000096755567802048676700000001195612668100575884_)",
      enableBackground: "new"
    },
    points: " 223.1,400.3 296.3,156 352.2,187.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000036935690478019505980000002777701255381550510_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.4118,
    y1: -243.1837,
    x2: -49.9219,
    y2: -239.6938,
    gradientTransform: "matrix(55 0 0 61 3145 15039)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#909090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#616161"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11881_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000036935690478019505980000002777701255381550510_)",
      enableBackground: "new"
    },
    points: " 223.1,400.3 415,340.9 352.2,187.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000143578568338268223530000009211964006136022953_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.9677,
    y1: -246.5282,
    x2: -50.4778,
    y2: -243.0384,
    gradientTransform: "matrix(164 0 0 51 9161 12578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#909090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#616161"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11880_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000143578568338268223530000009211964006136022953_)",
      enableBackground: "new"
    },
    points: " 296.3,156 868.7,9.4 352.2,187.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000029748785398026684710000007134943884925217954_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.3614,
    y1: -243.7375,
    x2: -51.2182,
    y2: -241.5943,
    gradientTransform: "matrix(84 0 0 44 4777 10942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#909090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7E7E7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11879_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000029748785398026684710000007134943884925217954_)",
      enableBackground: "new"
    },
    points: " 415,340.9 484.5,260.8 352.2,187.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000090290319678946905340000000052253239909331595_",
    gradientUnits: "userSpaceOnUse",
    x1: -52.8029,
    y1: -244.1205,
    x2: -51.0893,
    y2: -242.4069,
    gradientTransform: "matrix(147 0 0 78 8242 19101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5C5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDEDED"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11878_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000090290319678946905340000000052253239909331595_)",
      enableBackground: "new"
    },
    points: " 484.5,260.8 865.2,65.2 352.2,187.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000160892660970394515660000000822939831922861192_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.6813,
    y1: -246.4431,
    x2: -50.1914,
    y2: -242.9533,
    gradientTransform: "matrix(148 0 0 51 8297 12578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBFBFB"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11877_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000160892660970394515660000000822939831922861192_)",
      enableBackground: "new"
    },
    points: " 865.2,65.2 868.7,9.4 352.2,187.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000023973943951903666070000000284374738078846085_",
    gradientUnits: "userSpaceOnUse",
    x1: -48.8336,
    y1: -247.8707,
    x2: -38.1303,
    y2: -237.1675,
    gradientTransform: "matrix(49 0 0 40 2936 10010)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CCCCCC"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11876_",
    style: {
      opacity: 0.7,
      fill: "url(#triangle36_00000023973943951903666070000000284374738078846085_)",
      enableBackground: "new"
    },
    points: " 484.5,260.8 941.2,206.6 781.7,442.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000083807620981048835590000008615352735533950626_",
    gradientUnits: "userSpaceOnUse",
    x1: -43.2182,
    y1: -239.4836,
    x2: -40.7904,
    y2: -237.0558,
    gradientTransform: "matrix(39 0 0 52 2390 12942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C2C2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#979797"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11875_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000083807620981048835590000008615352735533950626_)",
      enableBackground: "new"
    },
    points: " 659.3,578.3 795.4,620.1 781.7,442.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000062902196182108286910000003733206523786064274_",
    gradientUnits: "userSpaceOnUse",
    x1: -48.0106,
    y1: -239.6118,
    x2: -45.4013,
    y2: -237.0025,
    gradientTransform: "matrix(68 0 0 52 3994 12942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11874_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000062902196182108286910000003733206523786064274_)",
      enableBackground: "new"
    },
    points: " 795.4,620.1 928,546.8 781.7,442.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000176026645676781736200000011812637170149578374_",
    gradientUnits: "userSpaceOnUse",
    x1: -47.137,
    y1: -242.713,
    x2: -44.0106,
    y2: -239.5867,
    gradientTransform: "matrix(68 0 0 71 3994 17481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11873_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000176026645676781736200000011812637170149578374_)",
      enableBackground: "new"
    },
    points: " 941.2,206.6 928,546.8 781.7,442.1  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000155849932728774873020000009661436542363486870_",
    gradientUnits: "userSpaceOnUse",
    x1: -54.8078,
    y1: -240.5392,
    x2: -48.0063,
    y2: -233.7376,
    gradientTransform: "matrix(63 0 0 42 3574 10521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFBFBF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11872_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000155849932728774873020000009661436542363486870_)",
      enableBackground: "new"
    },
    points: " 184.7,546.8 223.1,400.3 498,588.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000044895509502139145670000004711388118873905598_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.5,
    y1: -240.6226,
    x2: -49.4723,
    y2: -236.5949,
    gradientTransform: "matrix(63 0 0 58 3574 14397)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C7C7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDEDED"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11871_",
    style: {
      opacity: 0.9,
      fill: "url(#triangle36_00000044895509502139145670000004711388118873905598_)",
      enableBackground: "new"
    },
    points: " 184.7,546.8 359.2,672.5 498,588.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000144326167752005127550000008801751793994813343_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.4372,
    y1: -243.3163,
    x2: -46.6445,
    y2: -236.5235,
    gradientTransform: "matrix(55 0 0 37 3145 9299)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#909090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#616161"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11870_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000144326167752005127550000008801751793994813343_)",
      enableBackground: "new"
    },
    points: " 223.1,400.3 415,340.9 498,588.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000181809441955025434770000000016134161688025745_",
    gradientUnits: "userSpaceOnUse",
    x1: -45.9833,
    y1: -239.1182,
    x2: -43.1404,
    y2: -236.2753,
    gradientTransform: "matrix(25 0 0 58 1534 14397)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#979797"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#898989"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11869_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000181809441955025434770000000016134161688025745_)",
      enableBackground: "new"
    },
    points: " 359.2,672.5 446.4,665.5 498,588.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000127722345116786941160000018120570211340215698_",
    gradientUnits: "userSpaceOnUse",
    x1: -52.9115,
    y1: -242.3856,
    x2: -43.4216,
    y2: -232.8959,
    gradientTransform: "matrix(69 0 0 38 3967 9539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#909090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E7E7E7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11868_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000127722345116786941160000018120570211340215698_)",
      enableBackground: "new"
    },
    points: " 415,340.9 484.5,260.8 498,588.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000035496569628299871350000018327012593570965939_",
    gradientUnits: "userSpaceOnUse",
    x1: -47.59,
    y1: -237.4266,
    x2: -46.5153,
    y2: -236.352,
    gradientTransform: "matrix(41 0 0 56 2427 13915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#393939"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686868"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11867_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000035496569628299871350000018327012593570965939_)",
      enableBackground: "new"
    },
    points: " 446.4,665.5 547.6,630.6 498,588.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000155850386054048844080000004530513126989941938_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.9821,
    y1: -237.8609,
    x2: -48.799,
    y2: -236.6777,
    gradientTransform: "matrix(73 0 0 46 4187 11505)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0B0B0B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11866_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000155850386054048844080000004530513126989941938_)",
      enableBackground: "new"
    },
    points: " 547.6,630.6 659.3,578.3 498,588.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000166653922047093592630000012133013440870955174_",
    gradientUnits: "userSpaceOnUse",
    x1: -57.3216,
    y1: -246.0622,
    x2: -47.7776,
    y2: -236.5182,
    gradientTransform: "matrix(82 0 0 38 4682 9539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11865_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000166653922047093592630000012133013440870955174_)",
      enableBackground: "new"
    },
    points: " 484.5,260.8 781.7,442.1 498,588.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000034787995804140105170000000238021756329208475_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.4748,
    y1: -238.5441,
    x2: -48.328,
    y2: -237.3972,
    gradientTransform: "matrix(82 0 0 40 4682 10050)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2C2C2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11864_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000034787995804140105170000000238021756329208475_)",
      enableBackground: "new"
    },
    points: " 659.3,578.3 781.7,442.1 498,588.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000092434977290395614710000007838876595465808786_",
    gradientUnits: "userSpaceOnUse",
    x1: -15.3126,
    y1: -207.3032,
    x2: -11.8227,
    y2: -203.8132,
    gradientTransform: "matrix(15 0 0 19 1144 5233)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F1F1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#545454"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11863_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000092434977290395614710000007838876595465808786_)",
      enableBackground: "new"
    },
    points: " 917.5,1290.2 935,1356.5 969.9,1328.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000025444025033177707240000011065829564926056120_",
    gradientUnits: "userSpaceOnUse",
    x1: -22.8096,
    y1: -183.8541,
    x2: -19.3197,
    y2: -180.3642,
    gradientTransform: "matrix(19 0 0 11 1364 3305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11862_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000025444025033177707240000011065829564926056120_)",
      enableBackground: "new"
    },
    points: " 917.5,1290.2 983.9,1290.2 969.9,1328.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000141422386478358042960000008427380248084164275_",
    gradientUnits: "userSpaceOnUse",
    x1: -13.0139,
    y1: -198.1806,
    x2: -9.524,
    y2: -194.6907,
    gradientTransform: "matrix(15 0 0 15 1159 4269)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#333333"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11861_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000141422386478358042960000008427380248084164275_)",
      enableBackground: "new"
    },
    points: " 969.9,1328.6 983.9,1290.2 1022.2,1342.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000128468025132723212640000018082872357412429478_",
    gradientUnits: "userSpaceOnUse",
    x1: -20.502,
    y1: -204.3759,
    x2: -17.0121,
    y2: -200.8859,
    gradientTransform: "matrix(19 0 0 17 1383 4749)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7C7C7C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11860_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000128468025132723212640000018082872357412429478_)",
      enableBackground: "new"
    },
    points: " 983.9,1290.2 1050.2,1283.2 1022.2,1342.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000041286480422885938200000007225036096737329808_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.1503,
    y1: -203.6962,
    x2: 15.6402,
    y2: -200.2063,
    gradientTransform: "matrix(10 0 0 17 899 4749)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11859_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000041286480422885938200000007225036096737329808_)",
      enableBackground: "new"
    },
    points: " 1050.2,1283.2 1057.1,1335.6 1022.2,1342.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000096748979306771858250000002273087840919473281_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.9405,
    y1: -220.8443,
    x2: 10.4304,
    y2: -217.3544,
    gradientTransform: "matrix(11 0 0 32 954 8379)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11858_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000096748979306771858250000002273087840919473281_)",
      enableBackground: "new"
    },
    points: " 1057.1,1335.6 1060.6,1447.2 1022.2,1342.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000026876805072967193840000001962199551443518376_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.2282,
    y1: -216.3611,
    x2: -4.7383,
    y2: -212.8711,
    gradientTransform: "matrix(13 0 0 28 1039 7421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11857_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000026876805072967193840000001962199551443518376_)",
      enableBackground: "new"
    },
    points: " 935,1356.5 949,1454.2 980.4,1412.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000120523464804108637940000003403991189103925125_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.6202,
    y1: -213.7312,
    x2: -4.1303,
    y2: -210.2414,
    gradientTransform: "matrix(13 0 0 24 1039 6449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5C5C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11856_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000120523464804108637940000003403991189103925125_)",
      enableBackground: "new"
    },
    points: " 935,1356.5 969.9,1328.6 980.4,1412.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000129913685754613221740000015244135541126182805_",
    gradientUnits: "userSpaceOnUse",
    x1: -36.2207,
    y1: -180.0967,
    x2: -32.7308,
    y2: -176.6068,
    gradientTransform: "matrix(32 0 0 12 2088 3581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11855_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000129913685754613221740000015244135541126182805_)",
      enableBackground: "new"
    },
    points: " 949,1454.2 1060.6,1447.2 980.4,1412.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000007404418873341371130000010512866219568827061_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.5767,
    y1: -213.38,
    x2: -9.0868,
    y2: -209.8901,
    gradientTransform: "matrix(15 0 0 24 1159 6449)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5C5C5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11854_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000007404418873341371130000010512866219568827061_)",
      enableBackground: "new"
    },
    points: " 969.9,1328.6 1022.2,1342.5 980.4,1412.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000163068469772165394810000005962611738978644395_",
    gradientUnits: "userSpaceOnUse",
    x1: -27.1536,
    y1: -218.4228,
    x2: -23.6637,
    y2: -214.933,
    gradientTransform: "matrix(23 0 0 30 1602 7899)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C2C2C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11853_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000163068469772165394810000005962611738978644395_)",
      enableBackground: "new"
    },
    points: " 1022.2,1342.5 1060.6,1447.2 980.4,1412.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000166636223591685416280000003922433888383184309_",
    gradientUnits: "userSpaceOnUse",
    x1: -35.4322,
    y1: -222.7913,
    x2: -31.9417,
    y2: -219.3009,
    gradientTransform: "matrix(38 0 0 23 2480 6102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11852_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000166636223591685416280000003922433888383184309_)",
      enableBackground: "new"
    },
    points: " 1165.3,1035.4 1165.3,958.6 1297.9,1038.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000067195171747985331380000004558514697023612049_",
    gradientUnits: "userSpaceOnUse",
    x1: -42.5832,
    y1: -224.057,
    x2: -39.0923,
    y2: -220.5661,
    gradientTransform: "matrix(61 0 0 24 3745 6343)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11851_",
    style: {
      opacity: 0.5,
      fill: "url(#triangle36_00000067195171747985331380000004558514697023612049_)",
      enableBackground: "new"
    },
    points: " 1165.3,958.6 1378.2,1042.4 1297.9,1038.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000077319597002736554320000005175234388129067189_",
    gradientUnits: "userSpaceOnUse",
    x1: -36.2543,
    y1: -213.3155,
    x2: -32.7621,
    y2: -209.8233,
    gradientTransform: "matrix(43 0 0 16 2755 4437)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11850_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000077319597002736554320000005175234388129067189_)",
      enableBackground: "new"
    },
    points: " 1165.3,1035.4 1315.4,1091.3 1297.9,1038.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "triangle36_00000093162291387809673330000006287091609649614753_",
    gradientUnits: "userSpaceOnUse",
    x1: -17.0469,
    y1: -210.6714,
    x2: -13.557,
    y2: -207.1814,
    gradientTransform: "matrix(23 0 0 15 1693 4197)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "triangle36_11849_",
    style: {
      opacity: 0.8,
      fill: "url(#triangle36_00000093162291387809673330000006287091609649614753_)",
      enableBackground: "new"
    },
    points: " 1315.4,1091.3 1378.2,1042.4 1297.9,1038.9  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1703.4,854.4l-50.5-404.3c2.4-1.8,4-4.7,4-8c0-5.5-4.5-10-10-10c-1.3,0-2.6,0.3-3.7,0.7l-3-2.4L1465,205.7 c0.1-0.3,0.1-0.6,0.1-0.9c0-1.8-1.4-3.2-3.2-3.2c-0.7,0-1.3,0.2-1.9,0.6L878,10.5c0-0.4,0.1-0.7,0.1-1.1c0-5.2-4.2-9.4-9.4-9.4 s-9.4,4.2-9.4,9.4c0,0.2,0,0.3,0,0.5L299.8,153.2c-0.8-1-2-1.6-3.4-1.6c-2.4,0-4.4,2-4.4,4.4c0,0.8,0.2,1.5,0.5,2.1L7.1,539.7 c-0.1,0-0.3,0-0.4,0c-2.1,0-3.7,1.7-3.7,3.7c0,1.6,1,3,2.4,3.5l15.2,91c-4.2,1.5-7.2,5.5-7.2,10.2c0,6,4.8,10.8,10.8,10.8 c0.6,0,1.2-0.1,1.8-0.2l29.5,82.6c-1.3,1.1-2.2,2.7-2.2,4.5c0,3.2,2.6,5.8,5.8,5.8c1.9,0,3.6-1,4.7-2.4l80.8,24.9 c0.2,2.8,2.4,5,5.3,5c0.1,0,0.2,0,0.3,0l86.4,26.6l-34.6,97c-3.9,0.1-7,3.2-7,7.1c0,3.9,3.1,7,7,7.1l13.8,38.6 c-0.7,0.9-1.2,2-1.2,3.2c0,2.5,1.9,4.6,4.4,4.9l16.6,38.6c-1.4,1.3-2.3,3.2-2.3,5.3c0,4,3.3,7.3,7.3,7.3c2.5,0,4.7-1.3,6.1-3.2 l6.3,1l166.4,67.8c-0.5,1.2-0.8,2.6-0.8,4c0,5.8,4.7,10.5,10.5,10.5s10.5-4.7,10.5-10.5c0-0.2,0-0.3,0-0.5l180.9-64.6 c1.1,0.9,2.5,1.5,4.1,1.5c1.2,0,2.3-0.3,3.2-0.9c4.4,7.4,8.8,14.9,13.2,22.6c1.4,2.4,2.6,4.8,4.1,7.2l4.6,7.4l9.1,14.8 c10.7,17.5,21.7,34.9,32.6,52.1c-1.3,1.5-2.1,3.5-2.1,5.6c0,4.8,3.9,8.6,8.6,8.6c0.8,0,1.5-0.1,2.2-0.3c1.2,4.5,2.3,9.2,3.3,13.8 l1.3,5.7c0.4,2,1.1,4.1,1.6,6.1l3.3,12.2c3.7,13.9,7.7,27.7,11.7,41.4c-2.1,1.4-3.5,3.9-3.5,6.6c0,4.4,3.6,8,8,8 c3,0,5.6-1.7,7-4.2c8.5,4.6,17.1,9.4,25.7,14.3c11.4,6.1,23.4,12.1,35,18.1l62.4,31.5c-0.1,0.7-0.2,1.3-0.2,2 c0,5.4,4.4,9.7,9.7,9.7c5.4,0,9.7-4.4,9.7-9.7c0-0.1,0-0.1,0-0.2c5.2-0.1,10.4-0.1,15.8-0.2h13.4c2.5,0,5.1,0,7.6-0.2 c1.1,2.2,3.3,3.7,5.9,3.7c0.4,0,0.9,0,1.3-0.1c0.6,2.9,1.1,5.9,1.6,8.9c0.6,5.1,2.3,11.3,3.5,17c2.1,9.1,4.4,18.2,6.7,27.2 c-2.2,1.4-3.8,3.9-3.8,6.8c0,4.4,3.6,8,8,8c0.3,0,0.5-0.1,0.8-0.1c0.5,4.8,0.9,9.8,1.2,14.8c0.1,3.8,0.9,8.2,1.3,12.3l1.5,12.6 c1.6,13.8,3.5,27.5,5.4,41.2c-3.5,1.5-5.9,4.9-5.9,8.9c0,5.3,4.3,9.6,9.6,9.6s9.6-4.3,9.6-9.6v-0.1c5.5-0.1,11.1-0.1,16.7-0.1 c4.4,0.2,9.4-0.3,14.1-0.5l14.3-0.7c16-0.8,31.9-1.7,47.8-2.6c1.3,3.9,4.9,6.7,9.2,6.7c5.4,0,9.7-4.4,9.7-9.7 c0-4.6-3.2-8.5-7.6-9.5l-1.7-47.5l-0.6-14.2c-0.2-4.7-0.2-9.6-0.8-14l-2-20.9c2.9-0.3,5.2-2.7,5.2-5.7c0-2.6-1.7-4.7-4-5.4 c-1-7.5-2.1-15-3.5-22.5l-1.2-6.9l-1.6-6.1c-0.6-2.2-1-4.4-1.5-6.6h112.7c1.7,2.9,4.8,4.9,8.5,4.9c3.9,0,7.3-2.3,8.9-5.7 l103.2-9.7v-0.2c1.2-0.1,2.2-0.6,3-1.4l0.2,0.1l115.2-122.1l-0.2-0.2c0.8-0.8,1.2-1.9,1.2-3.1c0-0.4-0.1-0.7-0.1-1.1l0.3-0.2 l-12.8-47.9c0.5-1,0.8-2,0.8-3.2c0-2.1-1-4-2.5-5.2l-5.7-45.4l143.7,6.5c1.1,1,2.6,1.6,4.2,1.6c3.4,0,6.2-2.7,6.3-6.1l160.9-181 c0.1,0,0.2,0,0.2,0c4.3,0,7.7-3.5,7.7-7.7C1707,858.2,1705.6,855.8,1703.4,854.4z M1644.7,464.4l44.4,355.1l-37.9-101.9 l-45.6-122.8c1.3-1.7,2.2-3.8,2.2-6.1c0-2.4-0.9-4.6-2.4-6.3L1644.7,464.4z M1639.5,448.8l-42.8,128.3l-199.8-326.7l240.2,190.3 c-0.1,0.5-0.2,1-0.2,1.5C1636.9,444.7,1637.9,447,1639.5,448.8z M1317.9,1083.1l-13-38.9l59.7,2.6L1317.9,1083.1z M1374.4,1051.6 l5.1,41.1l-25-2.5l-26.4-2.6l31.6-24.5L1374.4,1051.6z M942.5,1353.7l24.3-19.5c0.4,0.2,0.9,0.4,1.4,0.6l8.6,68.5 c-0.2,0.1-0.3,0.1-0.5,0.2l-16.2-19.8c-1.8-2.2-3.8-4.5-5.6-6.7c-1.9-2.2-4.2-4.4-6.4-6.7l-7.6-8c1.5-1.5,2.5-3.5,2.5-5.8 C943,1355.5,942.8,1354.5,942.5,1353.7z M702.6,1122.6l19.4-58.2l40,126.2l-27.3-27.2c-5.5-5.9-12-11.2-18.2-16.8l-12.5-11.2 c1.4-1.5,2.2-3.5,2.2-5.7C706.3,1126.7,704.9,1124.2,702.6,1122.6z M301.6,757.1c0.6,0.1,1.1,0.2,1.7,0.2c0.5,0,1-0.1,1.5-0.2 l3.3,6l10.1,18.6c-1.3,1.3-2.1,3-2.3,4.8l-33,5.5l-29,4.8L301.6,757.1z M244.4,791.9l-1.6-14l-0.5-4.3l38.5-12.2L244.4,791.9z  M34.1,643.9l54.2-34.2l89.3-56.3L71.1,701.9c-0.5-0.2-1.1-0.3-1.6-0.3c-0.6,0-1.2,0.1-1.8,0.3l-4.1-5.3L32,655.3 c1.8-1.9,2.9-4.5,2.9-7.3C34.9,646.6,34.6,645.2,34.1,643.9z M940,1051.1l-0.7-6.4l-1.2-10.4c1.1-0.6,2-1.5,2.6-2.6l184.2,5.6 l-178.2,19.2C945.6,1053.7,943.1,1051.6,940,1051.1z M982.8,1081c3.6,1.7,7.3,3.6,10.9,5.2l10.7,4.8l21.5,9.6l33.1,14.7 c14.7,6.6,29.3,13.1,44,19.5l-160.9,12.9c-0.3-0.4-0.7-0.8-1.2-1.1v-78.4c2.5-0.7,4.5-2.4,5.5-4.7L982.8,1081z M421.6,336.2 l60.6-69.9c0.2,0.1,0.5,0.2,0.7,0.2l12.6,307.6c-0.2,0-0.3,0-0.5,0.1l-75.8-226.3c2.3-1.4,3.8-4,3.8-6.9 C423.1,339.2,422.5,337.5,421.6,336.2z M815.3,620l123.6-32.4c0.9,0.5,2,0.8,3.1,0.8h0.1l100.2,88.4L815.3,620z M1020.1,681.4 l-171.5-11l-105.1-6.7l53-38.2L1020.1,681.4z M954.8,586.5l78.8,13.6c0.4,4.8,4.3,8.5,9.1,8.8l13.5,67L954.8,586.5z M953,581.1 l24.2-6.9l33.9-9.7c1,1.1,2.5,1.8,4.1,1.8c0.3,0,0.6,0,0.9-0.1l19.5,26.8c-0.5,0.6-1,1.3-1.3,2.1L953,581.1z M1039.7,590.2 l-7.3-10l-12.2-16.8c0.4-0.8,0.7-1.6,0.7-2.6c0-0.2,0-0.4-0.1-0.6l282.8-181.8l-254.8,212.8c-1.6-1.1-3.5-1.8-5.6-1.8 C1041.9,589.5,1040.8,589.7,1039.7,590.2z M1020.3,545.3l-5,9.9l0,0c-1.9,0-3.5,0.9-4.5,2.3l-75.6-12.1c-0.1-0.5-0.2-0.9-0.4-1.4 L1091,403.9L1020.3,545.3z M1003.9,561.5L963,573.2l-15.8,4.5c-0.6-0.8-1.4-1.5-2.4-1.9l-10.1-25.3L1003.9,561.5z M935.3,578.4 l-21.7,5.7l-81.3,21.3l93.2-51.5L935.3,578.4z M921,545.1l-121.2,67l-12.5-163L921,544.9C921,545,921,545,921,545.1z  M789.9,613.3l-121.8-37.5L777.7,454L789.9,613.3z M573.2,624.1l60.1-28.2l21.1-9.9v29.1c-1.7,1-3,2.4-3.9,4.1L573.2,624.1z  M648.6,629.2l-43.8,36c-1.4-0.9-3.1-1.5-4.9-1.5c-1.8,0-3.6,0.6-5,1.6L557,635L648.6,629.2z M548.4,624.8L512,594.1 c0.2-0.4,0.3-0.9,0.4-1.3l121.2-7.9L548.4,624.8z M515.1,582.7l249.6-129L657,573.5L515.1,582.7z M664.2,591.8l17.3,20.5 l29.5,35.1l-41.8-23.9c0-3.6-2-6.8-4.9-8.5L664.2,591.8L664.2,591.8z M775.4,441.7l-1.5,1.6l-264,136.6 c-2.5-3.3-6.3-5.6-10.7-5.9l-12.6-307.6c0.7-0.2,1.3-0.6,1.8-1.1l287.2,175.3C775.5,441,775.5,441.4,775.4,441.7z M491.5,575.3 c-1.8,0.9-3.4,2.1-4.7,3.6l-99.5-68.2l-160-109.8l100-30.9l80.8-25c1.4,2.4,4,4,7,4c0.3,0,0.5-0.1,0.7-0.1L491.5,575.3z  M494.2,603.3c1.2,0.3,2.5,0.5,3.8,0.5c2.8,0,5.4-0.8,7.6-2.1l32.2,27.1L458.7,656L494.2,603.3z M379.7,665.9l101.8-61.4l-3.4,5 l-31.2,46.4c-0.2,0-0.3,0-0.5,0c-3.8,0-7,2.2-8.6,5.3L379.7,665.9z M420.1,672.6l-44.7,21.3l-8.1-16.1c0.2-0.3,0.4-0.7,0.5-1 L420.1,672.6z M363.7,664c-1.4-0.7-2.9-1.2-4.6-1.2c-2.3,0-4.5,0.9-6.2,2.3L194.1,550.6L483,589.3c0,0.9,0.1,1.7,0.3,2.6 L363.7,664z M358.3,682.1c0.1,0,0.1,0,0.2,0l7.9,15.8l0.4,0.8l-42.1,29.5L358.3,682.1z M362.9,713.6L346,743.7l-20,35.6 c-0.6-0.1-1.2-0.2-1.8-0.2c-0.6,0-1.2,0.1-1.7,0.2l-6.4-11.7l-7-12.9c1.3-1.3,2.1-3.1,2.2-5.1L362.9,713.6z M372.2,707l1.9-1.4 c1.2-0.2,2.2-0.9,3-1.8l4.2-2L484,690.1l-153.2,90.6L372.2,707z M475.7,686.2l-80.6,9.2l46-21.9c1.5,1,3.4,1.6,5.3,1.6 c3.1,0,5.8-1.5,7.5-3.7l31.4,13.5c0,0.1,0,0.1,0,0.2L475.7,686.2z M456.6,667.2l78.7-27.2L500,677.6c-1.4-0.8-3.1-1.3-4.8-1.3 c-3.2,0-6.1,1.6-7.9,4L456.6,667.2z M545.4,636.6l3.2-1.1l1.1-0.1l42.2,33.8c-0.2,0.6-0.4,1.3-0.5,1.9l-86.8,11.6 c-0.2-0.6-0.5-1.1-0.9-1.7L545.4,636.6z M592,676c1.4,3,4.4,5.1,7.9,5.1c2.4,0,4.6-1,6.2-2.6l84.1,44.8l-33.8-6.8l-146.2-29.6 L592,676z M608,669.1l45.5-37.5c1.6,1.2,3.6,1.9,5.8,1.9c1.8,0,3.5-0.5,4.9-1.4l55.3,31.6l-111.4,5.9 C608.1,669.4,608,669.2,608,669.1z M673.8,587.9l94.7,29.1l15.9,4.9l-51.1,36.9L673.8,587.9z M737.2,668.3l168.9,10.8l124.4,8 l-316.8,38.1c-0.5-1-1.2-1.8-2-2.5l21.4-51.8C734.8,670.7,736.3,669.7,737.2,668.3z M714.4,731.3l337.7-40.6l0,0l-284.9,280 l-56.1-234.6C712.8,734.9,713.9,733.3,714.4,731.3z M818.4,996.1l89.8,27.4L739,1011.8l12.9-14.8l14.6-16.8L818.4,996.1z  M751.4,988.1l-20.3,23.3h-83.3l36.4-9.7l72.3-19.4L751.4,988.1z M734.3,1017.7l2,0.1L914,1057l-186.3-3c-0.4-1-1.1-1.8-1.9-2.4 L734.3,1017.7z M788.3,1024.2l-18.7-4.1l159.2,11c0.8,1.8,2.4,3.2,4.3,3.7l1.4,12.5l0.5,4.4c-1.9,0.8-3.4,2.2-4.4,4L788.3,1024.2 z M934.1,1021.9c-1.5,0.2-2.8,0.9-3.8,1.9l-158.9-48.5l281.8-276.9L934.1,1021.9z M953.9,1025.9l116.6-35.3l89.9-27.3 c0.5,0.5,1.1,0.9,1.8,1.3v67.6L953.9,1025.9z M1158.7,957.4l-171.4,52l-47.2,14.3l119.8-325.8l99.2,258.2 C1158.9,956.5,1158.8,957,1158.7,957.4z M1061.3,677l-13.9-69.1c3.2-1.6,5.5-4.9,5.5-8.7c0-1.5-0.4-2.9-0.9-4.1l254-212.3 L1062.1,677C1061.9,677,1061.6,677,1061.3,677z M1021.5,553.9l75.5-150.8c0.7,0.1,1.4,0.2,2.1,0.2c5.1,0,9.3-3.9,9.8-9l215.4-35 L1021.5,553.9z M1109.9,389.1l42.9-25.2l217.9-128.1l-39.6,116.8l-0.6,0.8L1109.9,389.1z M1379.5,240.8l197,322.1l-70.4-62.6 l-164.9-146.8L1379.5,240.8z M1106.4,386.9c-1.5-1.8-3.7-2.9-6.1-3.3l-10.2-182.9c3.1-0.8,5.5-3.1,6.5-6l251.7,32.6l22.7,2.9 c0,0.4,0.1,0.7,0.2,1L1106.4,386.9z M1096.6,383.8c-0.9,0.2-1.7,0.6-2.4,1L948.9,212.9c1.2-1.5,2-3.3,2.2-5.4l48.5-5l79.3-8.1 c1.1,3.4,4,6,7.6,6.5L1096.6,383.8z M1091.4,387.2c-1.4,1.7-2.2,3.8-2.2,6.2c0,1.6,0.4,3.2,1.1,4.5L931.4,540.4 c-0.4-0.2-0.9-0.4-1.3-0.5l12.5-323.5c1.2-0.2,2.4-0.6,3.4-1.2L1091.4,387.2z M926.4,539.7c-0.9,0.2-1.8,0.6-2.6,1.1l-136-97.3 c0.1-0.4,0.2-0.9,0.2-1.4c0-1.5-0.5-2.9-1.4-3.9l33.8-49.9l116.8-172.5c0.5,0.2,1.1,0.4,1.7,0.5L926.4,539.7z M783.5,436.1 c-0.6-0.2-1.2-0.3-1.8-0.3c-1.6,0-3.1,0.6-4.2,1.6L490.4,262.1c0-0.1,0-0.1,0.1-0.2l441.4-52.3c0.5,1.5,1.3,2.9,2.4,4.1 L783.5,436.1z M488.8,256.5c-1.1-1.1-2.6-1.7-4.2-1.7s-3,0.6-4.1,1.6l-69.1-38.3l-54.1-30L850.7,70.6L488.8,256.5z M478.7,259.6 c-0.1,0.4-0.1,0.8-0.1,1.1c0,1.1,0.3,2.2,0.9,3.1l-60.7,70c-1.1-0.6-2.4-1-3.7-1c-0.4,0-0.8,0.1-1.3,0.1l-57.9-141.4L478.7,259.6 z M410.3,334.4c-2.1,1.5-3.4,3.9-3.4,6.6c0,0.2,0,0.4,0.1,0.5l-6.5,2L227.2,397l124.6-205.4h0.1L410.3,334.4z M484.7,582 c-0.4,0.8-0.8,1.6-1,2.5l-290.5-38.9c-0.4-2.8-2.2-5.1-4.6-6.4l35.5-135.7c0.1,0,0.2,0,0.2-0.1L484.7,582z M185,538.2 c-0.1,0-0.2,0-0.3,0c-4.4,0-7.9,3.2-8.6,7.4l-135.8,9.5V555l26.1-21.8l153.4-127.8L185,538.2z M174.1,564.8l7.2-10 c0.9,0.4,1.9,0.6,2.9,0.7l25.1,106.7c-0.7,0.7-1.2,1.7-1.3,2.8L81.6,702l-7.4,2.2l0,0L174.1,564.8z M189,554.3 c0.3-0.2,0.7-0.4,1-0.7L350.1,669c-0.1,0.2-0.1,0.4-0.2,0.6l-132.5-6.3l-1.5-1.4l-0.2,0.1c-0.5-0.4-1-0.7-1.6-0.9L189,554.3z  M349.7,674.5c0.1,0.6,0.3,1.3,0.6,1.8l-47.2,64.9c-0.3,0-0.7,0-1,0.1l-78.9-72.9L349.7,674.5z M322.2,795.8 c0.4,0.1,0.9,0.2,1.4,0.2l29.6,140.2c-5.8,2.2-10.1,7.5-10.7,13.9L224.1,956L322.2,795.8z M336.6,834.1l-8.2-39.1 c2.6-1.4,4.4-4.2,4.4-7.4c0-0.7-0.1-1.4-0.3-2l24.4-14.4l131.3-77.7c0.2,0.2,0.3,0.3,0.5,0.4L364.2,936c-1.7-0.6-3.4-0.9-5.3-0.9 c-0.3,0-0.6,0-1,0L336.6,834.1z M493,696.2c0.7,0.2,1.5,0.3,2.2,0.3c4,0,7.4-2.3,9-5.7l41.9,8.5L698,730c0,0.3,0,0.5,0.1,0.8 L371,940.4c-0.7-0.8-1.5-1.5-2.4-2.1L493,696.2z M609,674.5l118.5-6.2l0.8,0.5c0.1,0.1,0.1,0.2,0.2,0.3L707.1,721 c-0.3,0-0.5-0.1-0.8-0.1c-2.3,0-4.4,0.9-5.9,2.5L609,674.5z M761.8,974.5l-11.7,3.1l-121.2,32.5L706,741.3L761.8,974.5z  M729.3,1017.6l-8.2,32.8c-1.2,0.2-2.3,0.8-3.1,1.5l-80.1-34.3L729.3,1017.6L729.3,1017.6z M726.1,1060.9c0.6-0.6,1.1-1.2,1.5-2 l202.3,3.3c0.1,0.4,0.2,0.8,0.4,1.2l-161.6,131.9L726.1,1060.9z M933.4,1067.2c0.8,0.5,1.7,0.9,2.6,1.2v78.4 c-0.9,0.6-1.6,1.5-1.9,2.5c-16.8,4.8-33.4,9.6-50.1,14.5l-32.8,9.5c-14.4,4.3-29.1,8.4-42.6,13.1l-34.7,11.1L933.4,1067.2z  M940,1157.2l59.8,88.2c-0.5,0.9-0.8,1.8-0.8,2.9l0,0l-77.1,37c-0.3-0.3-0.7-0.6-1.1-0.8L940,1157.2z M974.2,1323.9l10.4-28.5 l31.5,43l-6.9-1.8c-2.9-0.7-5.9-1.5-8.8-2.2l-2.8-0.7l-6.3-1.6l-7-1.1l-8.1-1.4c0.1-0.3,0.1-0.7,0.1-1.1 C976.3,1326.7,975.5,1325,974.2,1323.9z M983.6,1285.1c-1.8,0.1-3.4,1.1-4.3,2.6h-51l71-34.1L983.6,1285.1z M923.6,1292.7h55.7 c0.2,0.3,0.4,0.6,0.6,0.9l-10.4,28.6c-1.1,0.1-2.1,0.4-3,0.9c-7.5-5.5-15.1-10.9-22.8-16.2l-7-4.8c-2.3-1.6-4.5-2.7-6.7-4.1 c-2.4-1.4-4.7-2.9-7-4.3C923.3,1293.4,923.5,1293,923.6,1292.7z M973.1,1334.1c1.3-0.7,2.3-1.9,2.8-3.2l5.8,2.2l6.1,2.4l6.8,1.9 l8.3,2.3c2.1,0.6,4.2,1.2,6.3,1.8l8.3,2.3c0.1,0.4,0.3,0.8,0.5,1.2l-34.8,58c-0.5-0.1-0.9-0.2-1.4-0.3L973.1,1334.1z  M988.5,1292.3c0-0.1,0.1-0.1,0.1-0.2l57.5-6.1l-24.2,51.4c-0.1,0-0.1,0-0.2,0L988.5,1292.3z M988.1,1287.3l16.6-33.2h0.1 c0.9,0,1.8-0.2,2.6-0.7l24.7,19l11.6,9L988.1,1287.3z M1006.6,1242.9c-0.6-0.2-1.2-0.3-1.8-0.3c-0.3,0-0.6,0-0.9,0.1l-61-89.9 l163.7-13.1L1006.6,1242.9z M1064.1,1112.6l-38.6-16.8l-22.1-9.5l-11.1-4.8c-3.7-1.6-7.3-2.9-10.9-4.4l-34.7-13.9 c0.2-0.6,0.4-1.2,0.5-1.8l213.7-23h0.1l-7.5,14.6l-41.2,79.6c-0.5,0.1-1,0.3-1.4,0.5C1095.3,1126.2,1079.7,1119.4,1064.1,1112.6z  M1165.4,1040.7l136.9,51l-184.7,41.4L1165.4,1040.7z M1194.8,1041.1l99.5,2.6l13.1,39.3L1194.8,1041.1z M1308.3,1095.4 c0.5,0.9,1.2,1.7,2,2.3l-3.1,97.7l-184.6-58.3L1308.3,1095.4z M1298.2,1034L1298.2,1034L1298.2,1034l-2.5-0.1l-88.2-53.4 l141.5,55.7L1298.2,1034z M1264,1022l19.2,11.6l-114.8-3v-65.4l4.9,1.9L1264,1022z M1167.4,950.4l-99.1-258 c0.6-0.8,1.1-1.6,1.4-2.5l511.3-93.1L1167.4,950.4z M1073.2,679.2L1336.1,362l204.6,182.2l46.5,41.4L1073.2,679.2z M1462,208 L1462,208l166,212.8L1385.8,229l74.2-21.6C1460.6,207.8,1461.2,208,1462,208z M1455.7,204.7l-71.3,20.8c-1.3-2.1-3.6-3.6-6.2-3.6 c-2.3,0-4.4,1.1-5.7,2.8l-465-200.6L1455.7,204.7z M1358.2,224.8L1097.1,191c-0.3-4.9-4.4-8.7-9.3-8.7c-2.8,0-5.3,1.3-7.1,3.3 L891.6,78.1l-10-5.7L1358.2,224.8z M872.4,71.4l206.5,117.3c-0.2,0.6-0.3,1.3-0.4,2l-98.3,10.1l-29.5,3c-1.2-4.1-5-7.1-9.5-7.1 c-1,0-2,0.2-3,0.5l-67-124.7C871.6,72.2,872,71.8,872.4,71.4z M911,154.3l24,44.6c-2.1,1.7-3.4,4.2-3.6,7l-436.8,51.8L857.8,71.1 c1.7,2.2,4.4,3.6,7.4,3.6c1,0,1.9-0.2,2.8-0.5L911,154.3z M860.6,14.1c1.2,2.1,3.2,3.7,5.7,4.3L864,55.8 c-4.6,0.6-8.2,4.6-8.2,9.4c0,0.1,0,0.2,0,0.4L388.5,176.8L860.6,14.1z M825,22.5L736.3,53L355.2,184.4c-0.8-0.8-1.8-1.3-3-1.3 c-0.9,0-1.7,0.3-2.4,0.8l-48.5-27.3L825,22.5z M297,160.3c0.7-0.1,1.4-0.4,2-0.8l49,27.6c0,0.1,0,0.2,0,0.3 c0,0.9,0.3,1.7,0.7,2.3L229,386.9l61-203.2L297,160.3z M291.6,165.4L222.1,397c-1.4,0.4-2.4,1.7-2.4,3.2l0,0L14.5,535.9 L291.6,165.4z M196.2,420.3l-91.3,76.1L38,552.1c-1-0.6-2.1-1-3.3-1c-1.7,0-3.3,0.7-4.4,1.9l-17.4-8.7l-2.4-1.2l0,0L196.2,420.3z  M23.8,634.8L9.1,546.6l19.4,9.7c0,0.3-0.1,0.6-0.1,1c0,2.5,1.5,4.7,3.6,5.6L23.8,634.8z M35.8,563.4c2.4-0.5,4.2-2.3,4.8-4.6 l51.9-3.6l83.9-5.9c0,0.2,0.1,0.3,0.2,0.5l-144.4,91c-1.3-1.5-3-2.6-4.9-3.1L35.8,563.4z M58.8,739.6l-28.9-81l9.5,12.4 l25.4,33.2c-0.6,0.9-1,2-1,3.2c0,2,1,3.7,2.5,4.7L58.8,739.6z M64.8,745.6c-0.1-1.9-1-3.6-2.5-4.6l7.6-27.9 c1-0.1,1.8-0.3,2.6-0.8l68.9,56.9L64.8,745.6z M150,768.4c-0.1,0-0.1,0-0.2,0c-1,0-1.8,0.3-2.6,0.7l-72.3-59.7 c0.2-0.5,0.3-1.1,0.4-1.7l132.6-38.8L150,768.4z M209.8,675.2l21.1,90.3l-75.2,3L209.8,675.2z M178.8,777.5l53.8-2.2l2.2,19.4 L178.8,777.5z M221,680l72.7,67.1l-53.1,16.8L221,680z M241.6,805.8c0.5-0.1,1-0.4,1.4-0.7l0.6,0.2l2.7-2.3l32.2-5.4l38.1-6.4 c0,0.1,0.1,0.1,0.1,0.2L208.1,900.3L241.6,805.8z M206.7,915.2c1.5-1.3,2.5-3.2,2.5-5.4c0-1.1-0.2-2-0.7-2.9l3.8-3.8l98.9-98.9 l-91,148.8L206.7,915.2z M245.1,1001.9c-1.3-1-2.9-1.7-4.6-1.7c-0.1,0-0.3,0-0.4,0l-16.6-38.6c0.2-0.2,0.3-0.5,0.4-0.7l118.6-5.9 c0.1,0.3,0.1,0.6,0.2,0.9L245.1,1001.9z M251,1006l94.5-44.5c3,4.2,7.9,6.9,13.4,6.9c2.6,0,5.1-0.6,7.4-1.7l48.7,64.6L251,1006z  M437.4,1078c-1.6-2.2-4-3.7-6.8-4.1l-4.9-34.5c0.4-0.4,0.8-0.9,1.1-1.4l172.5-17.8L437.4,1078z M426.1,1031.9 c-1-1.2-2.5-1.9-4.1-1.9c-0.1,0-0.2,0-0.2,0l-50.6-67.1c1.2-1.3,2.2-2.8,2.9-4.4l231.9,54.8L426.1,1031.9z M622.9,1008.4 c-1.2,0.3-2.3,0.9-3.1,1.8l-144.5-34.1l-99.8-23.6c0-0.2,0-0.5,0-0.7c0-2.2-0.4-4.3-1.2-6.2l326.8-209.4l-46.8,163.1 L622.9,1008.4z M698,1121c-0.1,0-0.2,0-0.3,0c-0.8,0-1.6,0.2-2.4,0.4c-10.5-16.5-21.1-32.9-31.8-49.1l-9.2-14l-4.6-7 c-1.5-2.3-3.3-4.8-5-7.2c-5.7-8-11.2-16.1-16.8-24.5c0.3-0.2,0.6-0.4,0.8-0.7l87.3,37.4c0,1.8,0.8,3.3,2,4.4L698,1121z  M730.9,1217.9c-1.4-1.2-3.1-2-5.1-2c-3.8-12.8-7.7-25.5-11.9-38.2l-3.7-11.4c-0.6-1.9-1.1-3.7-1.9-5.7l-2.2-6 c-2-5.5-3.9-11.1-5.8-16.8c1.1-0.4,2.2-1,3-1.7l10.3,11.6c5.5,6,10.6,12.3,16.7,18.1l33,33.1c-0.6,0.3-1.1,0.7-1.7,1 L730.9,1217.9z M797.5,1257.4c-11.6-5.6-22.8-11.3-34.8-16.8c-9.9-4.4-19.8-8.9-29.9-13.5c0.5-1,0.7-2.1,0.7-3.3 c0-0.6-0.1-1.1-0.2-1.7l31.3-18.2c0.7-0.4,1.5-0.8,2.2-1.2c0.2,0,0.4,0,0.5,0.1l84.6,81.5 C833.8,1275.3,815.7,1266.3,797.5,1257.4z M865.2,1284c-1.8,0-3.6,0.5-5,1.4l-89-85.8l2-1.6l38.7-9.9 c14.9-3.5,28.7-7.5,42.9-11.4l25.4-7.2c17.9-4.9,35.7-10,53.5-15.1l-66.4,129.7C866.6,1284,865.9,1284,865.2,1284z M916,1283.8 c-2.2,0.5-4,2.2-4.7,4.3c-2.1,0.2-4.3,0.4-6.5,0.8l-12.8,1.7c-5.6,0.7-11.4,1.4-17.2,2.1c-0.3-2.5-1.4-4.6-3.2-6.2l62.1-121.3 L916,1283.8z M935.4,1348.5c-2.2-8.1-4.4-16.2-6.8-24.3c-1.7-5.4-2.9-10.3-5.2-16.2c-1.4-3.8-2.6-7.6-3.9-11.6 c1.2-0.4,2.3-1.1,3.1-2.1c2,1.7,4.1,3.5,6.2,5.3c3.5,3.4,8.2,7,12.6,10.4c7.3,5.8,14.8,11.4,22.3,16.9c-0.1,0.5-0.2,1-0.2,1.5 c0,0.6,0.1,1.2,0.3,1.8l-24.3,19.4C938.3,1349,936.9,1348.6,935.4,1348.5z M952.5,1445.3c-0.8-0.3-1.6-0.5-2.5-0.6 c-1.9-12.8-3.8-25.5-5.9-38.2l-2-11.8c-0.7-4-1.2-7.7-2.2-12.1c-1.3-6-2.4-12.1-3.5-18.2c1.1-0.2,2.2-0.6,3.1-1.2l5,7.4 c1.7,2.4,3.1,4.9,5,7.3c2,2.4,3.8,4.8,5.8,7.2l17.2,21.4c-1.2,1.6-1.9,3.6-1.9,5.8c0,2.3,0.8,4.4,2.2,6.1L952.5,1445.3z  M1006,1448.6l-13.6,1.1c-4.6,0.4-8.9,0.5-13.9,1.3c-6.6,0.8-13.3,1.6-20,2.3c-0.2-1.9-0.9-3.5-2-4.9l20.2-26.9 c1.1,0.5,2.4,0.7,3.7,0.7c3.1,0,5.9-1.5,7.7-3.8l62.3,27.1C1035.5,1446.4,1020.8,1447.4,1006,1448.6z M1053,1441.2l-63-27.4 c0.1-0.5,0.2-1,0.2-1.5c0-2.7-1.1-5.1-2.8-6.8l34.3-57.2l33.4,91C1054.3,1439.8,1053.6,1440.5,1053,1441.2z M1057,1341.3 l-0.6,23.6c-0.3,4.9,0,9.3,0,13.9l0.3,13.7l1.1,39.7l-31.7-86.5c0.4-0.5,0.7-1,0.9-1.6l25.6-5.1 C1053.6,1340.3,1055.2,1341.2,1057,1341.3z M1051.2,1297.9l0.2,7l0.6,6.2c0.6,6.6,1.3,13.1,2.2,19.6c-1.2,0.8-2.1,2-2.4,3.4 l-25.1,5l24-51C1050.8,1291.4,1051,1294.7,1051.2,1297.9z M1049.6,1278.3l-0.7,0.2l0.1,0.7l0,0l-38.5-29.6 c0.1-0.4,0.1-0.8,0.1-1.2c0-0.7-0.1-1.4-0.4-2l5.2-5.4l90-92.9L1049.6,1278.3z M1080.7,1218.3l32.5-75.9l52.9,102.6 c-1.1,1.1-2,2.4-2.5,3.9l-107.9,27.8L1080.7,1218.3z M1167.4,1274.8c-1.5,0.9-2.7,2.1-3.5,3.5h-74.7l76.8-19.8 c0.4,0.4,0.9,0.8,1.4,1.1L1167.4,1274.8L1167.4,1274.8z M1170.4,1242.8l-52.5-102l182.6,57.7l-122.7,46c-1.5-1.2-3.5-1.9-5.5-1.9 C1171.7,1242.6,1171,1242.6,1170.4,1242.8z M1180.3,1277.5c-0.8-1.1-1.8-2-3-2.8v-15.2c0.7-0.4,1.3-0.9,1.8-1.5l69.5,13 L1180.3,1277.5z M1280.8,1267.1l-90.2-16.9l112.8-42.3l-6.8,17.8L1280.8,1267.1z M1297.4,1251.3l12.9-33.9l5.5-14.5l57.6-32.3 L1297.4,1251.3z M1317.1,1190.9l2.9-90.3l65.4,46.3l4.5,3.2L1317.1,1190.9z M1390.9,1138.7l-0.7-0.5l-56.6-40.1l20,2l26.6,2.7 c0.4,0.5,1,1,1.5,1.3L1390.9,1138.7z M1376.2,1035.2c-0.5,0.1-1,0.3-1.4,0.6l-200-78.7l408.6-349.3L1376.2,1035.2z  M1530.7,1043.1c-1,0.2-1.9,0.6-2.7,1.2l-132.4-6l280.3-158.4L1530.7,1043.1z M1691.7,859.5l-302.1,170.8l207.9-429.1l95.1,255.9 C1692.2,857.9,1691.9,858.7,1691.7,859.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.f8a585263b0567cc2983f821ae091b7a.svg";
export { ForwardRef as ReactComponent };